webpackJsonp([1],{

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FANTASY_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var FANTASY_ACTION_TYPES = exports.FANTASY_ACTION_TYPES = (0, _object.namespacedConsts)({
  TOURNAMENT: {
    LOAD_MORE: true,
    GET_TOURNAMENTS_FEED: true,
    SELECT_TOURNAMENT: true
  }
});

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scheduleActions = exports.API_ENDPOINT_NAME = exports.SCHEDULE_ACTION_TYPES = undefined;
exports.changeNumVisbileItems = changeNumVisbileItems;
exports.fetchData = fetchData;
exports.changeLeague = changeLeague;
exports.changeScheduleDate = changeScheduleDate;

var _fn = __webpack_require__(15);

var _object = __webpack_require__(12);

var _api = __webpack_require__(123);

var _pageDataObject = __webpack_require__(5);

var _fetchSaga = __webpack_require__(56);

var SCHEDULE_ACTION_TYPES = exports.SCHEDULE_ACTION_TYPES = (0, _object.namespacedConsts)({
  CHANGE_LEAGUE: true,
  CHANGE_SCHEDULE_DATE: true,
  CHANGE_NUM_VISIBLE_ITEMS: true
}); /* eslint semi:0 */
/* eslint-disable camelcase */
var API_ENDPOINT_NAME = exports.API_ENDPOINT_NAME = 'MATCHES';

function changeNumVisbileItems(numItems) {
  return function (dispatch, getState) {
    return dispatch({
      type: SCHEDULE_ACTION_TYPES.CHANGE_NUM_VISIBLE_ITEMS,
      state: {
        numItems: numItems
      }
    });
  };
}

function fetchData(dataTransformer) {
  var _memoizeFirstCall = (0, _fn.memoizeFirstCall)('matchesEndpoint', _api.getApiEndpoints, API_ENDPOINT_NAME),
      _memoizeFirstCall$mat = _memoizeFirstCall.matchesEndpoint,
      url = _memoizeFirstCall$mat.url,
      endpointName = _memoizeFirstCall$mat.endpointName;

  return function (dispatch, getState) {
    return dispatch({
      type: _fetchSaga.FETCH_REQUEST_ACTION_TYPE,
      payload: {
        url: url,
        endpointName: endpointName,
        dataTransformer: dataTransformer,
        additionalState: {
          IS_INITIALIZED: true
        }
      }
    });
  };
}

function changeLeague(leagueName) {
  var leagueId = (0, _pageDataObject.getLeaguesForFixtures)().find(function (league) {
    return league.name === leagueName;
  }).id;
  return function (dispatch, getState) {
    return dispatch({
      type: SCHEDULE_ACTION_TYPES.CHANGE_LEAGUE,
      state: {
        leagueId: leagueId,
        leagueName: leagueName,
        leagueChanged: true
      }
    });
  };
}

function changeScheduleDate(newDate) {
  return function (dispatch, getState) {
    return dispatch({
      type: SCHEDULE_ACTION_TYPES.CHANGE_SCHEDULE_DATE,
      state: {
        scheduleDate: newDate
      }
    });
  };
}

var scheduleActions = exports.scheduleActions = {
  fetchData: fetchData, changeLeague: changeLeague, changeScheduleDate: changeScheduleDate, changeNumVisbileItems: changeNumVisbileItems
};

/***/ }),

/***/ 1114:
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FACEBOOK_BOT_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var FACEBOOK_BOT_ACTION_TYPES = exports.FACEBOOK_BOT_ACTION_TYPES = (0, _object.namespacedConsts)({
  GO_TO_MESSENGER_BOT: true
});

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformMatchResponse = transformMatchResponse;
var TEAM_SIDES = {
  HOME: 'home',
  AWAY: 'away'
};
var MATCH_STATUSES = exports.MATCH_STATUSES = {
  FINISHED: 'finished',
  UPCOMING: 'upcoming'
};
var API_STATUSES = {
  FINISHED: 'finished'
};
function getTeamData(matchInput, teamSide) {
  var teamName = matchInput[teamSide + '_nick'];
  var teamLogo = matchInput[teamSide + '_logo'];
  return {
    name: teamName,
    image: teamLogo
  };
}
function getMatchDate(matchData) {
  var epochTime = matchData.start_time;

  return new Date(1000 * epochTime);
}
function getMatchStatus(matchData) {
  return matchData.status === API_STATUSES.FINISHED ? MATCH_STATUSES.FINISHED : MATCH_STATUSES.UPCOMING;
}
function getMatchResult(matchData) {
  var score = matchData.match_score;
  var home = score.home_team,
      away = score.away_team;

  return {
    home: home,
    away: away
  };
}
function transformMatchResponse(serverMatch) {
  var clientMatch = {
    homeTeam: getTeamData(serverMatch, TEAM_SIDES.HOME),
    awayTeam: getTeamData(serverMatch, TEAM_SIDES.AWAY),
    result: getMatchResult(serverMatch),
    date: getMatchDate(serverMatch),
    status: getMatchStatus(serverMatch)
  };
  return clientMatch;
}

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectPostCampaigns = exports.injectHeaderCampaigns = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _campaignInjectors;

var _campaignManagerProvider = __webpack_require__(155);

var _appStore = __webpack_require__(23);

var _logo = __webpack_require__(222);

var _geolocationProvider = __webpack_require__(44);

var _initCampaigns = __webpack_require__(144);

var _CampaignInjector = __webpack_require__(143);

var _CampaignInjector2 = _interopRequireDefault(_CampaignInjector);

var _ua = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMMERCIAL_WIDGET_TABOOLA_FEED_PLACEHOLDER = 'commercialWidgetTaboolaFeedPlaceHolder';
var VIEWABILITY_LABEL = 'data-viewability_label';
var MINIMUM_NUMBER_OF_PARAGRAPHS = 3;
var isEmbedded = _ua.path.isEmbedded;


var canInjectHeader = function canInjectHeader() {
  return true;
};

var canInjectBelowArticle = function canInjectBelowArticle() {
  return (0, _initCampaigns.postCategoriesAllowCampaigns)();
};

var canInjectInArticle = function canInjectInArticle() {
  var index = (0, _initCampaigns.findPositionToInjectCampaign)();
  return (0, _initCampaigns.postCategoriesAllowCampaigns)() && (0, _initCampaigns.postHasAtLeastParagraphs)(MINIMUM_NUMBER_OF_PARAGRAPHS) && index !== -1 && !window.location.search.includes('app=1') && !isEmbedded;
};

var headerCampaignInjector = function headerCampaignInjector(payload) {
  (0, _appStore.dispatch)((0, _logo.changeLogo)(payload.src));
};

var inArticleCampaignInjector = function inArticleCampaignInjector(payload) {
  var campaignElement = (0, _initCampaigns.generateCampaignElement)(payload.embedCode);
  var index = -1;
  if ((0, _geolocationProvider.getCountryCode)() === 'ES') {
    index = (0, _initCampaigns.findPositionToInjectCampaignEs)();
  } else {
    index = (0, _initCampaigns.findPositionToInjectCampaign)();
  }
  var paragraph = (0, _initCampaigns.getPostItems)()[index];
  paragraph && paragraph.insertAdjacentElement('afterend', campaignElement);

  (0, _initCampaigns.registerElementToViewabilityTracker)(campaignElement.firstChild);
  (0, _initCampaigns.dispatchWidgetEmbed)(campaignElement.firstChild, VIEWABILITY_LABEL);
};

var belowArticleCampaignInjector = function belowArticleCampaignInjector(payload) {
  var campaignElement = (0, _initCampaigns.generateCampaignElement)(payload.embedCode);

  var taboolaPlaceholder = document.getElementsByClassName(COMMERCIAL_WIDGET_TABOOLA_FEED_PLACEHOLDER)[0];
  taboolaPlaceholder && taboolaPlaceholder.insertAdjacentElement('beforeend', campaignElement);

  (0, _initCampaigns.registerElementToViewabilityTracker)(campaignElement.firstChild);
  (0, _initCampaigns.dispatchWidgetEmbed)(campaignElement.firstChild, VIEWABILITY_LABEL);
};

var POSITIONS = {
  HEADER: 'header',
  IN_ARTICLE: 'inArticle',
  BELOW_ARTICLE: 'belowArticle'
};

var campaignInjectors = (_campaignInjectors = {}, (0, _defineProperty3.default)(_campaignInjectors, POSITIONS.HEADER, new _CampaignInjector2.default(headerCampaignInjector, canInjectHeader)), (0, _defineProperty3.default)(_campaignInjectors, POSITIONS.IN_ARTICLE, new _CampaignInjector2.default(inArticleCampaignInjector, canInjectInArticle)), (0, _defineProperty3.default)(_campaignInjectors, POSITIONS.BELOW_ARTICLE, new _CampaignInjector2.default(belowArticleCampaignInjector, canInjectBelowArticle)), _campaignInjectors);

var injectHeaderCampaigns = exports.injectHeaderCampaigns = function injectHeaderCampaigns() {
  return (0, _campaignManagerProvider.getCampaignsFromCampaignManager)().then(function (campaigns) {
    campaigns.filter(function (campaign) {
      return campaign.position === POSITIONS.HEADER;
    }).forEach(function (campaign) {
      var _campaignInjectors$ca = campaignInjectors[campaign.position],
          validate = _campaignInjectors$ca.validate,
          inject = _campaignInjectors$ca.inject;

      if (validate()) {
        inject(campaign.payload);
      }
    });
  });
};

var injectPostCampaigns = exports.injectPostCampaigns = function injectPostCampaigns() {
  return (0, _campaignManagerProvider.getCampaignsFromCampaignManager)().then(function (campaigns) {
    campaigns.filter(function (campaign) {
      return campaign.position !== POSITIONS.HEADER;
    }).forEach(function (campaign) {
      var _campaignInjectors$ca2 = campaignInjectors[campaign.position],
          validate = _campaignInjectors$ca2.validate,
          inject = _campaignInjectors$ca2.inject;

      if (validate()) {
        inject(campaign.payload);
      }
    });
  });
};

/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(116);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(60);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _exenv = __webpack_require__(1254);

var _exenv2 = _interopRequireDefault(_exenv);

var _elementClass = __webpack_require__(1114);

var _elementClass2 = _interopRequireDefault(_elementClass);

var _ModalPortal = __webpack_require__(1248);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(1249);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _refCount = __webpack_require__(1251);

var refCount = _interopRequireWildcard(_refCount);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EE = _exenv2.default;
var renderSubtreeIntoContainer = _reactDom2.default.unstable_renderSubtreeIntoContainer;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);

      if (refCount.count() === 0) {
        (0, _elementClass2.default)(document.body).remove(_this.props.bodyOpenClassName);
      }
    }, _this.renderPortal = function (props) {
      if (props.isOpen || refCount.count() > 0) {
        (0, _elementClass2.default)(document.body).add(_this.props.bodyOpenClassName);
      } else {
        (0, _elementClass2.default)(document.body).remove(_this.props.bodyOpenClassName);
      }

      if (props.ariaHideApp) {
        ariaAppHider.toggle(props.isOpen, props.appElement);
      }

      _this.portal = renderSubtreeIntoContainer(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.node = document.createElement('div');
      this.node.className = this.props.portalClassName;

      if (this.props.isOpen) refCount.add(this);

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);
      this.renderPortal(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var isOpen = newProps.isOpen;
      // Stop unnecessary renders if modal is remaining closed

      if (!this.props.isOpen && !isOpen) return;

      if (isOpen) refCount.add(this);
      if (!isOpen) refCount.remove(this);
      var currentParent = getParentElement(this.props.parentSelector);
      var newParent = getParentElement(newProps.parentSelector);

      if (newParent !== currentParent) {
        currentParent.removeChild(this.node);
        newParent.appendChild(this.node);
      }

      this.renderPortal(newProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps) {
      if (newProps.portalClassName !== this.props.portalClassName) {
        this.node.className = newProps.portalClassName;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      if (!this.node) return;

      refCount.remove(this);

      if (this.props.ariaHideApp) {
        ariaAppHider.show(this.props.appElement);
      }

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(function () {
          return _this2.removePortal;
        }, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'setAppElement',
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable no-console */

  }, {
    key: 'injectCSS',
    value: function injectCSS() {
      "production" !== "production" && console.warn('React-Modal: injectCSS has been deprecated ' + 'and no longer has any effect. It will be removed in a later version');
    }
    /* eslint-enable no-console */

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  appElement: _propTypes2.default.instanceOf(SafeHTMLElement),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string.isRequired
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: 'ReactModalPortal',
  bodyOpenClassName: 'ReactModal__Body--open',
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldCloseOnOverlayClick: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position: 'absolute',
    top: '40px',
    left: '40px',
    right: '40px',
    bottom: '40px',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px'
  }
};
exports.default = Modal;

/***/ }),

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(60);

var _focusManager = __webpack_require__(1250);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(1252);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: 'ReactModal__Overlay',
  content: 'ReactModal__Content'
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setFocusAfterRender = function (focus) {
      _this.focusAfterRender = focus;
    };

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
    };

    _this.setContentRef = function (content) {
      _this.content = content;
    };

    _this.afterClose = function () {
      focusManager.returnFocus();
      focusManager.teardownScopedFocus();
    };

    _this.open = function () {
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        focusManager.setupScopedFocus(_this.node);
        focusManager.markForFocusLater();
        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }
      if (event.keyCode === ESC_KEY) {
        event.preventDefault();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === 'undefined' ? 'undefined' : _typeof(additional)) === 'object' ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + '--after-open',
        beforeClose: CLASS_NAMES[which] + '--before-close'
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + ' ' + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + ' ' + classNames.beforeClose;
      }
      return typeof additional === 'string' && additional ? className + ' ' + additional : className;
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Focus needs to be set when mounting and already open
      if (this.props.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // Focus only needs to be set once when the modal is being opened
      if (!this.props.isOpen && newProps.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      } else if (this.props.isOpen && !newProps.isOpen) {
        this.close();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.focusAfterRender) {
        this.focusContent();
        this.setFocusAfterRender(false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.closeTimer);
    }

    // Don't steal focus from inner elements

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          overlayClassName = _props.overlayClassName,
          defaultStyles = _props.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? _react2.default.createElement('div', null) : _react2.default.createElement(
        'div',
        {
          ref: this.setOverlayRef,
          className: this.buildClassName('overlay', overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick },
        _react2.default.createElement(
          'div',
          {
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName('content', className),
            tabIndex: '-1',
            onKeyDown: this.handleKeyDown,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            'aria-label': this.props.contentLabel },
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  }
};
ModalPortal.propTypes = {
  isOpen: _propTypes.PropTypes.bool.isRequired,
  defaultStyles: _propTypes.PropTypes.shape({
    content: _propTypes.PropTypes.object,
    overlay: _propTypes.PropTypes.object
  }),
  style: _propTypes.PropTypes.shape({
    content: _propTypes.PropTypes.object,
    overlay: _propTypes.PropTypes.object
  }),
  className: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
  overlayClassName: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
  onAfterOpen: _propTypes.PropTypes.func,
  onRequestClose: _propTypes.PropTypes.func,
  closeTimeoutMS: _propTypes.PropTypes.number,
  shouldCloseOnOverlayClick: _propTypes.PropTypes.bool,
  role: _propTypes.PropTypes.string,
  contentLabel: _propTypes.PropTypes.string,
  children: _propTypes.PropTypes.node
};
exports.default = ModalPortal;

/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.tryForceFallback = tryForceFallback;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.toggle = toggle;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;
var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error('react-modal: No elements were found for selector ' + selector + '.');
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === 'string') {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = 'length' in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function tryForceFallback() {
  if (document && document.body) {
    // force fallback to document.body
    setElement(document.body);
    return true;
  }
  return false;
}

function validateElement(appElement) {
  if (!appElement && !globalElement && !tryForceFallback()) {
    throw new Error(['react-modal: Cannot fallback to `document.body`, because it\'s not ready or available.', 'If you are doing server-side rendering, use this function to defined an element.', '`Modal.setAppElement(el)` to make this accessible']);
  }
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || globalElement).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || globalElement).removeAttribute('aria-hidden');
}

function toggle(shouldHide, appElement) {
  var apply = shouldHide ? hide : show;
  apply(appElement);
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = document.body;
}

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dom = __webpack_require__(13);

var _ua = __webpack_require__(10);

var _BaseAdView2 = __webpack_require__(215);

var _BaseAdView3 = _interopRequireDefault(_BaseAdView2);

var _mithril = __webpack_require__(54);

var _adsConfig = __webpack_require__(27);

var _pageDataObject = __webpack_require__(5);

var _window = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STICKY = _adsConfig.CLASS_NAMES.STICKY;
var debugStickyHeader = _window.queryString.debugStickyHeader;

var topSlot = null;

function displayStickyAdForSite(stickyConf) {
  return !stickyConf.exceptOnSites || stickyConf.exceptOnSites.length === 0 || stickyConf.exceptOnSites.some(function (site) {
    return site !== (0, _pageDataObject.getPageDomain)();
  });
}

function isSticky(stickyConf) {
  var isStickyByDefault = stickyConf.default;
  var isStickyNotBlacklisted = isStickyByDefault && displayStickyAdForSite(stickyConf);
  var isntStickyAndWhitelisted = !isStickyByDefault && !displayStickyAdForSite(stickyConf);
  return isStickyNotBlacklisted || isntStickyAndWhitelisted;
}

var RegularAdView = function (_BaseAdView) {
  (0, _inherits3.default)(RegularAdView, _BaseAdView);

  function RegularAdView() {
    (0, _classCallCheck3.default)(this, RegularAdView);
    return (0, _possibleConstructorReturn3.default)(this, (RegularAdView.__proto__ || (0, _getPrototypeOf2.default)(RegularAdView)).apply(this, arguments));
  }

  (0, _createClass3.default)(RegularAdView, [{
    key: 'view',
    value: function view(ctrl) {
      return (0, _mithril.createElementWithCallback)('div', this.renderParams);
    }
  }, {
    key: 'adjustTopSlot',
    value: function adjustTopSlot() {
      // eslint-disable-line complexity
      topSlot = topSlot || (0, _dom.node)('.ad[data-slot-id="' + _adsConfig.AD_FORMATS.Top + '"]');
      if (!topSlot) {
        return this;
      }
      var _adVm = this.adVm,
          topHeight = _adVm.topHeight,
          stickyConf = _adVm.stickyConf;

      if ((0, _ua.getIsDesktop)() && topSlot && topHeight) {
        topSlot.style.height = topHeight + 24 + 'px';
      }
      if (isSticky(stickyConf)) {
        if (!topSlot.classList.contains(STICKY)) {
          if (debugStickyHeader) {
            this.info('adding class \'' + STICKY + '\' to top slot', { topSlot: topSlot });
          }
          topSlot.classList.add(STICKY);
        }
      } else {
        if (topSlot.classList.contains(STICKY)) {
          // eslint-disable-line no-lonely-if
          if (debugStickyHeader) {
            this.info('removing class \'' + STICKY + '\' to top slot', { topSlot: topSlot });
          }
          topSlot.classList.remove(STICKY);
        }
      }
      return this;
    }
  }, {
    key: 'renderParams',
    get: function get() {
      var params = (0, _get3.default)(RegularAdView.prototype.__proto__ || (0, _getPrototypeOf2.default)(RegularAdView.prototype), 'renderParams', this);
      if (this.adId === _adsConfig.AD_FORMATS.Top) {
        (0, _window.addOnOrientationChangeEvent)(this.adjustTopSlot.bind(this), this.adjustTopSlot.bind(this));
        this.adjustTopSlot();
      }
      return params;
    }
  }]);
  return RegularAdView;
}(_BaseAdView3.default);

exports.default = RegularAdView;

/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(521);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    toFocus.focus();
    return;
  } catch (e) {
    console.warn(['You tried to return focus to', toFocus, 'but it is not in the DOM anymore'].join(" "));
  }
}
/* eslint-enable no-console */

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
}

/***/ }),

/***/ 1251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.remove = remove;
exports.count = count;
var modals = [];

function add(element) {
  if (modals.indexOf(element) === -1) {
    modals.push(element);
  }
}

function remove(element) {
  var index = modals.indexOf(element);
  if (index === -1) {
    return;
  }
  modals.splice(index, 1);
}

function count() {
  return modals.length;
}

/***/ }),

/***/ 1252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(521);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement ||
  // handle immediate shift+tab after opening with mouse
  node === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
}

/***/ }),

/***/ 1253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1247);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(156), __esModule: true };

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.FRESH8_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var FRESH8_ACTION_TYPES = exports.FRESH8_ACTION_TYPES = (0, _object.namespacedConsts)({
  DISPLAY_POPUP: true,
  HIDE_POPUP: true,
  DISPLAY_FLOATING_BUTTON: true
});
function displayPopup() {
  return function (dispatch, getState) {
    dispatch({
      type: FRESH8_ACTION_TYPES.DISPLAY_POPUP,
      state: {
        isPopupVisible: true
      }
    });
  };
}
function hidePopup() {
  return function (dispatch, getState) {
    dispatch({
      type: FRESH8_ACTION_TYPES.HIDE_POPUP,
      state: {
        isPopupVisible: false
      }
    });
  };
}
function displayFloatingButton() {
  return function (dispatch, getState) {
    dispatch({
      type: FRESH8_ACTION_TYPES.DISPLAY_FLOATING_BUTTON,
      state: {
        isFloatingButtongVisible: true
      }
    });
  };
}
var actions = exports.actions = { displayPopup: displayPopup, hidePopup: hidePopup, displayFloatingButton: displayFloatingButton, FRESH8_ACTION_TYPES: FRESH8_ACTION_TYPES };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107);
__webpack_require__(556);
module.exports = __webpack_require__(571);


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(9);

var _extends5 = _interopRequireDefault(_extends4);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

exports.default = addAnalyticsClickDelegator;

var _console = __webpack_require__(11);

var _dom = __webpack_require__(13);

var _window = __webpack_require__(8);

var _appStore = __webpack_require__(23);

var _analyticsActions = __webpack_require__(31);

var _analyticsActions2 = _interopRequireDefault(_analyticsActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FEATURE_FLAGS = {
  debug: _window.queryString.debugAnalyticsClickHandler
}; /* eslint consistent-return:0 */


var hasAnalyticsClickEventCategoryAttribute = function hasAnalyticsClickEventCategoryAttribute(target) {
  return target && target.hasAttribute('data-analytics-event-category');
};

var isAnchor = function isAnchor(el) {
  return el instanceof HTMLAnchorElement;
};

var isButton = function isButton(el) {
  return el instanceof HTMLButtonElement;
};

var isAnalyticsElement = function isAnalyticsElement(el) {
  return (isAnchor(el) || isButton(el)) && hasAnalyticsClickEventCategoryAttribute(el);
};

var parentUntilCategoryAttribute = (0, _dom.parentElementUntil)(hasAnalyticsClickEventCategoryAttribute);

var parentUntilClickable = (0, _dom.parentElementUntil)(isAnalyticsElement);

function debug() {
  FEATURE_FLAGS.debug && _console.info.apply(undefined, ['[analytics click handler]'].concat(Array.prototype.slice.call(arguments)));
}

function lowerCaseIfString(value) {
  return typeof value === 'string' ? value.toLowerCase() : value;
}

function normalizeEventData(eventMetadata) {
  return (0, _entries2.default)(eventMetadata).reduce(function (acc, _ref, idx) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (idx === 0) {
      return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, value));
    }
    return value === undefined ? acc : (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, lowerCaseIfString(value)));
  }, {});
}

function addGtmAnchorCallback(evt) {
  var maybeClickable = parentUntilClickable(evt.target);
  if (!maybeClickable || !maybeClickable.target || maybeClickable.target.length > 0) {
    return;
  }

  evt.preventDefault();
  return {
    eventCallback: function eventCallback() {
      window.location = maybeClickable.href;
    },

    eventTimeout: 1000
  };
}

function delegatedAnalyticsClickHandler(evt) {
  var gtmAnchorCallback = addGtmAnchorCallback(evt);
  var target = evt.target;
  debug('target', target);
  var targetDataValue = target.dataset.analyticsEventValue;
  var analyticsElementOrNull = parentUntilCategoryAttribute(target);
  if (!analyticsElementOrNull) {
    return;
  }
  var _analyticsElementOrNu = analyticsElementOrNull.dataset,
      eventCategory = _analyticsElementOrNu.analyticsEventCategory,
      eventAction = _analyticsElementOrNu.analyticsEventAction,
      eventLabel = _analyticsElementOrNu.analyticsEventLabel,
      eventValue = _analyticsElementOrNu.analyticsEventValue;

  if (eventCategory && eventAction) {
    (0, _appStore.dispatch)(_analyticsActions2.default.pageClicked(normalizeEventData({
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      eventValue: eventValue || targetDataValue,
      gtmAnchorCallback: gtmAnchorCallback
    })));
  }
}

function addAnalyticsClickDelegator() {
  document.body.addEventListener('click', delegatedAnalyticsClickHandler);
}

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _initCampaigns = __webpack_require__(124);

var _initGlobalRejectionHandler = __webpack_require__(145);

var _initGlobalRejectionHandler2 = _interopRequireDefault(_initGlobalRejectionHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Initializes modules, which are used across all pages in app.
 */
(0, _initGlobalRejectionHandler2.default)();
(0, _initCampaigns.injectHeaderCampaigns)();

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receivedError = exports.dataReceived = exports.TYPES = undefined;

var _AppDispatcher = __webpack_require__(55);

var _object = __webpack_require__(12);

/* eslint semi:0 */
var ACTION_COUNTER_PROVIDER_CONSTS = (0, _object.namespacedConsts)({
  ACTIONS: {
    DATA_RECEIVED: true,
    RECEIVED_ERROR: true
  }
});

var TYPES = exports.TYPES = ACTION_COUNTER_PROVIDER_CONSTS.ACTIONS;

var dataReceived = exports.dataReceived = function dataReceived(data) {
  _AppDispatcher.appDispatcher.dispatchAction.external({
    type: TYPES.DATA_RECEIVED,
    data: data,
    fluxToRedux: true
  });
};

var receivedError = exports.receivedError = function receivedError(error) {
  _AppDispatcher.appDispatcher.dispatchAction.external({
    type: TYPES.RECEIVED_ERROR,
    error: error,
    fluxToRedux: true
  });
};

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsServices = undefined;

var _getIterator2 = __webpack_require__(58);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = init;

var _analyticsStore = __webpack_require__(51);

var _analyticsStore2 = _interopRequireDefault(_analyticsStore);

var _pageDataObject = __webpack_require__(5);

var _pageDataObject2 = _interopRequireDefault(_pageDataObject);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _pageContext = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsServicesConditions = {
  default_services: function default_services() {
    return true;
  },
  slideshow_native_app_services: function slideshow_native_app_services() {
    return _pageDataObject2.default.isSlideshow && (0, _ua.getIsNativeApp)();
  },
  non_native_app_services: function non_native_app_services() {
    return !(0, _ua.getIsNativeApp)();
  },
  facebook_analytics: function facebook_analytics() {
    return !(0, _ua.getIsNativeApp)() && _pageDataObject2.default.get('config.facebook_pixel') && !(0, _pageContext.getInfluencerId)();
  },
  full_layout_services: function full_layout_services() {
    return _ua.path.isFullLayout;
  }
};

var supportedAnalyticsServices = _pageDataObject2.default.get('config.analytics_services');
var analyticsServices = exports.analyticsServices = [];
var site = NM.pdo.get('context.site');
for (var analyticsServicesGroup in supportedAnalyticsServices) {
  var condition = analyticsServicesConditions[analyticsServicesGroup];
  if (condition()) {
    var services = supportedAnalyticsServices[analyticsServicesGroup] || [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(services), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var service = _step.value;

        analyticsServices.push(__webpack_require__(175)("./" + service + 'Service').default);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}

var analyticsStore = _analyticsStore2.default.create();

function init() {
  analyticsServices.forEach(function (Class) {
    Class.create({ store: analyticsStore });
  });
}

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CampaignInjector = function CampaignInjector(inject, validate) {
  (0, _classCallCheck3.default)(this, CampaignInjector);

  this.inject = inject;
  this.validate = validate;
};

exports.default = CampaignInjector;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchWidgetEmbed = exports.registerElementToViewabilityTracker = exports.generateCampaignElement = exports.findPositionToInjectCampaignEs = exports.findPositionToInjectCampaign = exports.getPostItems = exports.postCategoriesAllowCampaigns = exports.postHasAtLeastParagraphs = exports.generateEmbedContent = exports.generateInsertableHTML = undefined;

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _pageDataObject = __webpack_require__(5);

var _viewbilityTracker = __webpack_require__(99);

var _appStore = __webpack_require__(23);

var _analyticsActions = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyAttributes = function copyAttributes(elemFrom, elemTo) {
  return (0, _from2.default)(elemFrom.attributes).forEach(function (attr) {
    return elemTo.setAttribute(attr.name, attr.value);
  });
};

var convertToExecutableScripts = function convertToExecutableScripts(scripts) {
  return scripts.map(function (script) {
    var executable = document.createElement('script');
    executable.innerHTML = script.innerHTML ? script.innerHTML : '';
    copyAttributes(script, executable);
    return executable;
  });
};

var isJS = function isJS(script) {
  return script.type === '' || script.type.indexOf('javascript') >= 0;
};

var findJavaScriptElements = function findJavaScriptElements(wrapper) {
  var scripts = (0, _from2.default)(wrapper.getElementsByTagName('script'));
  return scripts.filter(isJS);
};

var removeScripts = function removeScripts(scripts) {
  scripts.forEach(function (script) {
    return script.remove();
  });
};

var wrapHTML = function wrapHTML(html) {
  var tempWrapper = window.parent.document.createElement('div');
  tempWrapper.innerHTML = html;
  return tempWrapper;
};

var generateInsertableHTML = exports.generateInsertableHTML = function generateInsertableHTML(html) {
  var wrapper = wrapHTML(html);
  var scripts = findJavaScriptElements(wrapper);
  // Remove injected scripts and leave only created executable scripts
  removeScripts(scripts);
  var elements = (0, _from2.default)(wrapper.childNodes);
  return {
    elements: elements,
    scripts: convertToExecutableScripts(scripts)
  };
};

var generateEmbedContent = exports.generateEmbedContent = function generateEmbedContent(data) {
  var elements = data.elements,
      scripts = data.scripts;

  var el = document.createElement('div');
  el.style.width = '100%';
  elements.forEach(function (elem) {
    el.appendChild(elem);
  });
  scripts.forEach(function (script) {
    el.appendChild(script);
  });
  return el;
};

var postHasAtLeastParagraphs = exports.postHasAtLeastParagraphs = function postHasAtLeastParagraphs(minimumParagraphs) {
  var initialParagraphs = document.querySelectorAll('.post-content > p').length;
  var emptyParagraphs = document.querySelectorAll('.post-content > p > br').length;
  return initialParagraphs - emptyParagraphs > minimumParagraphs;
};

var postCategoriesAllowCampaigns = exports.postCategoriesAllowCampaigns = function postCategoriesAllowCampaigns() {
  var postCategories = (0, _pageDataObject.getPostCategories)();
  return !postCategories.includes('no-campaign-manager') && (!postCategories.includes('sponsored') || postCategories.includes('wirewax'));
};

var isParagraph = function isParagraph(node) {
  var nodeHTML = node.innerHTML;
  var isBoldTitle = nodeHTML.match('<strong>.+<\\/strong>') !== null;
  return node.innerText !== '' && nodeHTML !== '<span style="font-size: 1em;"><br></span>' && nodeHTML !== '<strong><br></strong>' && !isBoldTitle && nodeHTML !== '&nbsp;';
};

var getPostItems = exports.getPostItems = function getPostItems() {
  return [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('.post-content > *')));
};

var findPositionToInjectCampaign = exports.findPositionToInjectCampaign = function findPositionToInjectCampaign() {
  var postItems = getPostItems();
  var isParagraphArray = postItems.map(function (x) {
    return isParagraph(x);
  });
  var startPoint = parseInt(isParagraphArray.length / 2, 10);
  for (var i = startPoint; i < isParagraphArray.length - 2; i++) {
    if (isParagraphArray[i] && isParagraphArray[i + 1]) {
      return i;
    }
  }
  return -1;
};

var findPositionToInjectCampaignEs = exports.findPositionToInjectCampaignEs = function findPositionToInjectCampaignEs() {
  var postItems = getPostItems();
  var isParagraphArray = postItems.map(function (x) {
    return isParagraph(x);
  });
  var startPoint = parseInt(isParagraphArray.length, 1);
  for (var i = startPoint; i < isParagraphArray.length - 2; i++) {
    if (isParagraphArray[i]) {
      return i;
    }
  }
  return -1;
};

var generateCampaignElement = exports.generateCampaignElement = function generateCampaignElement(script) {
  var parsedScript = generateInsertableHTML('' + script);
  return generateEmbedContent(parsedScript);
};

var registerElementToViewabilityTracker = exports.registerElementToViewabilityTracker = function registerElementToViewabilityTracker(element) {
  (0, _viewbilityTracker.register)('.' + element.className);
};

var dispatchWidgetEmbed = exports.dispatchWidgetEmbed = function dispatchWidgetEmbed(element, viewabilityLabel) {
  (0, _appStore.dispatch)((0, _analyticsActions.widgetEmbedEvent)(element.getAttribute(viewabilityLabel)));
};

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initGlobalPromiseRejectionHandler;

var _dom = __webpack_require__(13);

var _console = __webpack_require__(11);

// https://devdocs.io/dom_events/unhandledrejection
function globalPromiseRejectionHandler(event) {
  // eslint-disable-line no-shadow
  var reason = event.reason,
      promise = event.promise;

  (0, _console.warn)('Unhandled Promise rejection caught: \'' + reason + '\'!', { event: event, reason: reason, promise: promise });
}

function initGlobalPromiseRejectionHandler() {
  return (0, _dom.addWindowEvent)('unhandledrejection', globalPromiseRejectionHandler);
}

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setLocaleCookie;

var _cookies = __webpack_require__(180);

var _window = __webpack_require__(8);

function setLocaleCookie() {
  if (_window.queryString.setLocale) {
    (0, _cookies.set)('locale', _window.path.substr(1), { path: '/', expires: new Date('2020', '1', '1') });
  }
}

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _pageContext = __webpack_require__(61);

var _pageDataObject = __webpack_require__(5);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _currentPostActionCounterProvider = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PAGE_DATA_OBJECT_FALLBACK = {
  post: {
    // Defaults for failed pageDataObject parsing
    id: null,
    author: {
      id: null,
      league: null
    }
  },
  page: {}
}; /* eslint semi:0 */

var ActionCounterService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(ActionCounterService, _AnalyticsBaseService);

  function ActionCounterService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ActionCounterService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionCounterService.__proto__ || (0, _getPrototypeOf2.default)(ActionCounterService)).call(this, options));

    _this.facebookShare = _this.twitterShare = _this.whatsappShare = _this.socialShare;
    var post = (0, _pageDataObject.get)('post', PAGE_DATA_OBJECT_FALLBACK.post);
    var author = post.author,
        actionCounterTag = post.action_counter_tag;

    _this.basicPostAndAuthorData = {
      post: post.id,
      author: author.id,
      league: actionCounterTag
    };
    if (_userStore2.default.state.id) {
      _this.basicPostAndAuthorData.user = _userStore2.default.state.id;
    }
    return _this;
  }

  (0, _createClass3.default)(ActionCounterService, [{
    key: 'routeChanged',
    value: function routeChanged(action) {
      //Empty override to prevent a read report on slideshows on each slide change
    }
  }, {
    key: 'pageViewed',
    value: function pageViewed() {
      if (this.shouldReportPageview()) {
        this.trackEvent('reads', this.pageViewData);
      }
    }
  }, {
    key: 'shouldReportPageview',
    value: function shouldReportPageview() {
      var postId = (0, _pageDataObject.get)('post.id', false);
      if (postId === false) {
        return false;
      }
      return _userStore2.default.recentReads[postId].readsCount <= 1;
    }
  }, {
    key: 'socialShare',
    value: function socialShare() {
      this.trackEvent('shares', this.basicPostAndAuthorData);
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(type, params) {
      if (!(0, _ua.getIsBot)()) {
        this.logAnalytics(type, params);
        (0, _currentPostActionCounterProvider.sendData)(type, params);
      }
    }
  }, {
    key: 'className',
    get: function get() {
      return 'ActionCounterService';
    }
  }, {
    key: 'pageViewData',
    get: function get() {
      var _Object$assign = (0, _assign2.default)(PAGE_DATA_OBJECT_FALLBACK, {
        post: (0, _pageDataObject.get)('post', PAGE_DATA_OBJECT_FALLBACK.post),
        page: (0, _pageDataObject.get)('page', PAGE_DATA_OBJECT_FALLBACK.page)
      }),
          post = _Object$assign.post,
          page = _Object$assign.page;

      var author = post.author;

      var data = (0, _assign2.default)({}, this.basicPostAndAuthorData, {
        locale: page.locale,
        domain: page.site,
        aid: (0, _pageContext.getInfluencerId)() || _window.queryString.af,
        featured_to_site: post.featured_to_site // eslint-disable-line camelcase
      });
      return data;
    }
  }]);
  return ActionCounterService;
}(_analyticsBaseService2.default);

exports.default = ActionCounterService;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _window = __webpack_require__(8);

var _externalScripts = __webpack_require__(52);

var _fn = __webpack_require__(15);

var _script = __webpack_require__(19);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _i18nProvider = __webpack_require__(18);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable camelcase, key-spacing, no-multi-spaces, lines-around-comment, */
/* eslint semi:0 */
var AGOF_DEFAULT_PARAMS = {
  sv: 'i2',
  st: 'ftbpro'
};
var AGOF_DEFAULT_TAG = { cp: 'dTxUcCpOqKyFz02', co: '/other' };
var AGOF_STATIC_PAGE_TAG = { cp: 'dTxRcCpOqKyFz20serv', co: '/service' };
var AGOF_TAGS_DICTIONARY = {
  league: AGOF_DEFAULT_TAG,
  homepage: { cp: 'dTxRcHpOqKyFz02home', co: '/homepage', sv: 'ke' },
  league_articles: { cp: 'dTxUcCpOqKyFz02arti', co: '/artikel' },
  league_leaderboard: { cp: 'dTxUcCpOqKyFz27auto', co: '/autoren' },
  team: { cp: 'dTxUcCpOqKyFz02mann', co: '/mannschaften' },
  team_articles: { cp: 'dTxUcCpOqKyFz02arti', co: '/artikel' },
  users: { cp: 'dTxUcCpOqKyFz27prof', co: '/profile' },
  post: { cp: 'dTxUcCpOqKyFz02arti', co: '/meldungen' },
  about: AGOF_STATIC_PAGE_TAG,
  writersfaq: AGOF_STATIC_PAGE_TAG,
  rules: AGOF_STATIC_PAGE_TAG,
  terms: AGOF_STATIC_PAGE_TAG,
  contact: AGOF_STATIC_PAGE_TAG,
  privacy_policy: AGOF_STATIC_PAGE_TAG,
  mobile_apps: AGOF_STATIC_PAGE_TAG,
  affiliates: AGOF_STATIC_PAGE_TAG
  /* eslint-enable */

  // NOTICE: this class should be (and is) used only when not in native app
};
var AgofService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(AgofService, _AnalyticsBaseService);

  function AgofService() {
    var _ref;

    (0, _classCallCheck3.default)(this, AgofService);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AgofService.__proto__ || (0, _getPrototypeOf2.default)(AgofService)).call.apply(_ref, [this].concat(args)));

    if (_this.shouldReportPageview()) {
      _this.agofLoader = _script.external.load({ name: _externalScripts.externalScriptsConfig.agof.name });
    }
    return _this;
  }

  (0, _createClass3.default)(AgofService, [{
    key: 'pageViewed',
    value: function pageViewed() {
      if (this.shouldReportPageview()) {
        this.trackEvent(this.pageViewData);
      }
    }
  }, {
    key: 'shouldReportPageview',
    value: function shouldReportPageview() {
      var forceAgofReport = _window.queryString.forceAgofReport;

      return forceAgofReport || (0, _fn.allTrue)((0, _pageDataObject.isSupportedForDomain)('Agof'), _i18nProvider.locale === _i18nProvider.AVAILABLE_LOCALES.DE, (0, _pageDataObject.get)('config.env') !== 'development');
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(data) {
      if (this.shouldReportPageview()) {
        this.logAnalytics(data);
        this.agofLoader((0, _fn.makeSafeFn)(function () {
          return window.iom.c(data, 2);
        }));
      }
    }
  }, {
    key: 'className',
    get: function get() {
      return 'AgofService';
    }
  }, {
    key: 'pageViewData',
    get: function get() {
      var currentTag = AGOF_TAGS_DICTIONARY[(0, _pageDataObject.get)('page.type')] || AGOF_DEFAULT_TAG;
      var tagWithDefaults = (0, _extends3.default)({}, AGOF_DEFAULT_PARAMS, currentTag);
      var sha1 = _userStore2.default.state.sha1;

      if (sha1) {
        tagWithDefaults.mc = sha1;
      }
      return tagWithDefaults;
    }
  }]);
  return AgofService;
}(_analyticsBaseService2.default);

exports.default = AgofService;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _dom = __webpack_require__(13);

var _ua = __webpack_require__(10);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _adStore = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HOST = 'ec2-54-185-154-151.us-west-2.compute.amazonaws.com'; /* eslint semi:0 */

var AnalyticsCounterService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(AnalyticsCounterService, _AnalyticsBaseService);

  function AnalyticsCounterService() {
    (0, _classCallCheck3.default)(this, AnalyticsCounterService);
    return (0, _possibleConstructorReturn3.default)(this, (AnalyticsCounterService.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsCounterService)).apply(this, arguments));
  }

  (0, _createClass3.default)(AnalyticsCounterService, [{
    key: 'pageViewed',
    value: function pageViewed() {
      this.trackEvent('pageview', { platform: (0, _ua.getPlatform)() });
    }
  }, {
    key: 'routeChanged',
    value: function routeChanged(action) {
      //Empty override to prevent a read report on slideshows on each slide change
    }
  }, {
    key: 'adBlockDetectionFinished',
    value: function adBlockDetectionFinished() {
      this.trackEvent('adblock', {
        platform: (0, _ua.getPlatform)(),
        adblock_detected: _adStore.adStore.isAdblockPresent
      });
    }
  }, {
    key: 'slotRendered',
    value: function slotRendered(action) {
      var lineitem = void 0;
      if (action.event.isEmpty) {
        lineitem = 'empty';
      } else {
        lineitem = action.event.lineItemId || 'adx';
      }
      this.trackEvent('ad_served', {
        platform: (0, _ua.getPlatform)(),
        ad_unit: action.adId,
        lineitem: lineitem
      });
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(type, params) {
      for (var k in params) {
        params[k] = params[k].toString().replace(' ', '-');
      }
      params.ts = Date.now();
      this.logAnalytics(type, params);
      var serializedParams = _mithril2.default.route.buildQueryString(params);
      (0, _dom.makeImage)({ src: '//' + HOST + '/' + type + '?' + serializedParams });
    }
  }, {
    key: 'className',
    get: function get() {
      return 'AnalyticsCounterService';
    }
  }]);
  return AnalyticsCounterService;
}(_analyticsBaseService2.default);

exports.default = AnalyticsCounterService;

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _script = __webpack_require__(19);

var _fn = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var comscore = _script.external.load({
  name: 'comscore',
  loadNow: true
});

//NOTICE: this class should be (and is) used only when not in native app
/* eslint semi:0 */

var ComscoreService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(ComscoreService, _AnalyticsBaseService);

  function ComscoreService() {
    (0, _classCallCheck3.default)(this, ComscoreService);
    return (0, _possibleConstructorReturn3.default)(this, (ComscoreService.__proto__ || (0, _getPrototypeOf2.default)(ComscoreService)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComscoreService, [{
    key: 'pageViewed',
    value: function pageViewed() {
      this.trackEvent({});
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(data) {
      this.logAnalytics(data);
      comscore((0, _fn.makeSafeFn)(function () {
        return window.COMSCORE.beacon(data);
      }));
    }
  }, {
    key: 'className',
    get: function get() {
      return 'ComscoreService';
    }
  }]);
  return ComscoreService;
}(_analyticsBaseService2.default);

exports.default = ComscoreService;

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ua = __webpack_require__(10);

var _dom = __webpack_require__(13);

var _fn = __webpack_require__(15);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _window = __webpack_require__(8);

var _script = __webpack_require__(19);

var _analyticsStore = __webpack_require__(51);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const fbPixel = externalScript.load({ name: 'facebookPixel' })
// fbPixel(makeSafeFn(_ => window.fbq('init', getFromPdo('config.facebook_pixel.id'))))

/* eslint semi:0 */
var DEFINED_EVENTS = ['PageView', 'ViewContent', 'Search', 'AddToCart', 'AddToWishlist', 'InitiateCheckout', 'AddPaymentInfo', 'Purchase', 'Lead', 'CompleteRegistration'];

var FacebookAnalyticsService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(FacebookAnalyticsService, _AnalyticsBaseService);

  function FacebookAnalyticsService() {
    (0, _classCallCheck3.default)(this, FacebookAnalyticsService);
    return (0, _possibleConstructorReturn3.default)(this, (FacebookAnalyticsService.__proto__ || (0, _getPrototypeOf2.default)(FacebookAnalyticsService)).apply(this, arguments));
  }

  (0, _createClass3.default)(FacebookAnalyticsService, [{
    key: 'pageViewed',
    value: function pageViewed() {}
    // const oldPixels = getFromPdo('config.facebook_pixel.old_pixels') || []
    // for (const oldPixel of oldPixels) {
    //   this.trackEventOld(oldPixel)
    // }
    // this.trackEvent('PageView')
    // this.multiPageViews()
    // this.desktopPageview()


    // multiPageViews() {
    //   const postsInSession = Object.keys(userStore.recentReads).length
    //   if (postsInSession > 1) {
    //     this.trackEvent('multiPostsViews', { numPosts: postsInSession })
    //   }
    // }

    // desktopPageview() {
    //   if (getIsDesktop()) {
    //     this.trackEvent('desktopPageview')
    //   }
    // }

  }, {
    key: 'routeChanged',
    value: function routeChanged(action) {}
    //Empty override to prevent a read report on slideshows on each slide change


    // scrollAnchorReached(action) {
    //   if (action.payload.anchor === SCROLL_EVENTS_SELECTORS.SHARE_BUTTONS_BOTTOM) {
    //     this.reportOnce(action, () => {
    //       this.trackEvent('ScrolledToArticleEnd')
    //     })
    //   }
    // }

    // heartBeat() {
    //   const millisecondsPassed = this.store.heartbeatsCount * HEART_BEAT_PERIOD
    //   if (millisecondsPassed === 30000) {
    //     this.trackEvent('HalfMinuteOnPage')
    //   }
    // }

    // socialShare(action) {
    //   this.trackEvent('SharedArticle')
    // }

  }, {
    key: 'trackEvent',
    value: function trackEvent(type, args) {
      var data = (0, _assign2.default)({}, this.defaultEventArgs, args); //NOTICE: for some reason when using makeEmptyObj in Object.assign instead of {}, then it doesn't work and the fbq SDK raise an error
      var trackType = DEFINED_EVENTS.includes(type) ? 'track' : 'trackCustom';
      this.logAnalytics(type, data);
      // fbPixel(makeSafeFn(_ => window.fbq(trackType, type, data)))
    }

    // trackEventOld(pixelUrl) {
    //   this.logAnalytics(pixelUrl)
    //   makeImage({ src: pixelUrl })
    // }

  }, {
    key: 'className',
    get: function get() {
      return 'FacebookAnalyticsService';
    }
  }, {
    key: 'defaultEventArgs',
    get: function get() {
      return {};
    }
  }]);
  return FacebookAnalyticsService;
}(_analyticsBaseService2.default);

exports.default = FacebookAnalyticsService;

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ua = __webpack_require__(10);

var _window2 = __webpack_require__(8);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _pageDataObject = __webpack_require__(5);

var _script = __webpack_require__(19);

var _analyticsStore = __webpack_require__(51);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _console = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAnalyticsClickHandler = _window2.queryString.debugAnalyticsClickHandler; /* eslint semi:0 */

var CUSTOM_DIMENSIONS = {
  SESSION: {
    PLATFORM: 'dimension1',
    USER_LOGGED_IN: 'dimension3'
  },
  HIT: {
    POST_TEMPLATE: 'dimension2'
  }
};
var YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS = ['event', 'Y! DF'];
var googleAnalytics = _script.external.load({ name: 'googleAnalytics', loadNow: true });

var GoogleAnalyticsService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(GoogleAnalyticsService, _AnalyticsBaseService);

  function GoogleAnalyticsService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, GoogleAnalyticsService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleAnalyticsService.__proto__ || (0, _getPrototypeOf2.default)(GoogleAnalyticsService)).call(this, options));

    _this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.PLATFORM, (0, _ua.getPlatform)());
    _this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, _userStore2.default.isLoggedIn ? 'loggedIn' : 'loggedOut');
    _this.existingUserAuthenticated = _this.newUserAuthenticated = _this.userAuthenticated;
    return _this;
  }

  (0, _createClass3.default)(GoogleAnalyticsService, [{
    key: 'riddleEmbedMessage',
    value: function riddleEmbedMessage(_ref) {
      var _ref$payload = _ref.payload,
          category = _ref$payload.category,
          label = _ref$payload.label;

      return this.trackEvent('event', 'riddle', category, label);
    }
  }, {
    key: 'pageViewed',
    value: function pageViewed() {
      this.trackEvent('pageview');
    }
  }, {
    key: 'slotRendered',
    value: function slotRendered(action) {
      if (action.adId === 'Interstitial') {
        this.trackEvent('event', 'Ads', 'Interstitial', 'Display', { nonInteraction: true });
      }
    }
  }, {
    key: 'heartBeat',
    value: function heartBeat() {
      var millisecondsPassed = this.store.heartbeatsCount * _analyticsStore.HEART_BEAT_PERIOD;
      this.trackEvent('event', 'Post', 'Read', millisecondsPassed / 1000 + ' seconds');
    }
  }, {
    key: 'socialShare',
    value: function socialShare(action) {
      var position = action.e.target.parentNode.className;
      var shareTarget = action.type.split(':').pop();
      this.trackEvent('social', shareTarget, position, _window2.path);
    }
  }, {
    key: 'analyticsActionsClickEvent',
    value: function analyticsActionsClickEvent(action) {
      var dataToSend = (0, _entries2.default)(action.state.payload).reduce(function (acc, _ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return [].concat((0, _toConsumableArray3.default)(acc), [value]);
      }, []);

      if (debugAnalyticsClickHandler) {
        (0, _console.info)('CLICK SERVICE RECIEVED ACTION WITH PAYLOAD: ', action.state.payload);
        (0, _console.info)('SENDING TO GA: ', ['event'].concat((0, _toConsumableArray3.default)(dataToSend)));
      }

      this.trackEvent.apply(this, ['event'].concat((0, _toConsumableArray3.default)(dataToSend)));
    }
  }, {
    key: 'jwplayerAnalytics',
    value: function jwplayerAnalytics(_ref4) {
      var _ref4$payload = _ref4.payload,
          eventName = _ref4$payload.eventName,
          videoId = _ref4$payload.videoId;

      this.trackEvent('event', 'Article page', eventName, videoId);
    }

    //videoPlay(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoPause(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoComplete(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoPause(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoError(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoBufferChange({ payload: { eventName, videoId, buffer } }){
    //  this.trackEvent('event', 'Article Page', eventName, `videoId: ${videoId}, buffered: ${buffer.bufferPercent}`);
    //}

  }, {
    key: 'scrollAnchorReached',
    value: function scrollAnchorReached(action) {
      var _this2 = this;

      this.reportOnce(action, function () {
        _this2.setCustomDimension(CUSTOM_DIMENSIONS.HIT.POST_TEMPLATE, (0, _pageDataObject.get)('post.template'));
        _this2.trackEvent('event', 'Scroll', 'Reached', action.payload.anchor);
      });
    }
  }, {
    key: 'userAuthenticated',
    value: function userAuthenticated(action) {
      if (!action.isReauthenticated) {
        this.trackEvent('event', 'User', 'Logged In', null, null, { sessionControl: 'end' });
        this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, 'loggedIn');
      }
    }
  }, {
    key: 'fbLogin',
    value: function fbLogin(action) {}
  }, {
    key: 'logout',
    value: function logout(action) {
      // on user logged out
      this.trackEvent('event', 'User', 'Logged out', null, null, { sessionControl: 'end' });
      this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, 'loggedOut');
    }
  }, {
    key: 'vote',
    value: function vote(action) {}
  }, {
    key: 'placeBet',
    value: function placeBet(action) {}
  }, {
    key: 'tournamentGetTournamentsFeed',
    value: function tournamentGetTournamentsFeed(_ref5) {
      var numberOfTournaments = _ref5.state.tournaments.length;

      if (numberOfTournaments) {
        this.trackEvent.apply(this, YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS.concat(['view', 'contest widget']));
      }
    }
  }, {
    key: 'tournamentSelectTournament',
    value: function tournamentSelectTournament(action) {
      this.trackEvent.apply(this, YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS.concat(['enter clicked', 'contest widget']));
    }
  }, {
    key: 'tournamentLoadMore',
    value: function tournamentLoadMore(action) {
      this.trackEvent.apply(this, YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS.concat(['show more', 'contest widget']));
    }
  }, {
    key: 'goToMessengerBot',
    value: function goToMessengerBot(_ref6) {
      var displayMessage = _ref6.state.displayMessage;

      this.trackEvent('event', 'FB bot', 'button click', displayMessage);
    }
  }, {
    key: 'reactionsDisplay',
    value: function reactionsDisplay(action) {
      var reactionsCampaign = (0, _pageDataObject.get)('post.reactions.campaign.name', '');
      var buttonLocation = (0, _keys2.default)(action.state.reactionsComponentState)[0];
      this.trackEvent('event', 'Reactions Web ' + reactionsCampaign, 'Reaction Button Click', buttonLocation);
    }
  }, {
    key: 'reactionsSendVote',
    value: function reactionsSendVote(action) {
      var actionState = action.state;

      var reactionsCampaign = (0, _pageDataObject.get)('post.reactions.campaign.name', '');
      var buttonLocation = actionState.componentPosition,
          reactionId = actionState.selectedReaction;

      this.trackEvent('event', 'Reactions Web ' + reactionsCampaign, 'Reaction Selection ' + buttonLocation, reactionId);
    }
  }, {
    key: 'jwplayerEvent',
    value: function jwplayerEvent(action) {}
  }, {
    key: 'setCustomDimension',
    value: function setCustomDimension(dimension, value) {
      googleAnalytics(function () {
        return window.ga('set', dimension, value);
      });
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      args.unshift('send');
      this.logAnalytics.apply(this, args);
      googleAnalytics(function () {
        var _window;

        return (_window = window).ga.apply(_window, args);
      });
    }
  }, {
    key: 'className',
    get: function get() {
      return 'GoogleAnalyticsService';
    }
  }]);
  return GoogleAnalyticsService;
}(_analyticsBaseService2.default);

exports.default = GoogleAnalyticsService;

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _fn = __webpack_require__(15);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _adActions = __webpack_require__(50);

var _mithril = __webpack_require__(54);

var _dom = __webpack_require__(13);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var AdblockDetectorProvider = function (_BaseClass) {
  (0, _inherits3.default)(AdblockDetectorProvider, _BaseClass);

  function AdblockDetectorProvider() {
    (0, _classCallCheck3.default)(this, AdblockDetectorProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdblockDetectorProvider.__proto__ || (0, _getPrototypeOf2.default)(AdblockDetectorProvider)).call(this));

    !(0, _pageDataObject.getIsDraft)() && _this.loadAdblockTestScript();
    return _this;
  }

  (0, _createClass3.default)(AdblockDetectorProvider, [{
    key: 'loadAdblockTestScript',
    value: function loadAdblockTestScript() {
      (0, _mithril.safeRequest)({
        method: 'GET',
        url: 'https://static.minutemediacdn.com/assets/qa4/ads-adblock-test.js',
        deserialize: _fn.identity //This is simply to avoid the warning that the response is not a JSON
      }).then(this.onAdblockTestScriptLoaded.bind(this), this.onAdblockTestScriptError.bind(this));
    }
  }, {
    key: 'onAdblockTestScriptLoaded',
    value: function onAdblockTestScriptLoaded() {
      var ad = this.createDummyAd();
      this.adblockDetected = this.isAdHidden(ad);
      this.onAdblockDetectingFinished();
    }
  }, {
    key: 'createDummyAd',
    value: function createDummyAd() {
      var ad = (0, _dom.createElement)('div');
      ad.id = 'adblock-test';
      ad.setAttribute('class', 'ad-dummy pub_300x250');
      ad.setAttribute('style', 'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important');
      document.body.appendChild(ad);
      return ad;
    }
  }, {
    key: 'isAdHidden',
    value: function isAdHidden(ad) {
      var isHidden = ad.offsetHeight === 0 || ad.offsetWidth === 0;
      if (!isHidden && window.getComputedStyle) {
        var adStyle = window.getComputedStyle(ad, null);
        isHidden = adStyle.getPropertyValue('display') === 'none' || adStyle.getPropertyValue('visibility') === 'hidden';
      }
      return isHidden;
    }
  }, {
    key: 'onAdblockTestScriptError',
    value: function onAdblockTestScriptError(error) {
      // eslint-disable-line handle-callback-err
      this.adblockDetected = true;
      this.onAdblockDetectingFinished();
    }
  }, {
    key: 'onAdblockDetectingFinished',
    value: function onAdblockDetectingFinished() {
      (0, _adActions.adBlockDetectionFinished)({ detected: this.adblockDetected });
    }
  }]);
  return AdblockDetectorProvider;
}(_BaseClass3.default);

var initAdblockDetectorProvider = AdblockDetectorProvider.create.bind(AdblockDetectorProvider);
exports.default = initAdblockDetectorProvider;

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCampaignsFromCampaignManager = undefined;

var _regenerator = __webpack_require__(128);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(183);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _fetch = __webpack_require__(57);

var _window = __webpack_require__(8);

var _pageDataObject = __webpack_require__(5);

var _geolocationProvider = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDate = function getDate() {
  var date = _window.queryString.localTime ? new Date(_window.queryString.localTime) : new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000);
  date.setSeconds(0, 0);
  return date.toJSON();
};

var getLocale = function getLocale() {
  return _window.queryString.language || (0, _pageDataObject.getPageLocale)();
};

var getTags = function getTags() {
  return _window.queryString.tags || (0, _pageDataObject.getPostCategories)().join(',');
};

var getCampaignsFromCampaignManagerService = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(site, country, localTime, locale, tags) {
    var result;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _fetch.getJsonOrError)((0, _pageDataObject.getApiServicesEndpoints)().campaigns + '?site=' + site + '&country=' + country + '&localTime=' + localTime + '&language=' + locale + '&tags=' + tags);

          case 2:
            result = _context.sent;
            return _context.abrupt('return', result.data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getCampaignsFromCampaignManagerService(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var campaignsPromise = null;

var getCampaignsFromCampaignManager = exports.getCampaignsFromCampaignManager = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var countryCode;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _geolocationProvider.getCountryCode)();

          case 2:
            countryCode = _context2.sent;

            if (!campaignsPromise) {
              campaignsPromise = getCampaignsFromCampaignManagerService((0, _pageDataObject.getSite)(), countryCode, getDate(), getLocale(), getTags());
            }

            _context2.next = 6;
            return campaignsPromise;

          case 6:
            return _context2.abrupt('return', _context2.sent);

          case 7:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getCampaignsFromCampaignManager() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
module.exports = __webpack_require__(20).Object.values;

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(40)
  , $values = __webpack_require__(232)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./actionCounterService": 147,
	"./agofService": 148,
	"./analyticsBaseService": 28,
	"./analyticsCounterService": 149,
	"./comscoreService": 150,
	"./facebookAnalyticsService": 151,
	"./googleAnalyticsService": 152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 175;

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NoUpcomingMatches;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'no-upcoming-matches'; /* eslint semi:0 */
function NoUpcomingMatches(_ref) {
  var message = _ref.message;

  return _react2.default.createElement('div', { className: blockName, 'data-message': message });
}

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.scheduleReducer = scheduleReducer;

var _window = __webpack_require__(8);

var _fn = __webpack_require__(15);

var _pageDataObject = __webpack_require__(5);

var _fetchSaga = __webpack_require__(56);

var _scheduleActions = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getInitialLeague() {
  var initialLeagueId = _window.queryString.initialLeagueId;

  if (!initialLeagueId) {
    if ((0, _pageDataObject.getLeaguesForFixtures)().length === 0) {
      return {};
    }
    var _getLeaguesForFixture = (0, _pageDataObject.getLeaguesForFixtures)()[0],
        _leagueId = _getLeaguesForFixture.id,
        _leagueName = _getLeaguesForFixture.name;

    return { leagueId: _leagueId, leagueName: _leagueName };
  }
  var leagueId = +initialLeagueId;
  var leagueData = (0, _pageDataObject.getLeaguesForFixtures)().find(function (league) {
    return league.id === leagueId;
  });
  var leagueName = leagueData.name;

  return { leagueId: leagueId, leagueName: leagueName };
} /* eslint semi:0 */


function getDefaultState() {
  var _getInitialLeague = getInitialLeague(),
      leagueId = _getInitialLeague.leagueId,
      leagueName = _getInitialLeague.leagueName;

  return {
    IS_INITIALIZED: false,
    leagueId: leagueId,
    leagueName: leagueName,
    leaguesForFixtures: (0, _pageDataObject.getLeaguesForFixtures)(),
    numItems: 3,
    scheduleDate: new Date()
  };
}

function setState(state, newState) {
  return (0, _extends3.default)({}, state, newState);
}

function scheduleReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments[1];

  var _memoizeFirstCall = (0, _fn.memoizeFirstCall)('SCHEDULE_FETCH_ACTION_TYPES', _fetchSaga.getNamespacedFetchActionTypes, _scheduleActions.API_ENDPOINT_NAME),
      SCHEDULE_FETCH_ACTION_TYPES = _memoizeFirstCall.SCHEDULE_FETCH_ACTION_TYPES;

  if (SCHEDULE_FETCH_ACTION_TYPES) {
    switch (action.type) {
      case SCHEDULE_FETCH_ACTION_TYPES.FETCH.SUCCESS:
      case SCHEDULE_FETCH_ACTION_TYPES.FETCH.FAILED:
      case _scheduleActions.SCHEDULE_ACTION_TYPES.CHANGE_NUM_VISIBLE_ITEMS:
      case _scheduleActions.SCHEDULE_ACTION_TYPES.CHANGE_LEAGUE:
      case _scheduleActions.SCHEDULE_ACTION_TYPES.CHANGE_SCHEDULE_DATE:
        return setState(state, action.state);
      default:
        return state;
    }
  }
  return setState(state, { IS_ENTRY_POINT_MISSING: true });
}

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ua = __webpack_require__(10);

var _dom = __webpack_require__(13);

function getDeviceTypeClass() {
  if ((0, _ua.getIsDesktop)()) {
    return 'isDesktop';
  }
  return (0, _ua.getIsTablet)() ? 'isTablet' : 'isMobile';
}

(0, _dom.classList)(document.body).add(getDeviceTypeClass(), (0, _ua.getBrowserClassName)());

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LeagueSelection;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var blockName = 'league-selection-component';

function getLeagueNameSelectionOption(leagueName) {
  var optionProps = {
    key: leagueName,
    value: leagueName,
    children: leagueName,
    className: blockName + '__option'
  };
  return _react2.default.createElement('option', optionProps);
}

function LeagueSelection(_ref) {
  var modifier = _ref.modifier,
      leagueNames = _ref.leagues,
      currentLeague = _ref.currentLeague,
      onChangeLeagueHandler = _ref.onChangeLeagueHandler;

  var containerClassName = modifier ? blockName + ' ' + blockName + '--' + modifier : blockName;
  return _react2.default.createElement(
    'div',
    { className: containerClassName },
    _react2.default.createElement(
      'h4',
      { className: blockName + '__title' },
      (0, _i18nProvider.t)('homepage.schedule')
    ),
    _react2.default.createElement(
      'div',
      { className: blockName + '__wrapper' },
      _react2.default.createElement(
        'select',
        {
          value: currentLeague,
          onChange: onChangeLeagueHandler,
          className: blockName + '__league-selection'
        },
        leagueNames.map(getLeagueNameSelectionOption)
      )
    )
  );
}

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MatchWithResult;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'match-result-component';
var teamScoreElement = 'team-score';

function MatchWithResult(_ref) {
  var result = _ref.result;

  return _react2.default.createElement(
    'div',
    { className: blockName + '__container' },
    _react2.default.createElement(
      'span',
      { className: blockName + '__' + teamScoreElement + ' ' + blockName + '__' + teamScoreElement + '--home' },
      result.home
    ),
    _react2.default.createElement(
      'span',
      { className: blockName + '__seperator' },
      ':'
    ),
    _react2.default.createElement(
      'span',
      { className: blockName + '__' + teamScoreElement + ' ' + blockName + '__' + teamScoreElement + '--away' },
      result.away
    )
  );
}

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Team;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'team-component';
function Team(_ref) {
  var name = _ref.name,
      image = _ref.image,
      isHome = _ref.isHome;

  var isHomeClass = isHome ? 'home' : 'away';
  var classNames = blockName + ' ' + blockName + '--' + isHomeClass;
  return _react2.default.createElement(
    'div',
    { className: classNames },
    _react2.default.createElement(
      'div',
      { className: blockName + '__image-container' },
      _react2.default.createElement('img', { src: image, alt: name, className: blockName + '__image' })
    ),
    _react2.default.createElement(
      'p',
      { className: blockName + '__name' },
      name
    )
  );
}

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(9);

var _extends5 = _interopRequireDefault(_extends4);

exports.getLeagueId2Name = getLeagueId2Name;
exports.getLeagueName2Id = getLeagueName2Id;
exports.getLeagueNames = getLeagueNames;

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getLeagueId2Name() {
  return (0, _pageDataObject.getLeaguesForFixtures)().reduce(function (accumulator, curr) {
    return (0, _extends5.default)({}, accumulator, (0, _defineProperty3.default)({}, curr.id, curr.name));
  }, {});
}
function getLeagueName2Id() {
  return (0, _pageDataObject.getLeaguesForFixtures)().reduce(function (accumulator, curr) {
    return (0, _extends5.default)({}, accumulator, (0, _defineProperty3.default)({}, curr.name, curr.id));
  }, {});
}
function getLeagueNames() {
  return (0, _pageDataObject.getLeaguesForFixtures)().map(function (leagueData) {
    return leagueData.name;
  });
}

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.injectElement = injectElement;
exports.logger = logger;

var _console = __webpack_require__(11);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _dom = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INSERTION_ELEMENT_SELECTOR = 'p[data-label]'; /**
                                                   * Injects dom nodes according to configuration. Used by ads and campaigns.
                                                   */

var INSERTION_ELEMENT_SELECTOR_FALLBACK = 'p';
var INSERTION_ELEMENT_NUMBER = 2;
var INJECTED_ELEMENT_DEFAULTS = {
  tagName: 'div',
  className: '',
  dataset: {}
};

function getSelectorMatches(scopeEl, selector) {
  return scopeEl && scopeEl.querySelectorAll(selector);
}

function injectElement() {
  var elementConf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var log = arguments[1];

  var postBodyNode = (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.POST_BODY_SELECTOR);
  var postBodySelectorMatches = getSelectorMatches.bind(postBodyNode, postBodyNode);
  var selectorMatches = postBodySelectorMatches(INSERTION_ELEMENT_SELECTOR);
  if (selectorMatches && selectorMatches.length < INSERTION_ELEMENT_NUMBER) {
    var currentSelector = INSERTION_ELEMENT_SELECTOR_FALLBACK;
    selectorMatches = postBodySelectorMatches(currentSelector);
  }
  if (selectorMatches && selectorMatches.length >= INSERTION_ELEMENT_NUMBER) {
    var injectAfterNode = selectorMatches[INSERTION_ELEMENT_NUMBER - 1];

    var _Object$assign = (0, _assign2.default)({}, INJECTED_ELEMENT_DEFAULTS, elementConf),
        tagName = _Object$assign.tagName,
        className = _Object$assign.className,
        dataset = _Object$assign.dataset;

    var injectedEl = (0, _dom.createElement)(tagName);
    injectedEl.className = className;
    (0, _assign2.default)(injectedEl.dataset, dataset);
    (0, _dom.addElementAfter)(injectedEl, injectAfterNode);
    log('Adding', { injectedEl: injectedEl, injectAfterNode: injectAfterNode, selectorMatches: selectorMatches });
    return true;
  }
  log('Skipping', { elementConf: elementConf, selectorMatches: selectorMatches });
  return false;
}

function logger(shouldLog) {
  for (var _len = arguments.length, messages = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    messages[_key - 1] = arguments[_key];
  }

  shouldLog && _console.info.apply(undefined, messages);
}

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDfpDynamicSlot = initDfpDynamicSlot;

var _window = __webpack_require__(8);

var _injectDynamicContent = __webpack_require__(204);

var _adsConfig = __webpack_require__(27);

var _pageDataObject = __webpack_require__(5);

var adsDebugDynamicSlot = _window.queryString.adsDebugDynamicSlot;

var isNonEmbeddedPostPageOnMobile = (0, _pageDataObject.getIsPostPage)() && !(0, _pageDataObject.getIsEmbededPost)() || (0, _pageDataObject.getIsTopX)() || (0, _pageDataObject.getIsSlideshow)();
var BLOCK = _adsConfig.CLASS_NAMES.BLOCK,
    EMPTY = _adsConfig.CLASS_NAMES.EMPTY,
    INJECTED = _adsConfig.CLASS_NAMES.INJECTED,
    DFP = _adsConfig.CLASS_NAMES.DFP;

var INJECTED_ELEMENT_CONF_DFP_SLOT = {
  className: [BLOCK, INJECTED, EMPTY, DFP].join(' '),
  dataset: {
    slotId: _adsConfig.AD_FORMATS.InArticleDynamic
  }
};

function isDfpDynamicSlotEnabled() {
  return isNonEmbeddedPostPageOnMobile;
}

function initDfpDynamicSlot(config) {
  var dfpLogger = _injectDynamicContent.logger.part(adsDebugDynamicSlot, 'dfpDynamicSlot:');
  if (!isDfpDynamicSlotEnabled()) {
    dfpLogger('disabled', { isDfpDynamicSlotEnabled: isDfpDynamicSlotEnabled, isNonEmbeddedPostPageOnMobile: isNonEmbeddedPostPageOnMobile });
    return false;
  }
  return (0, _injectDynamicContent.injectElement)(INJECTED_ELEMENT_CONF_DFP_SLOT, dfpLogger);
}

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(58);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = initAds;

var _mithril = __webpack_require__(34);

var _dom = __webpack_require__(13);

var _adStore = __webpack_require__(69);

var _window = __webpack_require__(8);

var _fn = __webpack_require__(15);

var _console = __webpack_require__(11);

var _RegularAdView = __webpack_require__(125);

var _RegularAdView2 = _interopRequireDefault(_RegularAdView);

var _InjectedAdView = __webpack_require__(216);

var _InjectedAdView2 = _interopRequireDefault(_InjectedAdView);

var _adsConfig = __webpack_require__(27);

var _providerFactory = __webpack_require__(220);

var _providerFactory2 = _interopRequireDefault(_providerFactory);

var _i18nProvider = __webpack_require__(18);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _ua = __webpack_require__(10);

var _pageDataObject = __webpack_require__(5);

var _initAmazonHeaderBidder = __webpack_require__(141);

var _initAmazonHeaderBidder2 = _interopRequireDefault(_initAmazonHeaderBidder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLIDESHOW_DISABLED_AD_FORMATS = [_adsConfig.AD_FORMATS.Outofpage];
var adsConfig = (0, _pageDataObject.get)('config.ads', __webpack_require__(27));

var EXCLUDED_GEOS_FOR_MOBILE_BOTTOM_SLOT = ['in', 'ar', 'th', 'mx'];
var noAds = _window.queryString.noAds,
    noads = _window.queryString.noads,
    debugAds = _window.queryString.debugAds;


function getAdType(adId) {
  return adsConfig.slot[adId].type;
}

function getAdView(adType) {
  var _AdViewToCreate;

  var AdViewToCreate = void 0;
  switch (adType) {
    case _adsConfig.AD_TYPES.REGULAR:
      AdViewToCreate = _RegularAdView2.default;
      break;
    case _adsConfig.AD_TYPES.INJECTED:
      AdViewToCreate = _InjectedAdView2.default;
      break;
    default:
      AdViewToCreate = _RegularAdView2.default;
  }

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (_AdViewToCreate = AdViewToCreate).create.apply(_AdViewToCreate, args);
}

function isAdsEnabled() {
  var shouldShowAds = _pageDataObject.ads.shouldShowAds;

  var page = (0, _pageDataObject.get)('page', null);
  var areAdsEnabled = !(noAds || noads) && page && !(0, _pageDataObject.getIsDraft)() && shouldShowAds;
  debugAds && (0, _console.info)('areAdsEnabled:', areAdsEnabled, {
    shouldShowAds: shouldShowAds,
    isEmbededPost: (0, _pageDataObject.getIsEmbededPost)(),
    isDraft: (0, _pageDataObject.getIsDraft)(),
    page: page
  });
  return areAdsEnabled;
}

function filterAdsByTypeDeviceAndGeo(adId, countryCode) {
  return EXCLUDED_GEOS_FOR_MOBILE_BOTTOM_SLOT.includes(countryCode.toLowerCase()) && adId === _adsConfig.AD_FORMATS.Bottom && (0, _ua.getIsMobile)();
}

function isSlotEnabledInCountryCode(whiteListedCountryCodes, countryCode) {
  return whiteListedCountryCodes.map(function (s) {
    return s.toLowerCase();
  }).includes(countryCode.toLowerCase());
}

function isDisabledInSlideshow(adId) {
  return (0, _pageDataObject.getIsSlideshow)() && SLIDESHOW_DISABLED_AD_FORMATS.includes(adId);
}

function notShow(adId, countryCode) {
  // eslint-disable-line complexity
  var slotConf = adsConfig.slot[adId];
  if (adId === 'Top' && (0, _ua.getIsMobile)()) {
    return true;
  }
  if (!slotConf) {
    return true;
  }
  var _adsConfig$slot$adId = adsConfig.slot[adId],
      adType = _adsConfig$slot$adId.type,
      slotConfig = _adsConfig$slot$adId.doubleClick,
      isDisabled = _adsConfig$slot$adId.isDisabled,
      enabledInCountryCodes = _adsConfig$slot$adId.enabledInCountryCodes;

  if (isDisabled || adType === _adsConfig.AD_TYPES.VIDEO || filterAdsByTypeDeviceAndGeo(adId, countryCode)) {
    return true;
  }
  if (isDisabledInSlideshow(adId)) {
    return true;
  }
  if (enabledInCountryCodes) {
    if (!isSlotEnabledInCountryCode(enabledInCountryCodes, countryCode)) {
      return true;
    }
  }
  var hideForPlatform = slotConfig.hideForPlatform,
      hideForNonMobile = slotConfig.hideForNonMobile,
      hideForLocale = slotConfig.hideForLocale,
      hideForHorizonalBreakpoint = slotConfig.hideForHorizonalBreakpoint,
      isEnabledInNativeApp = slotConfig.isEnabledInNativeApp;

  var isInDisallowedPlatform = hideForPlatform && (0, _ua.getPlatform)(hideForPlatform);
  var isHideForNonMobile = hideForNonMobile && !(0, _ua.getIsMobile)();
  var isInDisallowedLocale = hideForLocale === _i18nProvider.locale;
  var isHiddenInNativeApp = !isEnabledInNativeApp && (0, _ua.getIsNativeApp)();
  var isInDisallowedViewport = hideForHorizonalBreakpoint && !_ua.viewport.widerThanTabletBreakpoint;
  return isInDisallowedPlatform || isInDisallowedLocale || isInDisallowedViewport || isHideForNonMobile || isHiddenInNativeApp || false;
}

var pageAdSlots = {};

function mountAdComponent(adElement, countryCode) {
  var dataset = adElement.dataset;
  var slotId = dataset.slotId;

  var existingPageSlot = pageAdSlots[slotId];
  if (existingPageSlot) {
    (0, _console.warn)('slotId \'' + slotId + '\' is already mounted! Not mounting again.', {
      newPageSlot: adElement,
      existingPageSlot: existingPageSlot,
      adsConfig: adsConfig,
      newDataset: dataset,
      existingDataset: existingPageSlot.dataset
    });
    return false;
  }
  pageAdSlots[slotId] = adElement;
  if ((0, _fn.makeSafeFn)(notShow).invoke(slotId, countryCode)) {
    return false;
  }
  var adType = (0, _fn.makeSafeFn)(getAdType).invoke(slotId);
  if (!adType) {
    (0, _console.warn)('\'' + adType + '\' is falsy! wat o_O', {
      adElement: adElement,
      adsConfig: adsConfig,
      slotId: slotId
    });
    return false;
  }
  var adConfig = adsConfig.slot[slotId];
  var adView = getAdView(adType, adElement, adConfig, _adStore.adStore);
  if (!adView) {
    (0, _console.warn)('adView is falsy! How does even?', {
      adElement: adElement,
      adsConfig: adsConfig,
      adConfig: adConfig,
      adStore: _adStore.adStore,
      adType: adType,
      adView: adView
    });
    return false;
  }
  var adComponent = {
    view: adView.view.bind(adView),
    controller: _fn.noop
  };
  return (0, _mithril.mount)(adElement, adComponent);
}

function renderSlots(countryCode) {
  var adElements = (0, _dom.nodes)(_preRenderedSelectorsConfig.SELECTORS.AD);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(adElements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var adElement = _step.value;

      mountAdComponent(adElement, countryCode);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if ((0, _initAmazonHeaderBidder.isCountryCodeUnitedStates)(countryCode)) {
    (0, _initAmazonHeaderBidder2.default)();
  }
}

function initConfiant() {
  var script = document.createElement('script');
  script.src = 'https://confiant-integrations.global.ssl.fastly.net/gVg8G70ZiP2pnVNIz9TfdRQopWU/gpt/config.js';
  script.async = true;
  document.head.appendChild(script);
}

function initAds() {
  var isEnabled = isAdsEnabled();
  _adStore.adStore.isAdsEnabled = isEnabled;
  if (isEnabled) {
    if ((0, _pageDataObject.getSite)() !== 'floor8') {
      initConfiant();
    }
    var Provider = _providerFactory2.default.getProvider();
    Provider.create(renderSlots);
  }
  return isEnabled;
}

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initGoogleAds;

var _initAds = __webpack_require__(209);

var _initAds2 = _interopRequireDefault(_initAds);

var _adInjectedDfpDynamicSlotConfig = __webpack_require__(205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initGoogleAds() {
  // initDfpDynamicSlot()
  (0, _initAds2.default)();
}

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initEiExternalScripts = initEiExternalScripts;

var _script = __webpack_require__(19);

var _pageDataObject = __webpack_require__(5);

function loadSocialMinerScript() {
  _script.external.load({
    name: 'socialMiner',
    loadNow: true
  });
}

function loadReactfulScript() {
  _script.external.load({
    name: 'reactful',
    loadNow: true
  });
}

function initEiExternalScripts() {
  if ('ei' === (0, _pageDataObject.getSite)()) {
    loadReactfulScript();
    loadSocialMinerScript();
  }
}

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTheDuelExternalScripts = initTheDuelExternalScripts;

var _script = __webpack_require__(19);

var _pageDataObject = __webpack_require__(5);

function loadAmplitudeScript() {
  _script.external.load({
    name: 'amplitude',
    loadNow: true
  });
}

function initTheDuelExternalScripts() {
  if ('theduel' === (0, _pageDataObject.getSite)()) {
    loadAmplitudeScript();
  }
}

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _adActions = __webpack_require__(50);

var _console = __webpack_require__(11);

var _window3 = __webpack_require__(8);

var _adsConfig = __webpack_require__(27);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _adTargeting = __webpack_require__(85);

var _adTargeting2 = _interopRequireDefault(_adTargeting);

var _ua = __webpack_require__(10);

var _pageDataObject = __webpack_require__(5);

var _initAmazonHeaderBidder = __webpack_require__(141);

var _geolocationProvider = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adsDebugRefresh = _window3.queryString.adsDebugRefresh;


var canSetPageTargeting = true;
var dfpEventCallbacksRegistered = false;

function isPassbackAdType(adType) {
  return adType === _adsConfig.AD_TYPES.PASSBACK;
}

function getDimensionsObj(_ref) {
  var dimensions = _ref.dimensions;

  if ((0, _ua.getIsDesktop)()) {
    return dimensions.desktop;
  }
  if ((0, _ua.getIsMobile)()) {
    return dimensions.mobile;
  }
  var isPortrait = _ua.viewport.isPortrait;

  var tabletDimensions = dimensions[isPortrait ? 'portraitTablet' : 'landscapeTablet'];
  return tabletDimensions || dimensions.mobile;
}

function getDimensions(adData) {
  return getDimensionsObj(adData).map(function (dimensionsObj) {
    return dimensionsObj.valueOf();
  });
}

var isGtagInitialized = false;

function repeat(count) {
  var string = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';

  var padString = '';

  for (var i = 0; i < count; i += 1) {
    padString += string;
  }

  return padString;
}

function padLeft(string, padding) {
  return repeat(Math.max(0, padding)) + string;
}

function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
}
function getGoogleConsent() {
  var googleConsent = getCookie('googlepersonalization');
  if (null !== googleConsent && 'undefined' !== typeof googleConsent) {
    var bstr = atob(googleConsent);
    var inputbits = '';

    for (var i = 0; i < bstr.length; i += 1) {
      var bitString = bstr.charCodeAt(i).toString(2);
      inputbits += padLeft(bitString, 8 - bitString.length);
    }

    // convert to bit string 0s and 1s

    return inputbits[72] === '1' ? 0 : 1;
  }
  return 0;
}

var GoogleTagService = function (_BaseClass) {
  (0, _inherits3.default)(GoogleTagService, _BaseClass);

  function GoogleTagService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, GoogleTagService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleTagService.__proto__ || (0, _getPrototypeOf2.default)(GoogleTagService)).call(this, options));

    var _window = window,
        gTag = _window.googletag;

    _this.merge({
      gTag: gTag = gTag || {}
    });
    gTag.renderedAdsEvents = gTag.renderedAdsEvents || {};
    gTag.cmd = gTag.cmd || [];
    return _this;
  }

  (0, _createClass3.default)(GoogleTagService, [{
    key: 'globalInitGtag',
    value: function globalInitGtag(callback) {
      if (!isGtagInitialized) {
        var _window2 = window,
            gTag = _window2.googletag;

        if (gTag) {
          gTag.cmd.push(function initializePubads() {
            if (!isGtagInitialized) {
              isGtagInitialized = true;
              gTag.pubads().setRequestNonPersonalizedAds(getGoogleConsent());
              var pubads = gTag.pubads;

              pubads().enableAsyncRendering();
              pubads().collapseEmptyDivs(true);
              if ((0, _initAmazonHeaderBidder.isCountryCodeUnitedStates)((0, _geolocationProvider.getLastKnownCountryCode)())) {
                pubads().disableInitialLoad();
              }
              gTag.enableServices();
            }
            callback();
          });
        }
      }
    }
  }, {
    key: 'defineSlot',
    value: function defineSlot(context) {
      var gTag = context.gTag,
          adConf = context.adConf,
          adType = context.adType,
          adFormat = context.adFormat;
      var slotDivId = adConf.slotDivId;

      var isOutOfPage = adConf.isOutOfPage || false;
      var adUnitPath = adConf.adUnitPath;

      adUnitPath = adUnitPath || context.adUnitPath;
      var slots = gTag.slots = gTag.slots || {};
      var slot = void 0;
      var isPassbackSlot = isPassbackAdType(adType);
      var adDimensions = null;
      if (isOutOfPage) {} else if (isPassbackSlot) {
        adDimensions = getDimensions(adConf);
        slot = gTag.pubads().definePassback(adUnitPath, adDimensions);
      } else {
        adDimensions = getDimensions(adConf);
        slot = gTag.defineSlot(adUnitPath, adDimensions, slotDivId);
      }
      if (!slot) {
        (0, _console.warn)('GoogleTagService.defineSlot: googletag.defineSlot() returned null', {
          adUnitPath: adUnitPath,
          adDimensions: adDimensions,
          adConf: adConf,
          context: context,
          isPassbackSlot: isPassbackSlot
        });
        return;
      }
      slots[adFormat] = slot;
      if (!isPassbackSlot) {
        slot.addService(gTag.pubads());
      }
    }
  }, {
    key: 'setTargeting',
    value: function setTargeting() {
      var targeting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (canSetPageTargeting) {
        (0, _adTargeting2.default)(this.gTag, targeting);
        canSetPageTargeting = false;
      }
      return this.gTag;
    }
  }, {
    key: 'resetPageTargetingLimit',
    value: function resetPageTargetingLimit() {
      canSetPageTargeting = true;
      return this;
    }
  }, {
    key: 'refreshSlot',
    value: function refreshSlot(slot) {
      adsDebugRefresh && this.info('Refreshing slot', slot);
      this.setTargeting({ isRefresh: true }).pubads().refresh([slot]);
      return this;
    }
  }, {
    key: 'initSlot',
    value: function initSlot(adConf, adType) {
      var _this2 = this;

      var adFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'DefaultFormat';

      this.merge({
        adFormat: adFormat,
        adConf: adConf,
        adType: adType
      }).gTag.cmd // The way DFP invokes the function prohibits the use of
      // proper 'this', so the argument is a workaround
      .push(function () {
        return _this2.defineSlot(_this2);
      });
      return this;
    }
  }, {
    key: 'registerDfpEventCallbacks',
    value: function registerDfpEventCallbacks(onSlotRenderEnded, onSlotOnload) {
      if (!dfpEventCallbacksRegistered) {
        this.gTag.pubads().addEventListener('slotRenderEnded', onSlotRenderEnded);
        this.gTag.pubads().addEventListener('slotOnload', onSlotOnload);
        dfpEventCallbacksRegistered = true;
      }
    }
  }, {
    key: 'initTargeting',
    value: function initTargeting(adData, adFormat, onSlotRenderEnded, onSlotOnload, adType) {
      var _this3 = this;

      var gTag = this.gTag;

      gTag.cmd.push(function () {
        var currentTag = gTag.slots[adFormat];
        var isPassbackSlot = isPassbackAdType(adType);
        if (!currentTag) {
          (0, _console.warn)('GoogleTagService.initTargeting: no \'' + adFormat + '\' in googletag.slots!', {
            adData: adData,
            adFormat: adFormat,
            adType: adType,
            isPassbackSlot: isPassbackSlot
          });
          return;
        }
        if (!isPassbackSlot) {
          currentTag.clearTargeting();
          //slot level targeting
          currentTag.setTargeting('format', adFormat);
        }
        _this3.registerDfpEventCallbacks(onSlotRenderEnded, onSlotOnload);
        if (!isPassbackSlot) {
          gTag.display(adData.slotDivId);
          setTimeout(function () {
            (0, _adActions.requestingAds)(adFormat);
          }, 0);
        }
      });
      return this;
    }
  }, {
    key: 'slots',
    get: function get() {
      return this.gTag.slots || [];
    }
  }, {
    key: 'renderedAdsEvents',
    get: function get() {
      return this.gTag.renderedAdsEvents;
    }
  }, {
    key: 'adUnitPath',
    get: function get() {
      var hierarchyLevels = _pageDataObject.ads.hierarchyLevels;

      hierarchyLevels.l4 = this.adFormat;
      return hierarchyLevels.toString();
    }
  }]);
  return GoogleTagService;
}(_BaseClass3.default);

exports.default = GoogleTagService;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AdVm = __webpack_require__(217);

var _AdVm2 = _interopRequireDefault(_AdVm);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

var _dom = __webpack_require__(13);

var _window = __webpack_require__(8);

var _adsConfig = __webpack_require__(27);

var _adTargeting = __webpack_require__(85);

var _adTargeting2 = _interopRequireDefault(_adTargeting);

var _adStore = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAdSizes = _window.queryString.debugAdSizes;
var EMPTY = _adsConfig.CLASS_NAMES.EMPTY;


var CLASS_CONSTANTS = {
  AD_WIDTH: 'ad-width',
  AD_HEIGHT: 'ad-height'
};
var AD_WIDTH = CLASS_CONSTANTS.AD_WIDTH,
    AD_HEIGHT = CLASS_CONSTANTS.AD_HEIGHT;

var BaseAdView = function (_BaseView) {
  (0, _inherits3.default)(BaseAdView, _BaseView);

  function BaseAdView(element, adConfig, store) {
    (0, _classCallCheck3.default)(this, BaseAdView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BaseAdView.__proto__ || (0, _getPrototypeOf2.default)(BaseAdView)).apply(this, arguments));

    var adId = element.dataset.slotId;
    var type = adConfig.type;

    var adVm = _AdVm2.default.create({
      adId: adId,
      type: type,
      adConfig: adConfig.doubleClick,
      store: store || _adStore.adStore,
      actions: _adStore.adActions
    });
    _this.merge({
      initialized: false,
      adVm: adVm,
      adId: adId
    });
    adVm.gTagService.globalInitGtag(_adTargeting2.default.part(adVm.gTagService.gTag));
    return _this;
  }

  (0, _createClass3.default)(BaseAdView, [{
    key: 'isEmptySlot',
    value: function isEmptySlot() {
      var _adVm = this.adVm,
          emptySlot = _adVm.emptySlot,
          adSize = _adVm.adSize;
      var width = adSize.width,
          height = adSize.height;

      return emptySlot.isEmpty || !width || !height;
    }
  }, {
    key: 'display',
    value: function display() {
      this.adVm.display();
      return this;
    }
  }, {
    key: 'adSizesClassNames',
    get: function get() {
      if (this.isEmptySlot()) {
        return [EMPTY];
      }
      var _adVm$adSize = this.adVm.adSize,
          width = _adVm$adSize.width,
          height = _adVm$adSize.height;

      return [AD_WIDTH + '--' + width, AD_HEIGHT + '--' + height];
    }
  }, {
    key: 'adClassList',
    get: function get() {
      var currentSlot = this.options;
      var currentSlotClassList = (0, _dom.classList)(currentSlot);
      var classNamesToFilter = [AD_WIDTH, AD_HEIGHT, EMPTY];
      return (0, _from2.default)(currentSlotClassList).filter(function (className) {
        return classNamesToFilter.every(function (classToFilter) {
          return !className.startsWith(classToFilter);
        });
      }).concat(this.adSizesClassNames);
    }
  }, {
    key: 'renderParams',
    get: function get() {
      var adVm = this.adVm;

      var params = {
        attributes: {
          id: adVm.adData.slotDivId
        }
      };
      var currentSlot = this.options;
      debugAdSizes && this.info(currentSlot.dataset.slotId, this.adId, this.adClassList);
      currentSlot.className = this.adClassList.join(' ');
      if (!this.initialized) {
        params.callback = adVm.initAndDisplay.bind(adVm);
      }
      this.initialized = true;
      return params;
    }
  }]);
  return BaseAdView;
}(_BaseView3.default);

exports.default = BaseAdView;

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _i18nProvider = __webpack_require__(18);

var _RegularAdView2 = __webpack_require__(125);

var _RegularAdView3 = _interopRequireDefault(_RegularAdView2);

var _adsConfig = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InjectedAdView = function (_RegularAdView) {
  (0, _inherits3.default)(InjectedAdView, _RegularAdView);

  function InjectedAdView() {
    (0, _classCallCheck3.default)(this, InjectedAdView);
    return (0, _possibleConstructorReturn3.default)(this, (InjectedAdView.__proto__ || (0, _getPrototypeOf2.default)(InjectedAdView)).apply(this, arguments));
  }

  (0, _createClass3.default)(InjectedAdView, [{
    key: 'view',
    value: function view(ctrl) {
      return [(0, _mithril2.default)('h5.' + _adsConfig.CLASS_NAMES.BLOCK + '__title', (0, _i18nProvider.t)('post_page.ad')), (0, _get3.default)(InjectedAdView.prototype.__proto__ || (0, _getPrototypeOf2.default)(InjectedAdView.prototype), 'view', this).call(this, ctrl)];
    }
  }]);
  return InjectedAdView;
}(_RegularAdView3.default);

exports.default = InjectedAdView;

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(126);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _dom = __webpack_require__(13);

var _window2 = __webpack_require__(8);

var _GoogleTagService = __webpack_require__(213);

var _GoogleTagService2 = _interopRequireDefault(_GoogleTagService);

var _adsConfig = __webpack_require__(27);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _ua = __webpack_require__(10);

var _adStore = __webpack_require__(69);

var _adActions = __webpack_require__(50);

var _analyticsActions = __webpack_require__(31);

var _appStore = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAdSizes = _window2.queryString.debugAdSizes,
    debugAdEvents = _window2.queryString.debugAdEvents;
var EMPTY_AD = _adsConfig.CLASS_NAMES.EMPTY;


function isDfpEventSize1x1(dfpEvent) {
  return dfpEvent.size && dfpEvent.size.length > 1 && dfpEvent.size[0] === 1 && dfpEvent.size[1] === 1;
}

function isEmptyAd(dfpEvent) {
  return dfpEvent.isEmpty || isDfpEventSize1x1(dfpEvent);
}

function getAdSlotSizeFromDfpEvent(dfpEvent) {
  var _dfpEvent$size = (0, _slicedToArray3.default)(dfpEvent.size, 2),
      _dfpEvent$size$ = _dfpEvent$size[0],
      width = _dfpEvent$size$ === undefined ? 0 : _dfpEvent$size$,
      _dfpEvent$size$2 = _dfpEvent$size[1],
      height = _dfpEvent$size$2 === undefined ? 0 : _dfpEvent$size$2;

  return { width: width, height: height };
}

function setSizeToZeroIfEmpty(dfpEvent) {
  dfpEvent.size = isEmptyAd(dfpEvent) ? _adStore.EMPTY_SLOT_DIMENSIONS : dfpEvent.size;
}

var AdVm = function (_BaseVm) {
  (0, _inherits3.default)(AdVm, _BaseVm);

  function AdVm() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AdVm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdVm.__proto__ || (0, _getPrototypeOf2.default)(AdVm)).call(this, options));

    var _window = window,
        gTag = _window.googletag;
    var actions = options.actions,
        adId = options.adId,
        adData = options.adConfig,
        type = options.type;

    _this.merge({
      actions: actions,
      adData: adData,
      adId: adId,
      gTag: gTag,
      type: type,
      slotRenderEndedEvents: {}
    });
    _this.gTagService = _GoogleTagService2.default.create();
    return _this;
  }

  (0, _createClass3.default)(AdVm, [{
    key: 'onChange',
    value: function onChange() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        event: { isEmpty: null, slideshowRefreshAction: false, resetPageTargetingLimit: false }
      };
      var adId = payload.adId,
          _payload$event = payload.event,
          isEmpty = _payload$event.isEmpty,
          slideshowRefreshAction = _payload$event.slideshowRefreshAction,
          resetPageTargetingLimit = _payload$event.resetPageTargetingLimit;

      if (isEmpty !== null && adId === this.adId) {
        this.emptySlot = {
          isEmpty: isEmpty,
          adId: adId
        };
      }
      if (slideshowRefreshAction && _adStore.adStore.shouldRefreshSlot) {
        _adStore.adStore.state.topSlotHeight = false;
        this.gTagService.refreshSlot(this.gTagService.slots[this.adId]);
      }
      if (resetPageTargetingLimit) {
        this.gTagService.resetPageTargetingLimit();
      }
      return (0, _get3.default)(AdVm.prototype.__proto__ || (0, _getPrototypeOf2.default)(AdVm.prototype), 'onChange', this).call(this);
    }
  }, {
    key: 'initSlot',
    value: function initSlot() {
      var adId = this.adId,
          type = this.type,
          adData = this.adData;

      this.gTagService.initSlot(adData, type, adId);
      return this;
    }
  }, {
    key: 'display',
    value: function display() {
      this.initTargeting();
      return this;
    }
  }, {
    key: 'initAndDisplay',
    value: function initAndDisplay() {
      var headerAd = (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.HEADER_AD_UNIT);
      this.initSlot().display();
      if (!headerAd) {
        return this;
      }
      if (_adStore.adStore.isAdblockPresent) {
        headerAd.classList.add(EMPTY_AD);
      }

      return this;
    }
  }, {
    key: 'initDisplayAndHideOnTimeOut',
    value: function initDisplayAndHideOnTimeOut(timeout) {
      this.initAndDisplay();
      setTimeout(function hideAdOnTimeout() {
        this.hide();
      }.bind(this), timeout);
      return this;
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.actions.slotHide(this.adId);
      return this;
    }
  }, {
    key: 'normalizeDfpData',
    value: function normalizeDfpData(data) {
      return data !== null ? data : 'none';
    }
  }, {
    key: 'getCustomDimensions',
    value: function getCustomDimensions(dfpEvent) {
      return {
        advertiserId: this.normalizeDfpData(dfpEvent.advertiserId),
        creativeId: this.normalizeDfpData(dfpEvent.creativeId),
        lineItemId: this.normalizeDfpData(dfpEvent.lineItemId),
        sourceAgnosticCreativeId: this.normalizeDfpData(dfpEvent.sourceAgnosticCreativeId),
        sourceAgnosticLineItemId: this.normalizeDfpData(dfpEvent.sourceAgnosticLineItemId),
        yieldGroupIds: this.normalizeDfpData(dfpEvent.yieldGroupIds),
        isBackfill: this.normalizeDfpData(dfpEvent.isBackfill),
        size: this.normalizeDfpData(dfpEvent.size),
        adUnitPath: this.normalizeDfpData(dfpEvent.slot.getAdUnitPath())
      };
    }
  }, {
    key: 'getAdId',
    value: function getAdId(dfpEvent) {
      var slotElementId = dfpEvent.slot.getAdUnitPath();
      var slotElementIdParts = slotElementId.split('/');

      return slotElementIdParts[slotElementIdParts.length - 1];
    }
  }, {
    key: 'shouldReportSlotData',
    value: function shouldReportSlotData(dfpEvent) {
      if ((0, _stringify2.default)(dfpEvent.size) === (0, _stringify2.default)([0, 0])) {
        return true;
      }

      var slotElementId = dfpEvent.slot.getSlotElementId();
      var element = document.getElementById(slotElementId);
      var elementParentHasAdEmptyClass = element.parentElement.classList.contains('ad--empty');
      var elementHasDisplayNoneStyle = element.getAttribute('style').includes('display: none;');

      return !elementParentHasAdEmptyClass && !elementHasDisplayNoneStyle;
    }
  }, {
    key: 'reportSlotDataToGA',
    value: function reportSlotDataToGA(dfpEvent) {
      if (this.shouldReportSlotData(dfpEvent)) {
        var payload = this.getCustomDimensions(dfpEvent);
        var adId = this.getAdId(dfpEvent);
        debugAdEvents && this.info(adId, 'reportSlotDataToGA', payload);
        (0, _appStore.dispatch)((0, _analyticsActions.dfpSlotOnloadEvent)(payload));
      }
    }
  }, {
    key: 'onSlotOnload',
    value: function onSlotOnload(dfpEvent) {
      var adId = this.getAdId(dfpEvent);
      debugAdEvents && this.info(adId, 'onSlotOnload', dfpEvent);
      var slotRenderEndedEvent = this.slotRenderEndedEvents[adId];
      this.reportSlotDataToGA(slotRenderEndedEvent);
    }
  }, {
    key: 'onSlotRenderEnded',
    value: function onSlotRenderEnded(dfpEvent) {
      this.adId = this.getAdId(dfpEvent);
      var adId = this.adId;

      debugAdEvents && this.info(adId, 'onSlotRenderEnded', dfpEvent);
      this.slotRenderEndedEvents[adId] = dfpEvent;

      if (dfpEvent.slot !== this.gTagService.slots[adId]) {
        return this;
      }

      debugAdSizes && this.warn('onSlotRenderEnded:', adId, dfpEvent);

      var isAdEmpty = dfpEvent.isEmpty;

      setSizeToZeroIfEmpty(dfpEvent);
      (0, _adActions.slotRendered)({
        adId: adId,
        isAdEmpty: isAdEmpty,
        size: getAdSlotSizeFromDfpEvent(dfpEvent),
        adRenderedEvent: dfpEvent
      });
      this.gTagService.renderedAdsEvents[adId] = dfpEvent;

      var isAllSlotsRendered = (0, _keys2.default)(this.gTagService.slots).length === (0, _keys2.default)(this.gTagService.renderedAdsEvents).length;

      if (isAllSlotsRendered) {
        // TODO: Remove this bad interstitial hack once the interstitial rendering code is moved from the SLIM to the client JS code
        if (window.__NMinterstitialEventHack) {
          this.gTagService.renderedAdsEvents.Interstitial = window.__NMinterstitialEventHack;
        }
        (0, _adActions.allSlotsRendered)(this.gTagService.renderedAdsEvents);
      }

      return this;
    }
  }, {
    key: 'initTargeting',
    value: function initTargeting() {
      var adId = this.adId,
          adData = this.adData,
          type = this.type;

      this.gTagService.initTargeting(adData, adId, this.onSlotRenderEnded.bind(this), this.onSlotOnload.bind(this), type);
      return this;
    }
  }, {
    key: 'emptySlot',
    get: function get() {
      return (_adStore.adStore.state[this.adId] || {}).emptySlot || false;
    },
    set: function set(emptySlot) {
      _adStore.adStore.state[this.adId] = _adStore.adStore.state[this.adId] || {};
      _adStore.adStore.state[this.adId].emptySlot = emptySlot;
    }
  }, {
    key: 'topHeight',
    get: function get() {
      return _adStore.adStore.state.topSlotHeight;
    }
  }, {
    key: 'adSize',
    get: function get() {
      return (_adStore.adStore.state[this.adId] || {}).adSize || _adStore.EMPTY_SLOT_SIZES_OBJECT;
    }
  }, {
    key: 'stickyConf',
    get: function get() {
      var isStickyOnPlatformMap = this.adData.isSticky || {};
      if (!(0, _keys2.default)(isStickyOnPlatformMap).length) {
        return false;
      }
      var stickyPlatform = void 0;
      if ((0, _ua.getIsTabletInPortrait)()) {
        stickyPlatform = 'portraitTablet';
      } else if ((0, _ua.getIsMobile)()) {
        stickyPlatform = 'mobile';
      } else {
        stickyPlatform = 'desktop';
      }
      return isStickyOnPlatformMap[stickyPlatform];
    }
  }]);
  return AdVm;
}(_BaseVm3.default);

exports.default = AdVm;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoAdsTag = getVideoAdsTag;

var _adTargeting = __webpack_require__(85);

function getVideoAdsTag() {
  window.getVideoTag = _adTargeting.getVideoTag;
}

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DoubleClickProvider = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

var _console = __webpack_require__(11);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _externalScripts = __webpack_require__(52);

var _script = __webpack_require__(19);

var _headerBidderScriptConfig = __webpack_require__(247);

var _geolocationProvider = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAds = _window.queryString.debugAds;


function conditionallyAddHeaderBidderScript(countryCode) {
  var shouldLoadHeaderBidderScript = _externalScripts.externalScriptsConfig.headerBidder.shouldLoad(countryCode);
  (0, _headerBidderScriptConfig.debug)('shouldLoadHeaderBidderScript', shouldLoadHeaderBidderScript);
  return shouldLoadHeaderBidderScript ? new _promise2.default(function headerBidderIsLoadedPromiseResolver(resolve, reject) {
    window[_headerBidderScriptConfig.HB_NAMESAPCE] = {
      jsLoaded: _externalScripts.externalScriptsConfig.headerBidder.afterLoad(resolve, countryCode, _headerBidderScriptConfig.HB_MS_TIMEOUT)
    };
    window[_headerBidderScriptConfig.HB_NAMESAPCE].pagetype = (0, _ua.getIsMobile)() ? 'mobile' : 'desktop';
    (0, _headerBidderScriptConfig.debug)('window.' + _headerBidderScriptConfig.HB_NAMESAPCE + '.pagetype is set to:', window[_headerBidderScriptConfig.HB_NAMESAPCE].pagetype);
    _script.external.load((0, _extends3.default)({}, _externalScripts.externalScriptsConfig.headerBidder, {
      loadNow: true
    }));
  }) : countryCode;
}

function loadDfpScript(callback) {
  return _script.external.load({
    name: _externalScripts.externalScriptsConfig.dfp.name,
    loadNow: true
  })(callback);
}

// Disabled because _base.html.slim has the script already.
function conditionallyAddDfpScript(countryCode, callback) {
  var shouldLoadDfpScript = _externalScripts.externalScriptsConfig.dfp.beforeLoad();
  var callbackWithCountryCode = callback.bind(0, countryCode);
  return shouldLoadDfpScript ? loadDfpScript(callbackWithCountryCode) : callbackWithCountryCode();
}

var DoubleClickProvider = exports.DoubleClickProvider = function (_BaseClass) {
  (0, _inherits3.default)(DoubleClickProvider, _BaseClass);

  function DoubleClickProvider(initAds) {
    (0, _classCallCheck3.default)(this, DoubleClickProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DoubleClickProvider.__proto__ || (0, _getPrototypeOf2.default)(DoubleClickProvider)).call(this));

    (0, _geolocationProvider.getCountryCode)().then(conditionallyAddHeaderBidderScript).then(function (countryCode) {
      return conditionallyAddDfpScript(countryCode, initAds);
    }).catch(conditionallyAddDfpScript.bind(0, _geolocationProvider.NO_LOCATION, initAds));
    debugAds && (0, _console.info)('Initializing DoubleClickProvider with callback', initAds);
    return _this;
  }

  return DoubleClickProvider;
}(_BaseClass3.default);

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getProvider: function getProvider() {
    return __webpack_require__(219).DoubleClickProvider;
  }
};

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinksGroupContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getPath = getPath;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT = '/';

function getPath() {
  return typeof window !== 'undefined' ? window.location.pathname : ROOT;
}

var LinksGroupContainer = exports.LinksGroupContainer = function (_Component) {
  (0, _inherits3.default)(LinksGroupContainer, _Component);

  function LinksGroupContainer(props) {
    (0, _classCallCheck3.default)(this, LinksGroupContainer);
    return (0, _possibleConstructorReturn3.default)(this, (LinksGroupContainer.__proto__ || (0, _getPrototypeOf2.default)(LinksGroupContainer)).call(this, props));
  }

  (0, _createClass3.default)(LinksGroupContainer, [{
    key: 'specific',
    value: function specific(link) {
      if (link.slug !== null) {
        return this.props.block_name + '__list-item' + link.slug;
      }
      return '';
    }
  }, {
    key: 'shouldRemoveLink',
    value: function shouldRemoveLink(link) {
      var path = getPath().split('/').pop();
      return this.props.remove_selected && path !== '/' && link.slug === path;
    }
  }, {
    key: 'getLinkItem',
    value: function getLinkItem(link, index) {
      return _react2.default.createElement(
        'li',
        { key: index, className: this.props.block_name + '__list-item ' + this.specific(link) },
        _react2.default.createElement(
          'a',
          {
            title: link.title,
            href: link.url,
            target: this.props.target,
            className: link.class_name_for_list_item_anchor,
            'data-analytics-event-category': this.props.analytics_event_category,
            'data-analytics-event-action': this.props.analytics_event_action,
            'data-analytics-event-label': link.analytics_event_label_at
          },
          link.image ? _react2.default.createElement('img', {
            src: link.image,
            alt: link.title,
            className: this.props.block_name + '__list-item-image'
          }) : null,
          link.title ? link.title : ''
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'section',
        {
          className: this.props.block_name + '  ' + this.props.block_name + '--' + this.props.modifier
        },
        this.props.header_text ? _react2.default.createElement(
          'h3',
          { className: this.props.block_name + '__title' },
          this.props.header_text
        ) : null,
        _react2.default.createElement(
          'ul',
          { className: this.props.block_name + '__list' },
          this.props.links.map(function (link, index) {
            return _this2.shouldRemoveLink(link) ? null : _this2.getLinkItem(link, index);
          })
        )
      );
    }
  }]);
  return LinksGroupContainer;
}(_react.Component);

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(126);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _string = __webpack_require__(47);

var _window = __webpack_require__(8);

var _analyticsStore = __webpack_require__(51);

var _analyticsStore2 = _interopRequireDefault(_analyticsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var AnalyticsBaseService = function (_BaseVm) {
  (0, _inherits3.default)(AnalyticsBaseService, _BaseVm);

  function AnalyticsBaseService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AnalyticsBaseService);

    options.store = options.store || _analyticsStore2.default.create();

    var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsBaseService.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsBaseService)).call(this, options));

    _this.state.reportOnce = {};
    _this.facebookShare = _this.twitterShare = _this.whatsappShare = _this.socialShare;
    return _this;
  }

  (0, _createClass3.default)(AnalyticsBaseService, [{
    key: 'onChange',
    value: function onChange(action) {
      var legacyActionHandlerName = (0, _string.toCamelCase)(action.type.split(':').pop());
      var actionHandlerName = action.analyticsActionName;
      var actionHandler = this[legacyActionHandlerName] || this[actionHandlerName];
      if (actionHandler instanceof Function) {
        actionHandler.bind(this)(action);
      }
    }
  }, {
    key: 'logAnalytics',
    value: function logAnalytics() {
      if (_window.queryString.showAnalytics) {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        this.info('tracking ' + this.className + ': ', args);
      }
    }
  }, {
    key: 'routeChanged',
    value: function routeChanged(action) {
      this.pageViewed();
    }

    // NOTICE - to identify an action and determine if it was already reported,
    // it does JSON.stringify(action) and uses that as key
    // if an action has properties that contain objects (and not just primitive values)
    // this may not work properly!

  }, {
    key: 'reportOnce',
    value: function reportOnce(action, reportMethod) {
      var reporter = this.className;
      this.state.reportOnce[reporter] = this.state.reportOnce[reporter] || {};
      var actionId = (0, _stringify2.default)(action);
      var wasReported = this.state.reportOnce[reporter][actionId];
      if (!wasReported) {
        reportMethod();
        this.state.reportOnce[reporter][actionId] = true;
      }
    }
  }, {
    key: 'pageViewed',
    value: function pageViewed() {}
  }, {
    key: 'socialShare',
    value: function socialShare() {}
  }, {
    key: 'className',
    get: function get() {
      return 'AnalyticsBaseService';
    }
  }]);
  return AnalyticsBaseService;
}(_BaseVm3.default);

exports.default = AnalyticsBaseService;

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// UMD: https://github.com/umdjs/umd/blob/master/returnExports.js
(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.humanFormat = factory();
	}
}(this, function () {
	'use strict';

	//==================================================================

	function assignBase(dst, src) {
		var prop;
		for (prop in src) {
			if (has(src, prop)) {
				dst[prop] = src[prop];
			}
		}
	}
	function assign(dst, src) {
		var i, n;
		for (i = 0, n = arguments.length; i < n; ++i) {
			src = arguments[i];
			if (src) {
				assignBase(dst, src);
			}
		}
		return dst;
	}

	function compareLongestFirst(a, b) {
		return b.length - a.length;
	}

	function compareSmallestFactorFirst(a, b) {
		return a.factor - b.factor;
	}

	// https://www.npmjs.org/package/escape-regexp
	function escapeRegexp(str) {
		return str.replace(/([.*+?=^!:${}()|[\]\/\\])/g, '\\$1');
	}

	function forEach(arr, iterator) {
		var i, n;
		for (i = 0, n = arr.length; i < n; ++i) {
			iterator(arr[i], i);
		}
	}

	function forOwn(obj, iterator) {
		var prop;
		for (prop in obj) {
			if (has(obj, prop)) {
				iterator(obj[prop], prop);
			}
		}
	}

	var has = (function (hasOwnProperty) {
		return function has(obj, prop) {
			return obj && hasOwnProperty.call(obj, prop);
		};
	})(Object.prototype.hasOwnProperty);

	var toString = (function (toString_) {
		return function toString(val) {
			return toString_.call(val);
		};
	})(Object.prototype.toString);

	function isDefined(val) {
		/* jshint eqnull:true */
		return val != null;
	}

	var isNumber = (function (tag) {
		return function isNumber(value) {
			return (value === value) && (toString(value) === tag);
		};
	})(toString(0));

	var isString = (function (tag) {
		return function isString(value) {
			return (toString(value) === tag);
		};
	})(toString(''));

	function resolve(container, entry) {
		while (isString(entry)) {
			entry = container[entry];
		}
		return entry;
	}

	function round(f, n) {
		if (!n) {
			return Math.round(f);
		}

		var p = Math.pow(10, n);
		return Math.round(f * p) / p;
	}

	//==================================================================

	function Scale(prefixes) {
		this._prefixes = prefixes;

		var escapedPrefixes = [];
		var list = [];
		forOwn(prefixes, function (factor, prefix) {
			escapedPrefixes.push(escapeRegexp(prefix));

			list.push({
				factor: factor,
				prefix: prefix
			});
		});

		list.sort(compareSmallestFactorFirst);
		this._list = list;

		escapedPrefixes.sort(compareLongestFirst);
		this._regexp = new RegExp(
			'^\\s*(\\d+(?:\\.\\d+)?)\\s*(' +
				escapedPrefixes.join('|') +
				')\\s*(.*)\\s*?$',
			'i'
		);
	}

	Scale.create = function Scale$create(prefixesList, base, initExp) {
		var prefixes = {};
		var factor = initExp ? Math.pow(base, initExp) : 1;
		forEach(prefixesList, function (prefix, i) {
			prefixes[prefix] = Math.pow(base, i + (initExp || 0));
			factor *= base;
		});

		return new Scale(prefixes);
	};

	// Binary search to find the greatest index which has a value <=.
	Scale.prototype.findPrefix = function Scale$findPrefix(value) {
		/* jshint bitwise: false */

		var list = this._list;
		var low = 0;
		var high = list.length - 1;

		var mid, current;
		while (low !== high) {
			mid = (low + high + 1) >> 1;
			current = list[mid].factor;

			if (current > value) {
				high = mid - 1;
			} else {
				low = mid;
			}
		}

		return list[low];
	};

	Scale.prototype.parse = function Scale$parse(str, strict) {
		var matches = str.match(this._regexp);

		if (!matches) {
			return null;
		}

		var prefix = matches[2];

		if (!has(this._prefixes, prefix)) {
			if (strict) {
				return null;
			}

			// FIXME
			return null;
		}

		return {
			factor: this._prefixes[prefix],
			prefix: prefix,
			unit: matches[3],
			value: +matches[1]
		};
	};

	//==================================================================

	var scales = {
		// https://en.wikipedia.org/wiki/Binary_prefix
		binary: Scale.create(
			',ki,Mi,Gi,Ti,Pi,Ei,Zi,Yi'.split(','),
			1024
		),

		// https://en.wikipedia.org/wiki/Metric_prefix
		//
		// Not all prefixes are present, only those which are multiple of
		// 1000, because humans usually prefer to see close numbers using
		// the same unit to ease the comparison.
		SI: Scale.create(
			'y,z,a,f,p,n,µ,m,,k,M,G,T,P,E,Z,Y'.split(','),
			1000, -8
		)
	};

	var defaults = {
		scale: 'SI',

		// Strict mode prevents parsing of incorrectly cased prefixes.
		strict: false,

		// Unit to use for formatting.
		unit: '', 

		// Defauls decimals if not specified
		decimals: 2
	};

	function humanFormat(value, opts){
		opts = assign({}, defaults, opts);

		var info = humanFormat$raw(value, opts);
		var suffix = info.prefix + opts.unit;
		return round(info.value, opts.decimals) + (suffix ? ' ' + suffix : '');
	}

	function humanFormat$parse(str, opts) {
		var info = humanFormat$parse$raw(str, opts);

		return info.value * info.factor;
	}

	function humanFormat$parse$raw(str, opts) {
		if (!isString(str)) {
			throw new TypeError('str must be a string');
		}

		// Merge default options.
		opts = assign({}, defaults, opts);

		// Get current scale.
		var scale = resolve(scales, opts.scale);
		if (!scale) {
			throw new Error('missing scale');
		}

		// TODO: the unit should be checked: it might be absent but it
		// should not differ from the one expected.
		//
		// TODO: if multiple units are specified, at least must match and
		// the returned value should be: { value: <value>, unit: matchedUnit }

		var info = scale.parse(str, opts.strict);
		if (!info) {
			throw new Error('cannot parse str');
		}

		return info;
	}

	function humanFormat$raw(value, opts) {
		// Zero is a special case, it never has any prefix.
		if (value === 0) {
			return {
				value: 0,
				prefix: ''
			};
		}

		if (!isNumber(value)) {
			throw new TypeError('value must be a number');
		}

		// Merge default options.
		opts = assign({}, defaults, opts);

		// Get current scale.
		var scale = resolve(scales, opts.scale);
		if (!scale) {
			throw new Error('missing scale');
		}

		var prefix = opts.prefix;
		var factor;
		if (isDefined(prefix)) {
			if (!has(scale._prefixes, prefix)) {
				throw new Error('invalid prefix');
			}

			factor = scale._prefixes[prefix];
		} else {
			var _ref = scale.findPrefix(value);
			prefix = _ref.prefix;
			factor = _ref.factor;
		}

		// Rebase using current factor.
		value /= factor;

		return {
			prefix: prefix,
			value: value
		};
	}

	humanFormat.parse = humanFormat$parse;
	humanFormat$parse.raw = humanFormat$parse$raw;
	humanFormat.raw = humanFormat$raw;
	humanFormat.Scale = Scale;

	return humanFormat;
}));


/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatsItem = StatsItem;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StatsItem(_ref) {
  var children = _ref.children,
      _ref$blockName = _ref.blockName,
      blockName = _ref$blockName === undefined ? 'stats' : _ref$blockName,
      modifier = _ref.modifier;

  var blockElement = blockName + '__item';
  var blockElementModifier = modifier ? blockElement + '--' + modifier : '';
  return _react2.default.createElement(
    'li',
    { className: blockElement + ' ' + blockElementModifier },
    children
  );
}

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

exports.StatsWrapper = StatsWrapper;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _humanFormat = __webpack_require__(280);

var _humanFormat2 = _interopRequireDefault(_humanFormat);

var _StatsItem = __webpack_require__(293);

var _reactUtils = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statsBemModifiers = {
  reads: 'view',
  shares: 'share'
};

function formatNumber(number, opts) {
  return (0, _humanFormat2.default)(Number(number), opts);
}

function statItemView(stat, modifier, key) {
  var statsItemProps = {
    key: key,
    modifier: modifier,
    children: formatNumber(stat, { decimals: 0 })
  };
  return _react2.default.createElement(_StatsItem.StatsItem, statsItemProps);
}

function getStats(stats, modifiers) {
  return (0, _entries2.default)(stats).map(function (_ref, index) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        statName = _ref2[0],
        stat = _ref2[1];

    return statItemView(stat, modifiers[statName], index);
  });
}

function StatsWrapper(_ref3) {
  var children = _ref3.children;

  var blockName = 'stats';
  return _react2.default.createElement(
    'ul',
    { className: blockName },
    (0, _reactUtils.cloneChildrenWithProps)(getStats(children, statsBemModifiers), { blockName: blockName })
  );
}

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postMetadataActions = undefined;

var _console = __webpack_require__(11);

var _actionCounterProviderActions = __webpack_require__(139);

var _currentPostActionCounterProvider = __webpack_require__(91);

var _actionCounterBaseProvider = __webpack_require__(153);

var DATA_RECEIVED = _actionCounterProviderActions.TYPES.DATA_RECEIVED;


function getPostData() {
  return function (dispatch, getState) {
    return (0, _currentPostActionCounterProvider.fetchPostMetadata)().then(function (state) {
      return dispatch({
        type: DATA_RECEIVED,
        state: state
      });
    }).catch(_console.warn);
  };
}

function getSpecificPostReadsData(postId) {
  return function (dispatch, getState) {
    return (0, _actionCounterBaseProvider.fetchCountersIndependent)('Post_' + postId).then(function (state) {
      state.postId = postId;
      return dispatch({
        type: DATA_RECEIVED,
        state: state
      });
    }).catch(_console.warn);
  };
}

var postMetadataActions = exports.postMetadataActions = {
  fetchData: getPostData,
  fetchSpecificData: getSpecificPostReadsData
};

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postMetadataStatsContainer = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = initPostMetadataStats;

var _ua = __webpack_require__(10);

var _reactRedux = __webpack_require__(37);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(60);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _StatsWrapper = __webpack_require__(294);

var _postMetadataReducer = __webpack_require__(297);

var _postMetadataActions = __webpack_require__(295);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var POST_METADATA_STATS_FEATURE_ID = 'PostMetadataStats';
var COMPONENT_NAME = 'statsContainer';
var STATE_KEY = 'postMetadataStats';
var shouldDisplayPostStatsInEmbedLayout = _window.queryString.showReadsCounter,
    debugPostStats = _window.queryString.debugPostStats;
var isEmbedded = _ua.path.isEmbedded;


function fetchPostData(props) {
  var fetchData = props.fetchData,
      fetchSpecificData = props.fetchSpecificData;
  var postId = props.options.dataset.postId;

  if (postId) {
    fetchSpecificData(postId);
  } else {
    fetchData();
  }
}

var PostMetadataStats = function (_React$Component) {
  (0, _inherits3.default)(PostMetadataStats, _React$Component);

  function PostMetadataStats() {
    (0, _classCallCheck3.default)(this, PostMetadataStats);
    return (0, _possibleConstructorReturn3.default)(this, (PostMetadataStats.__proto__ || (0, _getPrototypeOf2.default)(PostMetadataStats)).apply(this, arguments));
  }

  (0, _createClass3.default)(PostMetadataStats, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var IS_OVERRIDE = this.props.IS_OVERRIDE;

      if (!IS_OVERRIDE) {
        fetchPostData(this.props);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var stats = this.props.stats;
      var postId = this.props.options.dataset.postId;

      var statsForComponent = postId ? (0, _extends3.default)({}, stats[postId]) : stats;
      if (debugPostStats) {
        (0, _console.info)('[QS] Rendering component with: ', stats);
      }
      return _react2.default.createElement(
        _StatsWrapper.StatsWrapper,
        null,
        statsForComponent
      );
    }
  }]);
  return PostMetadataStats;
}(_react2.default.Component);

function definePropTypes(component) {
  var bool = _propTypes2.default.bool,
      func = _propTypes2.default.func,
      object = _propTypes2.default.object;

  component.propTypes = {
    stats: object,
    IS_INITIALIZED: bool,
    IS_OVERRIDE: bool,
    mountAction: func
  };
  return component;
}

function mapStatsStateToProps(state) {
  var _state$STATE_KEY = state[STATE_KEY],
      stats = _state$STATE_KEY.stats,
      IS_OVERRIDE = _state$STATE_KEY.IS_OVERRIDE;

  return { stats: stats, IS_OVERRIDE: IS_OVERRIDE };
}

var postMetadataStatsContainer = exports.postMetadataStatsContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStatsStateToProps, _postMetadataActions.postMetadataActions)(definePropTypes(PostMetadataStats)),
  reducer: _postMetadataReducer.postMetadataReducer
};

function shouldMountPostMetadataStats() {
  return (0, _pageDataObject.isSupportedForDomain)(POST_METADATA_STATS_FEATURE_ID) && !isEmbedded || shouldDisplayPostStatsInEmbedLayout;
}

function mountPostMetadataStats() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.POST_METADATA_STATS, postMetadataStatsContainer));
}

function initPostMetadataStats() {
  var shouldMountPostMetadata = shouldMountPostMetadataStats();
  if (shouldMountPostMetadata) {
    mountPostMetadataStats();
  }
  return shouldMountPostMetadata;
}

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.postMetadataReducer = postMetadataReducer;

var _ua = __webpack_require__(10);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _object = __webpack_require__(12);

var _actionCounterProviderActions = __webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldDisplayPostStatsInEmbedLayout = _window.queryString.readsCounter; /* eslint semi:0 */

var DATA_RECEIVED = _actionCounterProviderActions.TYPES.DATA_RECEIVED,
    RECEIVED_ERROR = _actionCounterProviderActions.TYPES.RECEIVED_ERROR;

var STATS = ['reads', 'shares'];
var FILTER_STATS = ['reads'];

function toNumber(string) {
  return parseInt(string, 10);
}

function getQueryStringKey(key) {
  return toNumber(_window.queryString[key]);
}

function isOverride(queryStringStats) {
  return !STATS.some(function (statName) {
    return !(statName in queryStringStats);
  });
}

function mapAllKeysFromQuery(key) {
  return (0, _defineProperty3.default)({}, key, getQueryStringKey(key) || 0);
}

function mapExistingKeysFromQuery(key) {
  var queryStringKey = getQueryStringKey(key);
  return queryStringKey ? (0, _defineProperty3.default)({}, key, queryStringKey) : '';
}

function mapReduceArrayToObject(stats, fn) {
  return stats.map(fn).reduce(function (acc, statObj) {
    return (0, _extends4.default)({}, acc, statObj);
  }, {});
}

function getStatsFromDebugQuery(mapFn) {
  return mapReduceArrayToObject(STATS, mapFn);
}

function parseObjectValuesOrZero(parsedObject, _ref3) {
  var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];

  return (0, _extends4.default)({}, parsedObject, (0, _defineProperty3.default)({}, key, toNumber(value) || 0));
}

function removeZeroValuesFromObject(zeroLessObject, _ref5) {
  var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];

  var newKey = value > 0 ? (0, _defineProperty3.default)({}, key, value) : {};
  return (0, _extends4.default)({}, zeroLessObject, newKey);
}

function queryStatsReducer(filterStats, statsObject) {
  return filterStats.reduce(function (filteredStats, stat) {
    var isUnvalidStat = stat === undefined;
    var validStat = isUnvalidStat ? {} : (0, _defineProperty3.default)({}, stat, statsObject[stat]);
    return (0, _extends4.default)({}, filteredStats, validStat);
  }, {});
}

var parseObjectValues = _object.reduceObjectEntries.part(parseObjectValuesOrZero);
var removeZeroValuePropertiesFromObject = _object.reduceObjectEntries.part(removeZeroValuesFromObject);

function filterStatsByQueryStringOrAll(isStatsInQuery, filterStats) {
  return function (originalStats) {
    return isStatsInQuery ? parseObjectValues(queryStatsReducer(filterStats, originalStats)) : removeZeroValuePropertiesFromObject(parseObjectValues(originalStats));
  };
}

var getFilteredStats = filterStatsByQueryStringOrAll(shouldDisplayPostStatsInEmbedLayout, FILTER_STATS);

function setReceivedState(state, action) {
  var _action$state = action.state,
      reads = _action$state.reads,
      shares = _action$state.shares,
      postId = _action$state.postId;

  var statsCopy = (0, _extends4.default)({}, state.stats);
  if (postId) {
    statsCopy[postId] = (0, _extends4.default)({}, getFilteredStats({ reads: reads, shares: shares }), getStatsFromDebugQuery(mapExistingKeysFromQuery));
  } else {
    statsCopy = (0, _extends4.default)({}, getFilteredStats({ reads: reads, shares: shares }), getStatsFromDebugQuery(mapExistingKeysFromQuery));
  }
  return {
    stats: statsCopy
  };
}

function setState(state, newState) {
  return (0, _extends4.default)({}, state, newState);
}

function recievedData(state, action) {
  if (state.IS_DRAFT) {
    return setState(state, getStatsFromDebugQuery(mapAllKeysFromQuery));
  }
  if (!state.IS_OVERRIDE) {
    return setState(state, setReceivedState(state, action));
  }
  return state;
}

function recievedError(state, action) {
  var error = action.state.error;

  (0, _console.warn)('Error recieving data from external source, check with provier', { error: error, action: action });
  return setState(state, getStatsFromDebugQuery(mapAllKeysFromQuery));
}

var INITIAL_STATE = {
  stats: {},
  IS_OVERRIDE: isOverride(getStatsFromDebugQuery(mapExistingKeysFromQuery)),
  IS_DRAFT: _ua.path.isDraft
};

function postMetadataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case DATA_RECEIVED:
      return recievedData(state, action);
    case RECEIVED_ERROR:
      return recievedError(state, action);
    default:
      return state;
  }
}

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectDestructuringEmpty2 = __webpack_require__(226);

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

exports.default = EmptySchedule;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'schedule-preload';
function EmptySchedule(_ref) {
  (0, _objectDestructuringEmpty3.default)(_ref);

  var itemsArr = [0, 0, 0];
  var items = itemsArr.map(function (item, i) {
    return _react2.default.createElement('div', {
      className: blockName + '__list-item',
      key: i
    });
  });
  return _react2.default.createElement(
    'div',
    { className: blockName + '__container' },
    _react2.default.createElement(
      'div',
      { className: blockName + '__title' },
      'Schedule'
    ),
    _react2.default.createElement(
      'div',
      { className: blockName + '__components-list' },
      items
    )
  );
}

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MatchDate;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'match-date-component';

var MONTH_NAMES_ABBR = (0, _i18nProvider.t)('date.abbr_month_names');
function MatchDate(_ref) {
  var date = _ref.date;

  var day = date.getDate();
  var monthNumber = date.getMonth() + 1;
  var monthShortName = MONTH_NAMES_ABBR[monthNumber];
  var time = _i18nProvider.i18n.l("time.formats.hour_minute", date);
  return _react2.default.createElement(
    'div',
    { className: blockName },
    _react2.default.createElement(
      'div',
      { className: blockName + '__month-and-day-container' },
      _react2.default.createElement(
        'div',
        { className: blockName + '__month' },
        monthShortName
      ),
      _react2.default.createElement(
        'div',
        { className: blockName + '__day' },
        day
      )
    ),
    _react2.default.createElement(
      'div',
      { className: blockName + '__time' },
      time
    )
  );
}

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MatchContainer;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _matchDateHomepage = __webpack_require__(300);

var _matchDateHomepage2 = _interopRequireDefault(_matchDateHomepage);

var _team = __webpack_require__(201);

var _team2 = _interopRequireDefault(_team);

var _matchResult = __webpack_require__(302);

var _matchResult2 = _interopRequireDefault(_matchResult);

var _mobileMatchDate = __webpack_require__(304);

var _mobileMatchDate2 = _interopRequireDefault(_mobileMatchDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'match-container-component';
function MatchContainer(_ref) {
  var homeTeam = _ref.homeTeam,
      awayTeam = _ref.awayTeam,
      result = _ref.result,
      date = _ref.date,
      status = _ref.status;

  return _react2.default.createElement(
    'div',
    { className: blockName },
    _react2.default.createElement(_mobileMatchDate2.default, { date: date }),
    _react2.default.createElement(_matchDateHomepage2.default, { date: date }),
    _react2.default.createElement(
      'div',
      { className: blockName + '__teams-container' },
      _react2.default.createElement(_team2.default, { name: homeTeam.name, image: homeTeam.image }),
      _react2.default.createElement(_matchResult2.default, { result: result, status: status }),
      _react2.default.createElement(_team2.default, { name: awayTeam.name, image: awayTeam.image })
    )
  );
}

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MatchResult;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _matchWithResult = __webpack_require__(200);

var _matchWithResult2 = _interopRequireDefault(_matchWithResult);

var _matchWithoutResult = __webpack_require__(303);

var _matchWithoutResult2 = _interopRequireDefault(_matchWithoutResult);

var _matchTransformUtil = __webpack_require__(122);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPCOMING_MATCH = _matchTransformUtil.MATCH_STATUSES.UPCOMING;

var blockName = 'match-result-component';
function MatchResult(_ref) {
  var result = _ref.result,
      status = _ref.status;

  var isStarted = status !== UPCOMING_MATCH;
  return _react2.default.createElement(
    'div',
    { className: blockName },
    isStarted ? _react2.default.createElement(_matchWithResult2.default, { result: result }) : _react2.default.createElement(_matchWithoutResult2.default, null)
  );
}

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MatchWithoutResult;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'match-result-component';
function MatchWithoutResult() {
  return _react2.default.createElement(
    'div',
    { className: blockName + '__container' },
    _react2.default.createElement(
      'div',
      { className: blockName + '__vs' },
      'vs.'
    )
  );
}

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MobileMatchDate;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'mobile-match-date-component';
var DATE_FORMAT = { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' };
function MobileMatchDate(_ref) {
  var date = _ref.date;

  var dateAndTimeStr = date.toLocaleString(_i18nProvider.locale, DATE_FORMAT);
  return _react2.default.createElement(
    'div',
    { className: blockName },
    dateAndTimeStr
  );
}

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Navigation;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'navigation-component';
function Navigation(_ref) {
  var direction = _ref.direction,
      onClick = _ref.onClick,
      caption = _ref.caption;

  return _react2.default.createElement(
    'button',
    {
      type: 'button',
      onClick: onClick,
      className: blockName + ' ' + blockName + '--' + direction
    },
    caption
  );
}

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ShowMoreButton;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockName = 'show-more-button';
function ShowMoreButton(_ref) {
  var leagueId = _ref.leagueId,
      scoresBaseUrl = _ref.scoresBaseUrl;

  var scoresUrl = scoresBaseUrl + '?initialLeagueId=' + leagueId;
  var textViewAllGames = (0, _i18nProvider.t)('homepage.view_all');
  return _react2.default.createElement(
    'div',
    { className: blockName },
    _react2.default.createElement(
      'a',
      {
        className: blockName + '__button',
        href: scoresUrl,
        title: textViewAllGames
      },
      textViewAllGames
    )
  );
}

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Schedule = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = initSchedule;

var _nukaCarousel = __webpack_require__(373);

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

var _reactRedux = __webpack_require__(37);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _navigation = __webpack_require__(305);

var _navigation2 = _interopRequireDefault(_navigation);

var _scheduleActions = __webpack_require__(109);

var _scheduleReducer = __webpack_require__(177);

var _emptySchedule = __webpack_require__(299);

var _emptySchedule2 = _interopRequireDefault(_emptySchedule);

var _i18nProvider = __webpack_require__(18);

var _showMoreButton = __webpack_require__(306);

var _showMoreButton2 = _interopRequireDefault(_showMoreButton);

var _leagueSelection = __webpack_require__(199);

var _leagueSelection2 = _interopRequireDefault(_leagueSelection);

var _matchItemHomepage = __webpack_require__(301);

var _matchItemHomepage2 = _interopRequireDefault(_matchItemHomepage);

var _noUpcomingMatches = __webpack_require__(176);

var _noUpcomingMatches2 = _interopRequireDefault(_noUpcomingMatches);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _fetchSaga = __webpack_require__(56);

var _pageDataObject = __webpack_require__(5);

var _scheduleHomepageTransformUtil = __webpack_require__(308);

var _mediaQuery = __webpack_require__(322);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var SCHEDULE_FEATURE_ID = 'Schedule';
var STATE_KEY = 'scheduleComponent';
var COMPONENT_NAME = 'ScheduleContainer';
var MATCH_STATUS = {
  FINISHED: 'finished'
};
var NUM_VISIBLE_ITEMS_DESKTOP_WIDE = 3;
var MEDIA_QUERY_TO_NUM_ITEMS = [{ query: (0, _mediaQuery.getMobileQuery)(), items: 1 }, { query: (0, _mediaQuery.getTabletQuery)(), items: 2 }, { query: (0, _mediaQuery.getDesktopQuery)(), items: 2 }, { query: (0, _mediaQuery.getDesktopWideQuery)(), items: NUM_VISIBLE_ITEMS_DESKTOP_WIDE }];

var mediaQueryListeners = [];

var matchesNotFinishedPredicate = function matchesNotFinishedPredicate(match) {
  return match.status !== MATCH_STATUS.FINISHED;
};
var scoresUrl = null;

function getScoresUrl() {
  return scoresUrl || (scoresUrl = (0, _pageDataObject.get)('config.pages_path.fixtures_path', 'scores'));
}

function createNavigationComponent(_ref) {
  var direction = _ref.direction,
      caption = _ref.text,
      onClick = _ref.clickHandler;

  return _react2.default.createElement(_navigation2.default, { direction: direction, caption: caption, onClick: onClick });
}

function getMobileLeagueStartOffset(leagueMatches) {
  var startOffsetWhenAllIsFinished = leagueMatches.length - 1;
  var firstUnfinishedMatchIndex = leagueMatches.findIndex(matchesNotFinishedPredicate);
  return firstUnfinishedMatchIndex === -1 ? startOffsetWhenAllIsFinished : firstUnfinishedMatchIndex;
}

function getLeagueStartOffset(leagueMatches) {
  if ((0, _mediaQuery.getMobileQuery)().matches) {
    return getMobileLeagueStartOffset(leagueMatches);
  }
  var firstUnfinishedMatchIndex = leagueMatches.findIndex(matchesNotFinishedPredicate);
  var lastFinishedMatchIndex = Math.max(0, firstUnfinishedMatchIndex - 1);
  var numVisibleItems = leagueMatches.length - lastFinishedMatchIndex;
  var startOffset = lastFinishedMatchIndex;
  if ((0, _mediaQuery.getDesktopWideQuery)().matches && numVisibleItems < NUM_VISIBLE_ITEMS_DESKTOP_WIDE) {
    startOffset = Math.max(startOffset - 1, 0);
  }
  return startOffset;
}

var Schedule = exports.Schedule = function (_Component) {
  (0, _inherits3.default)(Schedule, _Component);

  function Schedule() {
    (0, _classCallCheck3.default)(this, Schedule);
    return (0, _possibleConstructorReturn3.default)(this, (Schedule.__proto__ || (0, _getPrototypeOf2.default)(Schedule)).apply(this, arguments));
  }

  (0, _createClass3.default)(Schedule, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          IS_INITIALIZED = _props.IS_INITIALIZED,
          IS_ENTRY_POINT_MISSING = _props.IS_ENTRY_POINT_MISSING,
          fetchData = _props.fetchData,
          changeNumVisbileItems = _props.changeNumVisbileItems;

      if (IS_ENTRY_POINT_MISSING) {
        return (0, _fetchSaga.getNoEndpointsErrorMessage)(this);
      }
      if (IS_INITIALIZED) {
        return true;
      }
      fetchData(_scheduleHomepageTransformUtil.transformMatchResponseToHomepageSchedule);
      mediaQueryListeners = [];
      MEDIA_QUERY_TO_NUM_ITEMS.map(function (_ref2) {
        var query = _ref2.query,
            items = _ref2.items;

        var numVisibleItemsChangedListener = changeNumVisbileItems.part(items);
        query.addListener(numVisibleItemsChangedListener);
        mediaQueryListeners.push({ query: query, numVisibleItemsChangedListener: numVisibleItemsChangedListener });
        if (query.matches) {
          numVisibleItemsChangedListener();
        }
      });
      return mediaQueryListeners;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      mediaQueryListeners.map(function (_ref3) {
        var query = _ref3.query,
            listener = _ref3.listener;
        return query.removeListener(listener);
      });
    }
  }, {
    key: 'onLeagueChanged',
    value: function onLeagueChanged(e) {
      var selectedLeague = e.target.value;

      this.props.changeLeague(selectedLeague);
    }
  }, {
    key: 'getShowMoreContent',
    value: function getShowMoreContent(hasMatches) {
      return hasMatches ? this.showMoreButton : _react2.default.createElement('div', null);
    }
  }, {
    key: 'getMatchContainter',
    value: function getMatchContainter(match, key) {
      return _react2.default.createElement(_matchItemHomepage2.default, (0, _extends3.default)({ key: key }, match));
    }
  }, {
    key: 'getMatchesCarousel',
    value: function getMatchesCarousel(_ref4) {
      var blockName = _ref4.blockName,
          currentLeagueMatches = _ref4.currentLeagueMatches,
          offset = _ref4.offset;

      var carouselProps = {
        className: blockName + '__carousel',
        decorators: this.navigationDecorators,
        slidesToShow: this.props.numItems,
        slideIndex: offset,
        children: currentLeagueMatches.map(this.getMatchContainter)
      };
      return _react2.default.createElement(_nukaCarousel2.default, carouselProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          IS_INITIALIZED = _props2.IS_INITIALIZED,
          matches = _props2.matches,
          leagueName = _props2.leagueName;

      if (!IS_INITIALIZED) {
        return _react2.default.createElement(_emptySchedule2.default, null);
      }
      var leagues = matches.leagues;

      var currentLeague = leagues[leagueName];
      var currentLeagueMatches = currentLeague ? currentLeague.matches : [];
      var hasMatches = currentLeagueMatches.length !== 0;
      var offset = hasMatches ? getLeagueStartOffset(currentLeagueMatches) : 0;
      var blockName = 'schedule-component';
      var content = hasMatches ? this.getMatchesCarousel({ blockName: blockName, currentLeagueMatches: currentLeagueMatches, offset: offset }) : this.noUpcomingMatches;
      return _react2.default.createElement(
        'div',
        { className: blockName + '__container' },
        _react2.default.createElement(
          'div',
          { className: blockName + '__container-wrapper' },
          this.leagueSelection,
          _react2.default.createElement(
            'div',
            { className: blockName + '__navigation-container' },
            content
          ),
          this.getShowMoreContent(hasMatches)
        )
      );
    }
  }, {
    key: 'navigationDecorators',
    get: function get() {
      return [{
        component: function component(_ref5) {
          var previousSlide = _ref5.previousSlide;
          return createNavigationComponent({
            direction: 'prev',
            caption: (0, _i18nProvider.t)('common.prev'),
            clickHandler: previousSlide
          });
        },
        position: 'CenterLeft'
      }, {
        component: function component(_ref6) {
          var nextSlide = _ref6.nextSlide;
          return createNavigationComponent({
            direction: 'next',
            caption: (0, _i18nProvider.t)('common.next'),
            clickHandler: nextSlide
          });
        },
        position: 'CenterRight'
      }];
    }
  }, {
    key: 'showMoreButton',
    get: function get() {
      var leagueId = this.props.leagueId;

      var showMoreButtonProps = {
        leagueId: leagueId,
        scoresBaseUrl: getScoresUrl()
      };
      return _react2.default.createElement(_showMoreButton2.default, showMoreButtonProps);
    }
  }, {
    key: 'noUpcomingMatches',
    get: function get() {
      return _react2.default.createElement(_noUpcomingMatches2.default, { message: (0, _i18nProvider.t)('home.no_matches') });
    }
  }, {
    key: 'leagueSelection',
    get: function get() {
      var _props3 = this.props,
          currentLeague = _props3.leagueName,
          matches = _props3.matches;

      var leagueSelectionProps = {
        currentLeague: currentLeague,
        leagues: matches.leagueNamesForSelection,
        onChangeLeagueHandler: this.onLeagueChanged.bind(this)
      };
      return _react2.default.createElement(_leagueSelection2.default, leagueSelectionProps);
    }
  }]);
  return Schedule;
}(_react.Component);

function mapStateToProps(state) {
  var _state$scheduleCompon = state.scheduleComponent,
      IS_INITIALIZED = _state$scheduleCompon.IS_INITIALIZED,
      matches = _state$scheduleCompon.matches,
      leagueName = _state$scheduleCompon.leagueName,
      leagueId = _state$scheduleCompon.leagueId,
      numItems = _state$scheduleCompon.numItems,
      IS_ENTRY_POINT_MISSING = _state$scheduleCompon.IS_ENTRY_POINT_MISSING;

  return {
    IS_INITIALIZED: IS_INITIALIZED,
    IS_ENTRY_POINT_MISSING: IS_ENTRY_POINT_MISSING,
    matches: matches,
    leagueName: leagueName,
    leagueId: leagueId,
    numItems: numItems
  };
}

var ScheduleContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, _scheduleActions.scheduleActions)(Schedule),
  reducer: _scheduleReducer.scheduleReducer
};

function mountSchedule() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.SCHEDULE_COMPONENT, ScheduleContainer));
}

function initSchedule() {
  var shouldMountSchedule = (0, _pageDataObject.isSupportedForDomain)(SCHEDULE_FEATURE_ID);
  if (shouldMountSchedule) {
    mountSchedule();
  }
  return shouldMountSchedule;
}

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformMatchResponseToHomepageSchedule = transformMatchResponseToHomepageSchedule;

var _leagueTransformUtil = __webpack_require__(202);

var _matchTransformUtil = __webpack_require__(122);

var _array = __webpack_require__(101);

function mapCurrentDayLeagueToCurrentDayLeagueMatches(currDayLeague) {
  var leagueId = currDayLeague.league_id,
      currDayLeagueMatches = currDayLeague.matches;

  return currDayLeagueMatches.map(function (match) {
    return { match: match, leagueId: leagueId };
  });
} /* eslint semi:0 */


function mapDayToListOfLeagues(_ref) {
  var currDayLeaguesList = _ref.day_matches;

  return currDayLeaguesList.map(mapCurrentDayLeagueToCurrentDayLeagueMatches);
}

function getFlatMatchesArray(_ref2) {
  var listOfDays = _ref2.matches;

  return (0, _array.flatten)(listOfDays.map(mapDayToListOfLeagues));
}

function reduceMatchesByLeagues(leagueName2LeagueData, currMatch) {
  var leagueId = currMatch.leagueId,
      match = currMatch.match;

  var leagueId2Name = (0, _leagueTransformUtil.getLeagueId2Name)();
  var leagueName = leagueId2Name[leagueId];
  var leagueData = leagueName2LeagueData[leagueName];
  if (!leagueData) {
    leagueData = {
      name: leagueName,
      id: leagueId,
      matches: []
    };
    leagueName2LeagueData[leagueName] = leagueData;
  }
  leagueData.matches.push((0, _matchTransformUtil.transformMatchResponse)(match));
  return leagueName2LeagueData;
}

function transformMatchResponseToHomepageSchedule(matchesData) {
  var flatMatchesArray = getFlatMatchesArray(matchesData);
  var leagues = flatMatchesArray.reduce(reduceMatchesByLeagues, {});
  return {
    matches: {
      leagues: leagues,
      leagueNamesForSelection: (0, _leagueTransformUtil.getLeagueNames)()
    }
  };
}

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initBrowsi;

var _script = __webpack_require__(19);

var _browsiScriptConfig = __webpack_require__(314);

function loadBrowsiScript() {
  _script.external.load({
    name: 'browsi',
    loadNow: true
  });
}
function initBrowsi() {
  if ((0, _browsiScriptConfig.isBrowsiEnabled)()) {
    loadBrowsiScript();
  }
}

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEDIA_QUERIES = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.getMobileQuery = getMobileQuery;
exports.getTabletQuery = getTabletQuery;
exports.getDesktopQuery = getDesktopQuery;
exports.getDesktopWideQuery = getDesktopWideQuery;

var _nm = __webpack_require__(26);

var _object = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEDIA_QUERIES = exports.MEDIA_QUERIES = {
  MOBILE: '(min-width: 320px) and (max-width: 767px)',
  TABLET: '(min-width: 768px) and (max-width: 1023px)',
  DESKTOP: '(min-width: 1024px) and (max-width: 1311px)',
  DESKTOP_WIDE: '(min-width: 1312px)'
};

function getMobileQuery() {
  return window.matchMedia(MEDIA_QUERIES.MOBILE);
}

function getTabletQuery() {
  return window.matchMedia(MEDIA_QUERIES.TABLET);
}

function getDesktopQuery() {
  return window.matchMedia(MEDIA_QUERIES.DESKTOP);
}

function getDesktopWideQuery() {
  return window.matchMedia(MEDIA_QUERIES.DESKTOP_WIDE);
}

var mediaQueryUtils = (0, _assign2.default)((0, _object.create)(), {
  getMobileQuery: getMobileQuery,
  getTabletQuery: getTabletQuery,
  getDesktopQuery: getDesktopQuery,
  getDesktopWideQuery: getDesktopWideQuery,
  MEDIA_QUERIES: MEDIA_QUERIES
});

(0, _nm.registerUtils)({ mediaQueryUtils: mediaQueryUtils });

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["tweenState"] = factory();
	else
		root["tweenState"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/*!*****************!*\
  !*** multi lib ***!
  \*****************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./index.js */169);


/***/ },

/***/ 5:
/*!******************************!*\
  !*** ./~/process/browser.js ***!
  \******************************/
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },

/***/ 169:
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tweenFunctions = __webpack_require__(/*! tween-functions */ 170);
	
	var _tweenFunctions2 = _interopRequireDefault(_tweenFunctions);
	
	var _raf = __webpack_require__(/*! raf */ 171);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	// additive is the new iOS 8 default. In most cases it simulates a physics-
	// looking overshoot behavior (especially with easeInOut. You can test that in
	// the example
	var DEFAULT_STACK_BEHAVIOR = 'ADDITIVE';
	var DEFAULT_EASING = _tweenFunctions.easeInOutQuad;
	var DEFAULT_DURATION = 300;
	var DEFAULT_DELAY = 0;
	
	var stackBehavior = {
	  ADDITIVE: 'ADDITIVE',
	  DESTRUCTIVE: 'DESTRUCTIVE'
	};
	
	var Mixin = {
	  _rafID: null,
	
	  getInitialState: function getInitialState() {
	    return {
	      tweenQueue: []
	    };
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _raf2['default'].cancel(this._rafID);
	    this._rafID = -1;
	  },
	
	  tweenState: function tweenState(path, _ref) {
	    var _this = this;
	
	    var easing = _ref.easing;
	    var duration = _ref.duration;
	    var delay = _ref.delay;
	    var beginValue = _ref.beginValue;
	    var endValue = _ref.endValue;
	    var onEnd = _ref.onEnd;
	    var configSB = _ref.stackBehavior;
	
	    this.setState(function (state) {
	      var cursor = state;
	      var stateName = undefined;
	      // see comment below on pash hash
	      var pathHash = undefined;
	      if (typeof path === 'string') {
	        stateName = path;
	        pathHash = path;
	      } else {
	        for (var i = 0; i < path.length - 1; i++) {
	          cursor = cursor[path[i]];
	        }
	        stateName = path[path.length - 1];
	        pathHash = path.join('|');
	      }
	      // see the reasoning for these defaults at the top of file
	      var newConfig = {
	        easing: easing || DEFAULT_EASING,
	        duration: duration == null ? DEFAULT_DURATION : duration,
	        delay: delay == null ? DEFAULT_DELAY : delay,
	        beginValue: beginValue == null ? cursor[stateName] : beginValue,
	        endValue: endValue,
	        onEnd: onEnd,
	        stackBehavior: configSB || DEFAULT_STACK_BEHAVIOR
	      };
	
	      var newTweenQueue = state.tweenQueue;
	      if (newConfig.stackBehavior === stackBehavior.DESTRUCTIVE) {
	        newTweenQueue = state.tweenQueue.filter(function (item) {
	          return item.pathHash !== pathHash;
	        });
	      }
	
	      // we store path hash, so that during value retrieval we can use hash
	      // comparison to find the path. See the kind of shitty thing you have to
	      // do when you don't have value comparison for collections?
	      newTweenQueue.push({
	        pathHash: pathHash,
	        config: newConfig,
	        initTime: Date.now() + newConfig.delay
	      });
	
	      // sorry for mutating. For perf reasons we don't want to deep clone.
	      // guys, can we please all start using persistent collections so that
	      // we can stop worrying about nonesense like this
	      cursor[stateName] = newConfig.endValue;
	      if (newTweenQueue.length === 1) {
	        _this._rafID = (0, _raf2['default'])(_this._rafCb);
	      }
	
	      // this will also include the above mutated update
	      return { tweenQueue: newTweenQueue };
	    });
	  },
	
	  getTweeningValue: function getTweeningValue(path) {
	    var state = this.state;
	
	    var tweeningValue = undefined;
	    var pathHash = undefined;
	    if (typeof path === 'string') {
	      tweeningValue = state[path];
	      pathHash = path;
	    } else {
	      tweeningValue = state;
	      for (var i = 0; i < path.length; i++) {
	        tweeningValue = tweeningValue[path[i]];
	      }
	      pathHash = path.join('|');
	    }
	    var now = Date.now();
	
	    for (var i = 0; i < state.tweenQueue.length; i++) {
	      var _state$tweenQueue$i = state.tweenQueue[i];
	      var itemPathHash = _state$tweenQueue$i.pathHash;
	      var initTime = _state$tweenQueue$i.initTime;
	      var config = _state$tweenQueue$i.config;
	
	      if (itemPathHash !== pathHash) {
	        continue;
	      }
	
	      var progressTime = now - initTime > config.duration ? config.duration : Math.max(0, now - initTime);
	      // `now - initTime` can be negative if initTime is scheduled in the
	      // future by a delay. In this case we take 0
	
	      // if duration is 0, consider that as jumping to endValue directly. This
	      // is needed because the easing functino might have undefined behavior for
	      // duration = 0
	      var easeValue = config.duration === 0 ? config.endValue : config.easing(progressTime, config.beginValue, config.endValue, config.duration);
	
	      // TODO: some funcs accept a 5th param
	      var contrib = easeValue - config.endValue;
	      tweeningValue += contrib;
	    }
	
	    return tweeningValue;
	  },
	
	  _rafCb: function _rafCb() {
	    var state = this.state;
	    if (state.tweenQueue.length === 0) {
	      return;
	    }
	
	    var now = Date.now();
	    var newTweenQueue = [];
	
	    for (var i = 0; i < state.tweenQueue.length; i++) {
	      var item = state.tweenQueue[i];
	      var initTime = item.initTime;
	      var config = item.config;
	
	      if (now - initTime < config.duration) {
	        newTweenQueue.push(item);
	      } else {
	        config.onEnd && config.onEnd();
	      }
	    }
	
	    // onEnd might trigger a parent callback that removes this component
	    // -1 means we've canceled it in componentWillUnmount
	    if (this._rafID === -1) {
	      return;
	    }
	
	    this.setState({
	      tweenQueue: newTweenQueue
	    });
	
	    this._rafID = (0, _raf2['default'])(this._rafCb);
	  }
	};
	
	exports['default'] = {
	  Mixin: Mixin,
	  easingTypes: _tweenFunctions2['default'],
	  stackBehavior: stackBehavior
	};
	module.exports = exports['default'];

/***/ },

/***/ 170:
/*!************************************!*\
  !*** ./~/tween-functions/index.js ***!
  \************************************/
/***/ function(module, exports) {

	'use strict';
	
	// t: current time, b: beginning value, _c: final value, d: total duration
	var tweenFunctions = {
	  linear: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * t / d + b;
	  },
	  easeInQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t + b;
	  },
	  easeOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (t /= d) * (t - 2) + b;
	  },
	  easeInOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t + b;
	    } else {
	      return -c / 2 * ((--t) * (t - 2) - 1) + b;
	    }
	  },
	  easeInCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t + b;
	  },
	  easeOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	  },
	  easeInOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t + 2) + b;
	    }
	  },
	  easeInQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t + b;
	  },
	  easeOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	  },
	  easeInOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t + b;
	    } else {
	      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	    }
	  },
	  easeInQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t * t + b;
	  },
	  easeOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	  },
	  easeInOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	    }
	  },
	  easeInSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  },
	  easeOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	  },
	  easeInOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	  },
	  easeInExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	  },
	  easeOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	  },
	  easeInOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    if (t === 0) {
	      return b;
	    }
	    if (t === d) {
	      return b + c;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    } else {
	      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	    }
	  },
	  easeInCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	  },
	  easeOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	  },
	  easeInOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    } else {
	      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	    }
	  },
	  easeInElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	  },
	  easeOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	  },
	  easeInOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d / 2) === 2) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * (0.3 * 1.5);
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    if (t < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	    } else {
	      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
	    }
	  },
	  easeInBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * (t /= d) * t * ((s + 1) * t - s) + b;
	  },
	  easeOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	  },
	  easeInOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	    }
	  },
	  easeInBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    v = tweenFunctions.easeOutBounce(d - t, 0, c, d);
	    return c - v + b;
	  },
	  easeOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d) < 1 / 2.75) {
	      return c * (7.5625 * t * t) + b;
	    } else if (t < 2 / 2.75) {
	      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
	    } else if (t < 2.5 / 2.75) {
	      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
	    } else {
	      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
	    }
	  },
	  easeInOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    if (t < d / 2) {
	      v = tweenFunctions.easeInBounce(t * 2, 0, c, d);
	      return v * 0.5 + b;
	    } else {
	      v = tweenFunctions.easeOutBounce(t * 2 - d, 0, c, d);
	      return v * 0.5 + c * 0.5 + b;
	    }
	  }
	};
	
	module.exports = tweenFunctions;


/***/ },

/***/ 171:
/*!************************!*\
  !*** ./~/raf/index.js ***!
  \************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(/*! performance-now */ 172)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 172:
/*!**************************************************!*\
  !*** ./~/performance-now/lib/performance-now.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./~/process/browser.js */ 5)))

/***/ }

/******/ })
});
;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Carousel = __webpack_require__(374);

module.exports = Carousel;


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(116);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(60);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _kwReactTweenState = __webpack_require__(371);

var _kwReactTweenState2 = _interopRequireDefault(_kwReactTweenState);

var _decorators = __webpack_require__(375);

var _decorators2 = _interopRequireDefault(_decorators);

var _objectAssign = __webpack_require__(36);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _exenv = __webpack_require__(369);

var _exenv2 = _interopRequireDefault(_exenv);

var addEvent = function addEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.addEventListener) {
    elem.addEventListener(type, eventHandle, false);
  } else if (elem.attachEvent) {
    elem.attachEvent('on' + type, eventHandle);
  } else {
    elem['on' + type] = eventHandle;
  }
};

var removeEvent = function removeEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.removeEventListener) {
    elem.removeEventListener(type, eventHandle, false);
  } else if (elem.detachEvent) {
    elem.detachEvent('on' + type, eventHandle);
  } else {
    elem['on' + type] = null;
  }
};

var Carousel = _react2['default'].createClass({
  displayName: 'Carousel',

  mixins: [_kwReactTweenState2['default'].Mixin],

  propTypes: {
    afterSlide: _propTypes2['default'].func,
    autoplay: _propTypes2['default'].bool,
    autoplayInterval: _propTypes2['default'].number,
    beforeSlide: _propTypes2['default'].func,
    cellAlign: _propTypes2['default'].oneOf(['left', 'center', 'right']),
    cellSpacing: _propTypes2['default'].number,
    data: _propTypes2['default'].func,
    decorators: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      component: _propTypes2['default'].func,
      position: _propTypes2['default'].oneOf(['TopLeft', 'TopCenter', 'TopRight', 'CenterLeft', 'CenterCenter', 'CenterRight', 'BottomLeft', 'BottomCenter', 'BottomRight']),
      style: _propTypes2['default'].object
    })),
    dragging: _propTypes2['default'].bool,
    easing: _propTypes2['default'].string,
    edgeEasing: _propTypes2['default'].string,
    framePadding: _propTypes2['default'].string,
    frameOverflow: _propTypes2['default'].string,
    initialSlideHeight: _propTypes2['default'].number,
    initialSlideWidth: _propTypes2['default'].number,
    slideIndex: _propTypes2['default'].number,
    slidesToShow: _propTypes2['default'].number,
    slidesToScroll: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].oneOf(['auto'])]),
    slideWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    speed: _propTypes2['default'].number,
    swiping: _propTypes2['default'].bool,
    vertical: _propTypes2['default'].bool,
    width: _propTypes2['default'].string,
    wrapAround: _propTypes2['default'].bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      afterSlide: function afterSlide() {},
      autoplay: false,
      autoplayInterval: 3000,
      beforeSlide: function beforeSlide() {},
      cellAlign: 'left',
      cellSpacing: 0,
      data: function data() {},
      decorators: _decorators2['default'],
      dragging: true,
      easing: 'easeOutCirc',
      edgeEasing: 'easeOutElastic',
      framePadding: '0px',
      frameOverflow: 'hidden',
      slideIndex: 0,
      slidesToScroll: 1,
      slidesToShow: 1,
      slideWidth: 1,
      speed: 500,
      swiping: true,
      vertical: false,
      width: '100%',
      wrapAround: false
    };
  },

  getInitialState: function getInitialState() {
    return {
      currentSlide: this.props.slideIndex,
      dragging: false,
      frameWidth: 0,
      left: 0,
      slideCount: 0,
      slidesToScroll: this.props.slidesToScroll,
      slideWidth: 0,
      top: 0
    };
  },

  componentWillMount: function componentWillMount() {
    this.setInitialDimensions();
  },

  componentDidMount: function componentDidMount() {
    this.setDimensions();
    this.bindEvents();
    this.setExternalData();
    if (this.props.autoplay) {
      this.startAutoplay();
    }
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState({
      slideCount: nextProps.children.length
    });
    this.setDimensions(nextProps);
    if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide) {
      this.goToSlide(nextProps.slideIndex);
    }
    if (this.props.autoplay !== nextProps.autoplay) {
      if (nextProps.autoplay) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    this.unbindEvents();
    this.stopAutoplay();
  },

  render: function render() {
    var self = this;
    var children = _react2['default'].Children.count(this.props.children) > 1 ? this.formatChildren(this.props.children) : this.props.children;
    return _react2['default'].createElement(
      'div',
      {
        className: ['slider', this.props.className || ''].join(' '),
        ref: 'slider',
        style: (0, _objectAssign2['default'])(this.getSliderStyles(), this.props.style || {})
      },
      _react2['default'].createElement(
        'div',
        _extends({
          className: 'slider-frame',
          ref: 'frame',
          style: this.getFrameStyles()
        }, this.getTouchEvents(), this.getMouseEvents(), {
          onClick: this.handleClick
        }),
        _react2['default'].createElement(
          'ul',
          { className: 'slider-list', ref: 'list', style: this.getListStyles() },
          children
        )
      ),
      this.props.decorators ? this.props.decorators.map(function (Decorator, index) {
        return _react2['default'].createElement(
          'div',
          {
            style: (0, _objectAssign2['default'])(self.getDecoratorStyles(Decorator.position), Decorator.style || {}),
            className: 'slider-decorator-' + index,
            key: index
          },
          _react2['default'].createElement(Decorator.component, {
            currentSlide: self.state.currentSlide,
            slideCount: self.state.slideCount,
            frameWidth: self.state.frameWidth,
            slideWidth: self.state.slideWidth,
            slidesToScroll: self.state.slidesToScroll,
            cellSpacing: self.props.cellSpacing,
            slidesToShow: self.props.slidesToShow,
            wrapAround: self.props.wrapAround,
            nextSlide: self.nextSlide,
            previousSlide: self.previousSlide,
            goToSlide: self.goToSlide
          })
        );
      }) : null,
      _react2['default'].createElement('style', {
        type: 'text/css',
        dangerouslySetInnerHTML: { __html: self.getStyleTagStyles() }
      })
    );
  },

  // Touch Events

  touchObject: {},

  getTouchEvents: function getTouchEvents() {
    var self = this;

    if (self.props.swiping === false) {
      return null;
    }

    return {
      onTouchStart: function onTouchStart(e) {
        self.touchObject = {
          startX: e.touches[0].pageX,
          startY: e.touches[0].pageY
        };
        self.handleMouseOver();
      },
      onTouchMove: function onTouchMove(e) {
        var direction = self.swipeDirection(self.touchObject.startX, e.touches[0].pageX, self.touchObject.startY, e.touches[0].pageY);

        if (direction !== 0) {
          e.preventDefault();
        }

        var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - self.touchObject.startX, 2)));

        self.touchObject = {
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
          endX: e.touches[0].pageX,
          endY: e.touches[0].pageY,
          length: length,
          direction: direction
        };

        self.setState({
          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
        });
      },
      onTouchEnd: function onTouchEnd(e) {
        self.handleSwipe(e);
        self.handleMouseOut();
      },
      onTouchCancel: function onTouchCancel(e) {
        self.handleSwipe(e);
      }
    };
  },

  clickSafe: true,

  getMouseEvents: function getMouseEvents() {
    var self = this;

    if (this.props.dragging === false) {
      return null;
    }

    return {
      onMouseOver: function onMouseOver() {
        self.handleMouseOver();
      },
      onMouseOut: function onMouseOut() {
        self.handleMouseOut();
      },
      onMouseDown: function onMouseDown(e) {
        self.touchObject = {
          startX: e.clientX,
          startY: e.clientY
        };

        self.setState({
          dragging: true
        });
      },
      onMouseMove: function onMouseMove(e) {
        if (!self.state.dragging) {
          return;
        }

        var direction = self.swipeDirection(self.touchObject.startX, e.clientX, self.touchObject.startY, e.clientY);

        if (direction !== 0) {
          e.preventDefault();
        }

        var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - self.touchObject.startX, 2)));

        self.touchObject = {
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
          endX: e.clientX,
          endY: e.clientY,
          length: length,
          direction: direction
        };

        self.setState({
          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
        });
      },
      onMouseUp: function onMouseUp(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      },
      onMouseLeave: function onMouseLeave(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      }
    };
  },

  handleMouseOver: function handleMouseOver() {
    if (this.props.autoplay) {
      this.autoplayPaused = true;
      this.stopAutoplay();
    }
  },

  handleMouseOut: function handleMouseOut() {
    if (this.props.autoplay && this.autoplayPaused) {
      this.startAutoplay();
      this.autoplayPaused = null;
    }
  },

  handleClick: function handleClick(e) {
    if (this.clickSafe === true) {
      e.preventDefault();
      e.stopPropagation();

      if (e.nativeEvent) {
        e.nativeEvent.stopPropagation();
      }
    }
  },

  handleSwipe: function handleSwipe(e) {
    if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
      this.clickSafe = true;
    } else {
      this.clickSafe = false;
    }

    var slidesToShow = this.props.slidesToShow;
    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = this.state.slidesToScroll;
    }

    if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
      if (this.touchObject.direction === 1) {
        if (this.state.currentSlide >= _react2['default'].Children.count(this.props.children) - slidesToShow && !this.props.wrapAround) {
          this.animateSlide(_kwReactTweenState2['default'].easingTypes[this.props.edgeEasing]);
        } else {
          this.nextSlide();
        }
      } else if (this.touchObject.direction === -1) {
        if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
          this.animateSlide(_kwReactTweenState2['default'].easingTypes[this.props.edgeEasing]);
        } else {
          this.previousSlide();
        }
      }
    } else {
      this.goToSlide(this.state.currentSlide);
    }

    this.touchObject = {};

    this.setState({
      dragging: false
    });
  },

  swipeDirection: function swipeDirection(x1, x2, y1, y2) {
    var xDist, yDist, r, swipeAngle;

    xDist = x1 - x2;
    yDist = y1 - y2;
    r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return 1;
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return 1;
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return -1;
    }
    if (this.props.vertical === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 1;
      } else {
        return -1;
      }
    }
    return 0;
  },

  autoplayIterator: function autoplayIterator() {
    if (this.props.wrapAround) {
      return this.nextSlide();
    }
    if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
      this.nextSlide();
    } else {
      this.stopAutoplay();
    }
  },

  startAutoplay: function startAutoplay() {
    this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
  },

  resetAutoplay: function resetAutoplay() {
    if (this.props.autoplay && !this.autoplayPaused) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  },

  stopAutoplay: function stopAutoplay() {
    this.autoplayID && clearInterval(this.autoplayID);
  },

  // Action Methods

  goToSlide: function goToSlide(index) {
    var self = this;
    if (index >= _react2['default'].Children.count(this.props.children) || index < 0) {
      if (!this.props.wrapAround) {
        return;
      }
      if (index >= _react2['default'].Children.count(this.props.children)) {
        this.props.beforeSlide(this.state.currentSlide, 0);
        return this.setState({
          currentSlide: 0
        }, function () {
          self.animateSlide(null, null, self.getTargetLeft(null, index), function () {
            self.animateSlide(null, 0.01);
            self.props.afterSlide(0);
            self.resetAutoplay();
            self.setExternalData();
          });
        });
      } else {
        var endSlide = _react2['default'].Children.count(this.props.children) - this.state.slidesToScroll;
        this.props.beforeSlide(this.state.currentSlide, endSlide);
        return this.setState({
          currentSlide: endSlide
        }, function () {
          self.animateSlide(null, null, self.getTargetLeft(null, index), function () {
            self.animateSlide(null, 0.01);
            self.props.afterSlide(endSlide);
            self.resetAutoplay();
            self.setExternalData();
          });
        });
      }
    }

    this.props.beforeSlide(this.state.currentSlide, index);

    if (index !== this.state.currentSlide) {
      this.props.afterSlide(index);
    }
    this.setState({
      currentSlide: index
    }, function () {
      self.animateSlide();
      self.resetAutoplay();
      self.setExternalData();
    });
  },

  nextSlide: function nextSlide() {
    var childrenCount = _react2['default'].Children.count(this.props.children);
    var slidesToShow = this.props.slidesToShow;
    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = this.state.slidesToScroll;
    }
    if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround) {
      return;
    }

    if (this.props.wrapAround) {
      this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
    } else {
      if (this.props.slideWidth !== 1) {
        return this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
      }
      this.goToSlide(Math.min(this.state.currentSlide + this.state.slidesToScroll, childrenCount - slidesToShow));
    }
  },

  previousSlide: function previousSlide() {
    if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
      return;
    }

    if (this.props.wrapAround) {
      this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
    } else {
      this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
    }
  },

  // Animation

  animateSlide: function animateSlide(easing, duration, endValue, callback) {
    this.tweenState(this.props.vertical ? 'top' : 'left', {
      easing: easing || _kwReactTweenState2['default'].easingTypes[this.props.easing],
      duration: duration || this.props.speed,
      endValue: endValue || this.getTargetLeft(),
      onEnd: callback || null
    });
  },

  getTargetLeft: function getTargetLeft(touchOffset, slide) {
    var offset;
    var target = slide || this.state.currentSlide;
    switch (this.props.cellAlign) {
      case 'left':
        {
          offset = 0;
          offset -= this.props.cellSpacing * target;
          break;
        }
      case 'center':
        {
          offset = (this.state.frameWidth - this.state.slideWidth) / 2;
          offset -= this.props.cellSpacing * target;
          break;
        }
      case 'right':
        {
          offset = this.state.frameWidth - this.state.slideWidth;
          offset -= this.props.cellSpacing * target;
          break;
        }
    }

    var left = this.state.slideWidth * target;

    var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;

    if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
      left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
      offset = 0;
      offset -= this.props.cellSpacing * (this.state.slideCount - 1);
    }

    offset -= touchOffset || 0;

    return (left - offset) * -1;
  },

  // Bootstrapping

  bindEvents: function bindEvents() {
    var self = this;
    if (_exenv2['default'].canUseDOM) {
      addEvent(window, 'resize', self.onResize);
      addEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },

  onResize: function onResize() {
    this.setDimensions();
  },

  onReadyStateChange: function onReadyStateChange() {
    this.setDimensions();
  },

  unbindEvents: function unbindEvents() {
    var self = this;
    if (_exenv2['default'].canUseDOM) {
      removeEvent(window, 'resize', self.onResize);
      removeEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },

  formatChildren: function formatChildren(children) {
    var self = this;
    var positionValue = this.props.vertical ? this.getTweeningValue('top') : this.getTweeningValue('left');
    return _react2['default'].Children.map(children, function (child, index) {
      return _react2['default'].createElement(
        'li',
        {
          className: 'slider-slide',
          style: self.getSlideStyles(index, positionValue),
          key: index
        },
        child
      );
    });
  },

  setInitialDimensions: function setInitialDimensions() {
    var self = this,
        slideWidth,
        frameHeight,
        slideHeight;

    slideWidth = this.props.vertical ? this.props.initialSlideHeight || 0 : this.props.initialSlideWidth || 0;
    slideHeight = this.props.initialSlideHeight ? this.props.initialSlideHeight * this.props.slidesToShow : 0;

    frameHeight = slideHeight + this.props.cellSpacing * (this.props.slidesToShow - 1);

    this.setState({
      slideHeight: slideHeight,
      frameWidth: this.props.vertical ? frameHeight : '100%',
      slideCount: _react2['default'].Children.count(this.props.children),
      slideWidth: slideWidth
    }, function () {
      self.setLeft();
      self.setExternalData();
    });
  },

  setDimensions: function setDimensions(props) {
    props = props || this.props;

    var self = this,
        slideWidth,
        slidesToScroll,
        firstSlide,
        frame,
        frameWidth,
        frameHeight,
        slideHeight;

    slidesToScroll = props.slidesToScroll;
    frame = this.refs.frame;
    firstSlide = frame.childNodes[0].childNodes[0];
    if (firstSlide) {
      firstSlide.style.height = 'auto';
      slideHeight = this.props.vertical ? firstSlide.offsetHeight * props.slidesToShow : firstSlide.offsetHeight;
    } else {
      slideHeight = 100;
    }

    if (typeof props.slideWidth !== 'number') {
      slideWidth = parseInt(props.slideWidth);
    } else {
      if (props.vertical) {
        slideWidth = slideHeight / props.slidesToShow * props.slideWidth;
      } else {
        slideWidth = frame.offsetWidth / props.slidesToShow * props.slideWidth;
      }
    }

    if (!props.vertical) {
      slideWidth -= props.cellSpacing * ((100 - 100 / props.slidesToShow) / 100);
    }

    frameHeight = slideHeight + props.cellSpacing * (props.slidesToShow - 1);
    frameWidth = props.vertical ? frameHeight : frame.offsetWidth;

    if (props.slidesToScroll === 'auto') {
      slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
    }

    this.setState({
      slideHeight: slideHeight,
      frameWidth: frameWidth,
      slideWidth: slideWidth,
      slidesToScroll: slidesToScroll,
      left: props.vertical ? 0 : this.getTargetLeft(),
      top: props.vertical ? this.getTargetLeft() : 0
    }, function () {
      self.setLeft();
    });
  },

  setLeft: function setLeft() {
    this.setState({
      left: this.props.vertical ? 0 : this.getTargetLeft(),
      top: this.props.vertical ? this.getTargetLeft() : 0
    });
  },

  // Data

  setExternalData: function setExternalData() {
    if (this.props.data) {
      this.props.data();
    }
  },

  // Styles

  getListStyles: function getListStyles() {
    var listWidth = this.state.slideWidth * _react2['default'].Children.count(this.props.children);
    var spacingOffset = this.props.cellSpacing * _react2['default'].Children.count(this.props.children);
    var transform = 'translate3d(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px, 0)';
    return {
      transform: transform,
      WebkitTransform: transform,
      msTransform: 'translate(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px)',
      position: 'relative',
      display: 'block',
      margin: this.props.vertical ? this.props.cellSpacing / 2 * -1 + 'px 0px' : '0px ' + this.props.cellSpacing / 2 * -1 + 'px',
      padding: 0,
      height: this.props.vertical ? listWidth + spacingOffset : this.state.slideHeight,
      width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
      cursor: this.state.dragging === true ? 'pointer' : 'inherit',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box'
    };
  },

  getFrameStyles: function getFrameStyles() {
    return {
      position: 'relative',
      display: 'block',
      overflow: this.props.frameOverflow,
      height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
      margin: this.props.framePadding,
      padding: 0,
      transform: 'translate3d(0, 0, 0)',
      WebkitTransform: 'translate3d(0, 0, 0)',
      msTransform: 'translate(0, 0)',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box'
    };
  },

  getSlideStyles: function getSlideStyles(index, positionValue) {
    var targetPosition = this.getSlideTargetPosition(index, positionValue);
    return {
      position: 'absolute',
      left: this.props.vertical ? 0 : targetPosition,
      top: this.props.vertical ? targetPosition : 0,
      display: this.props.vertical ? 'block' : 'inline-block',
      listStyleType: 'none',
      verticalAlign: 'top',
      width: this.props.vertical ? '100%' : this.state.slideWidth,
      height: 'auto',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
      marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto'
    };
  },

  getSlideTargetPosition: function getSlideTargetPosition(index, positionValue) {
    var slidesToShow = this.state.frameWidth / this.state.slideWidth;
    var targetPosition = (this.state.slideWidth + this.props.cellSpacing) * index;
    var end = (this.state.slideWidth + this.props.cellSpacing) * slidesToShow * -1;

    if (this.props.wrapAround) {
      var slidesBefore = Math.ceil(positionValue / this.state.slideWidth);
      if (this.state.slideCount - slidesBefore <= index) {
        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount - index) * -1;
      }

      var slidesAfter = Math.ceil((Math.abs(positionValue) - Math.abs(end)) / this.state.slideWidth);

      if (this.state.slideWidth !== 1) {
        slidesAfter = Math.ceil((Math.abs(positionValue) - this.state.slideWidth) / this.state.slideWidth);
      }

      if (index <= slidesAfter - 1) {
        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount + index);
      }
    }

    return targetPosition;
  },

  getSliderStyles: function getSliderStyles() {
    return {
      position: 'relative',
      display: 'block',
      width: this.props.width,
      height: 'auto',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      visibility: this.state.slideWidth ? 'visible' : 'hidden'
    };
  },

  getStyleTagStyles: function getStyleTagStyles() {
    return '.slider-slide > img {width: 100%; display: block;}';
  },

  getDecoratorStyles: function getDecoratorStyles(position) {
    switch (position) {
      case 'TopLeft':
        {
          return {
            position: 'absolute',
            top: 0,
            left: 0
          };
        }
      case 'TopCenter':
        {
          return {
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            WebkitTransform: 'translateX(-50%)',
            msTransform: 'translateX(-50%)'
          };
        }
      case 'TopRight':
        {
          return {
            position: 'absolute',
            top: 0,
            right: 0
          };
        }
      case 'CenterLeft':
        {
          return {
            position: 'absolute',
            top: '50%',
            left: 0,
            transform: 'translateY(-50%)',
            WebkitTransform: 'translateY(-50%)',
            msTransform: 'translateY(-50%)'
          };
        }
      case 'CenterCenter':
        {
          return {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            WebkitTransform: 'translate(-50%, -50%)',
            msTransform: 'translate(-50%, -50%)'
          };
        }
      case 'CenterRight':
        {
          return {
            position: 'absolute',
            top: '50%',
            right: 0,
            transform: 'translateY(-50%)',
            WebkitTransform: 'translateY(-50%)',
            msTransform: 'translateY(-50%)'
          };
        }
      case 'BottomLeft':
        {
          return {
            position: 'absolute',
            bottom: 0,
            left: 0
          };
        }
      case 'BottomCenter':
        {
          return {
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            WebkitTransform: 'translateX(-50%)',
            msTransform: 'translateX(-50%)'
          };
        }
      case 'BottomRight':
        {
          return {
            position: 'absolute',
            bottom: 0,
            right: 0
          };
        }
      default:
        {
          return {
            position: 'absolute',
            top: 0,
            left: 0
          };
        }
    }
  }
});

Carousel.ControllerMixin = {
  getInitialState: function getInitialState() {
    return {
      carousels: {}
    };
  },
  setCarouselData: function setCarouselData(carousel) {
    var data = this.state.carousels;
    data[carousel] = this.refs[carousel];
    this.setState({
      carousels: data
    });
  }
};

exports['default'] = Carousel;
module.exports = exports['default'];

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var DefaultDecorators = [{
  component: _react2['default'].createClass({
    displayName: 'component',

    render: function render() {
      return _react2['default'].createElement(
        'button',
        {
          style: this.getButtonStyles(this.props.currentSlide === 0 && !this.props.wrapAround),
          onClick: this.handleClick },
        'PREV'
      );
    },
    handleClick: function handleClick(e) {
      e.preventDefault();
      this.props.previousSlide();
    },
    getButtonStyles: function getButtonStyles(disabled) {
      return {
        border: 0,
        background: 'rgba(0,0,0,0.4)',
        color: 'white',
        padding: 10,
        outline: 0,
        opacity: disabled ? 0.3 : 1,
        cursor: 'pointer'
      };
    }
  }),
  position: 'CenterLeft'
}, {
  component: _react2['default'].createClass({
    displayName: 'component',

    render: function render() {
      return _react2['default'].createElement(
        'button',
        {
          style: this.getButtonStyles(this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround),
          onClick: this.handleClick },
        'NEXT'
      );
    },
    handleClick: function handleClick(e) {
      e.preventDefault();
      this.props.nextSlide();
    },
    getButtonStyles: function getButtonStyles(disabled) {
      return {
        border: 0,
        background: 'rgba(0,0,0,0.4)',
        color: 'white',
        padding: 10,
        outline: 0,
        opacity: disabled ? 0.3 : 1,
        cursor: 'pointer'
      };
    }
  }),
  position: 'CenterRight'
}, {
  component: _react2['default'].createClass({
    displayName: 'component',

    render: function render() {
      var self = this;
      var indexes = this.getIndexes(self.props.slideCount, self.props.slidesToScroll);
      return _react2['default'].createElement(
        'ul',
        { style: self.getListStyles() },
        indexes.map(function (index) {
          return _react2['default'].createElement(
            'li',
            { style: self.getListItemStyles(), key: index },
            _react2['default'].createElement(
              'button',
              {
                style: self.getButtonStyles(self.props.currentSlide === index),
                onClick: self.props.goToSlide.bind(null, index) },
              '•'
            )
          );
        })
      );
    },
    getIndexes: function getIndexes(count, inc) {
      var arr = [];
      for (var i = 0; i < count; i += inc) {
        arr.push(i);
      }
      return arr;
    },
    getListStyles: function getListStyles() {
      return {
        position: 'relative',
        margin: 0,
        top: -10,
        padding: 0
      };
    },
    getListItemStyles: function getListItemStyles() {
      return {
        listStyleType: 'none',
        display: 'inline-block'
      };
    },
    getButtonStyles: function getButtonStyles(active) {
      return {
        border: 0,
        background: 'transparent',
        color: 'black',
        cursor: 'pointer',
        padding: 10,
        outline: 0,
        fontSize: 24,
        opacity: active ? 1 : 0.5
      };
    }
  }),
  position: 'BottomCenter'
}];

exports['default'] = DefaultDecorators;
module.exports = exports['default'];

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEART_BEAT_PERIOD = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _values = __webpack_require__(127);

var _values2 = _interopRequireDefault(_values);

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _baseStore = __webpack_require__(77);

var _baseStore2 = _interopRequireDefault(_baseStore);

var _adActions = __webpack_require__(50);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _console = __webpack_require__(11);

var _object = __webpack_require__(12);

var _routerActions = __webpack_require__(208);

var _browsiActions = __webpack_require__(207);

var _string = __webpack_require__(47);

var _userToolbarActions = __webpack_require__(76);

var _analyticsActions = __webpack_require__(31);

var _pageDataObject = __webpack_require__(5);

var _socialButtonsActions = __webpack_require__(140);

var _fresh8Actions = __webpack_require__(135);

var _fantasyActionTypes = __webpack_require__(108);

var _socialBarActionTypes = __webpack_require__(98);

var _facebookBotActionTypes = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAnalyticsStore = _window.queryString.debugAnalyticsStore; /* eslint semi:0 */

var ANALYTICS_ACTION_TYPES = [].concat((0, _toConsumableArray3.default)((0, _values2.default)(_analyticsActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_socialButtonsActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_adActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_userToolbarActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_browsiActions.BROWSI_ACTIONS)), [_fresh8Actions.actions.FRESH8_ACTION_TYPES.DISPLAY_POPUP, _routerActions.TYPES.ROUTE_CHANGED, _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS.DISPLAY, _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS.SEND_VOTE, _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT.LOAD_MORE, _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT.GET_TOURNAMENTS_FEED, _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT.SELECT_TOURNAMENT, _facebookBotActionTypes.FACEBOOK_BOT_ACTION_TYPES.GO_TO_MESSENGER_BOT]);

var HEART_BEAT_PERIOD = 30e3; // half a minute
var HEART_BEAT_BLACK_LIST_BY_DOMAIN = ['12up'];

function isHeartBeatNotBlackListedForCurrentDomain() {
  return !HEART_BEAT_BLACK_LIST_BY_DOMAIN.includes(_ua.domainFromFqdn);
}

var AnalyticsStore = function (_BaseStore) {
  (0, _inherits3.default)(AnalyticsStore, _BaseStore);

  function AnalyticsStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AnalyticsStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsStore.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsStore)).call(this, options));

    _this.reset();
    _this.listenToBrowserEvents();
    return _this;
  }

  (0, _createClass3.default)(AnalyticsStore, [{
    key: 'listenToBrowserEvents',
    value: function listenToBrowserEvents() {
      window.addEventListener('DOMContentLoaded', _analyticsActions.pageViewed);
    }
  }, {
    key: 'routeAction',
    value: function routeAction(action) {
      if (debugAnalyticsStore) {
        (0, _console.info)('STORE EMIT ACTION: ', action);
      }
      action.analyticsActionName = (0, _string.toCamelCase)(action.type.replace(/:/g, '_'));
      if (this.isAnalyticsAction(action.type)) {
        this.analyticsEvents.push(action); //Note: maybe this is not really needed... probably will be used just for debugging purpose
        this.recordActionInState(action);
        this.emitChange(action);
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      var analyticsEvents = this.state.analyticsEvents || [];
      this.state = (0, _object.makeEmptyObj)();
      this.state.analyticsEvents = analyticsEvents;
      this.generatePageviewUid();
      if ((0, _pageDataObject.getIsPostPage)() && isHeartBeatNotBlackListedForCurrentDomain()) {
        if (this.heartbeatIntervalId) {
          clearInterval(this.heartbeatIntervalId);
        }
        this.heartbeatIntervalId = setInterval(_analyticsActions.heartBeat, HEART_BEAT_PERIOD);
      }
    }
  }, {
    key: 'generatePageviewUid',
    value: function generatePageviewUid() {
      this.state.pageviewUid = (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + Date.now();
      return this.state.pageviewUid;
    }
  }, {
    key: 'isAnalyticsAction',
    value: function isAnalyticsAction(actionType) {
      return ANALYTICS_ACTION_TYPES.includes(actionType);
    }
  }, {
    key: 'emitChange',
    value: function emitChange(action) {
      this.emit(this.constructor.EVENTS.CHANGE, action);
      return this;
    }
  }, {
    key: 'recordActionInState',
    value: function recordActionInState(action) {
      var actionType = (0, _string.toCamelCase)(action.type.split(':').pop());
      this.state[actionType] = (this.state[actionType] || 0) + 1;
    }
  }, {
    key: 'analyticsEvents',
    get: function get() {
      return this.state.analyticsEvents;
    }
  }, {
    key: 'heartbeatsCount',
    get: function get() {
      return this.state.heartBeat || 0;
    }
  }, {
    key: 'pageviewUid',
    get: function get() {
      return this.state.pageviewUid;
    }
  }]);
  return AnalyticsStore;
}(_baseStore2.default);

exports.default = AnalyticsStore;
exports.HEART_BEAT_PERIOD = HEART_BEAT_PERIOD;

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidden(el) {
  return el.offsetWidth <= 0 && el.offsetHeight <= 0 || el.style.display === 'none';
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidden(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(tabbable);
}

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(227);

__webpack_require__(138);

__webpack_require__(195);

var _headerComponents = __webpack_require__(196);

var _headerComponents2 = _interopRequireDefault(_headerComponents);

var _scheduleHomepageContainer = __webpack_require__(307);

var _scheduleHomepageContainer2 = _interopRequireDefault(_scheduleHomepageContainer);

var _localeCookieInitializer = __webpack_require__(146);

var _localeCookieInitializer2 = _interopRequireDefault(_localeCookieInitializer);

var _analyticsInitializer = __webpack_require__(142);

var _analyticsInitializer2 = _interopRequireDefault(_analyticsInitializer);

var _writersLoginButton = __webpack_require__(693);

var _writersLoginButton2 = _interopRequireDefault(_writersLoginButton);

var _trackAnalyticsClickEvents = __webpack_require__(137);

var _trackAnalyticsClickEvents2 = _interopRequireDefault(_trackAnalyticsClickEvents);

var _adblockDetectorProvider = __webpack_require__(154);

var _adblockDetectorProvider2 = _interopRequireDefault(_adblockDetectorProvider);

var _users = __webpack_require__(818);

var _initGoogleAds = __webpack_require__(210);

var _initGoogleAds2 = _interopRequireDefault(_initGoogleAds);

var _postMetadataContainer = __webpack_require__(296);

var _postMetadataContainer2 = _interopRequireDefault(_postMetadataContainer);

var _common = __webpack_require__(203);

var _initEiExternalScripts = __webpack_require__(211);

var _initTheDuelExternalScripts = __webpack_require__(212);

var _videoAdTag = __webpack_require__(218);

var _viewbilityTracker = __webpack_require__(99);

var _linksGroup = __webpack_require__(224);

var _hypernovaReact = __webpack_require__(191);

var _initBrowsi = __webpack_require__(315);

var _initBrowsi2 = _interopRequireDefault(_initBrowsi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _initGoogleAds2.default)(); /* eslint semi:0 */

(0, _analyticsInitializer2.default)();
(0, _adblockDetectorProvider2.default)();
(0, _initBrowsi2.default)();
(0, _localeCookieInitializer2.default)();
(0, _headerComponents2.default)();
(0, _scheduleHomepageContainer2.default)();
(0, _writersLoginButton2.default)();
(0, _trackAnalyticsClickEvents2.default)();
(0, _users.init)();
(0, _postMetadataContainer2.default)();
(0, _common.initCommonComponents)();
(0, _initEiExternalScripts.initEiExternalScripts)();
(0, _initTheDuelExternalScripts.initTheDuelExternalScripts)();
(0, _videoAdTag.getVideoAdsTag)();
(0, _viewbilityTracker.register)('.pagination-controls');
(0, _viewbilityTracker.register)('.feed-links-container');
(0, _hypernovaReact.renderReact)('LinksGroupContainer', _linksGroup.LinksGroupContainer);

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminActionsList = undefined;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLOCK_NAME = 'admin-actions-list';

var AdminActionsList = exports.AdminActionsList = function AdminActionsList(_ref) {
  var actions = _ref.actions;
  return _react2.default.createElement(
    'ul',
    { className: BLOCK_NAME },
    actions.map(function (action) {
      return _react2.default.createElement(
        'li',
        { key: action.name },
        _react2.default.createElement(
          'button',
          { className: BLOCK_NAME + '__action', onClick: action.onClick },
          action.name
        )
      );
    })
  );
};

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminPanelContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(37);

var _RestrictedArea = __webpack_require__(604);

var _fn = __webpack_require__(15);

var _pageDataObject = __webpack_require__(5);

var _AdminActionsList = __webpack_require__(602);

var _adminActions = __webpack_require__(788);

var mapDispatchToProps = _interopRequireWildcard(_adminActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var redirect = function redirect(url) {
  return window.location.assign(url);
};

var ADMIN_SECTION = 'admin';
var BLOCK_NAME = 'admin-panel';

var AdminPanelContainerComponent = function (_Component) {
  (0, _inherits3.default)(AdminPanelContainerComponent, _Component);

  function AdminPanelContainerComponent() {
    (0, _classCallCheck3.default)(this, AdminPanelContainerComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdminPanelContainerComponent.__proto__ || (0, _getPrototypeOf2.default)(AdminPanelContainerComponent)).call(this));

    _this.impersonate = function () {
      return _this.props.impersonate(_this.state.userId);
    };

    _this.showInAdmin = function () {
      return redirect('/' + ADMIN_SECTION + '/users/' + _this.state.userId);
    };

    _this.makeAdmin = function () {
      return redirect('/' + ADMIN_SECTION + '/make_admin_user?id=' + _this.state.userId);
    };

    _this.unAdmin = function () {
      return redirect('/' + ADMIN_SECTION + '/unadmin_user?id=' + _this.state.userId);
    };

    _this.lastWeek = function () {
      return redirect('/' + ADMIN_SECTION + '/users/' + _this.state.userId + '/weekly_summary?week=last_week');
    };

    _this.liveWeek = function () {
      return redirect('/' + ADMIN_SECTION + '/users/' + _this.state.userId + '/weekly_summary');
    };

    _this.getAdminActions = function () {
      return [{ name: 'impersonate', onClick: _this.impersonate }, { name: 'show in admin panel', onClick: _this.showInAdmin }, { name: 'make admin', onClick: _this.makeAdmin }, { name: 'unadmin', onClick: _this.unAdmin }];
    };

    _this.getWeeklySummaries = function () {
      return [{ name: 'last week', onClick: _this.lastWeek }, { name: 'live week', onClick: _this.liveWeek }];
    };

    _this.state = { userId: (0, _pageDataObject.get)('page.user_id') };
    return _this;
  }

  (0, _createClass3.default)(AdminPanelContainerComponent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _RestrictedArea.RestrictedArea,
        null,
        _react2.default.createElement(
          'section',
          { className: BLOCK_NAME },
          _react2.default.createElement(
            'h2',
            { className: BLOCK_NAME + '__title' },
            'admin actions'
          ),
          _react2.default.createElement(
            'div',
            { className: BLOCK_NAME + '__actions' },
            _react2.default.createElement(_AdminActionsList.AdminActionsList, { actions: this.getAdminActions() }),
            _react2.default.createElement(
              'h4',
              { className: BLOCK_NAME + '__sub-title' },
              'weekly summaries'
            ),
            _react2.default.createElement(_AdminActionsList.AdminActionsList, { actions: this.getWeeklySummaries() })
          )
        )
      );
    }
  }]);
  return AdminPanelContainerComponent;
}(_react.Component);

var AdminPanelContainer = exports.AdminPanelContainer = function AdminPanelContainer(_ref) {
  var name = _ref.name,
      stateKey = _ref.stateKey;
  return {
    name: name,
    stateKey: stateKey,
    component: (0, _reactRedux.connect)(_fn.identity, mapDispatchToProps)(AdminPanelContainerComponent)
  };
};

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestrictedArea = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(60);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(37);

var _currentUser = __webpack_require__(792);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestrictedAreaComponent = function (_Component) {
  (0, _inherits3.default)(RestrictedAreaComponent, _Component);

  function RestrictedAreaComponent() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RestrictedAreaComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RestrictedAreaComponent.__proto__ || (0, _getPrototypeOf2.default)(RestrictedAreaComponent)).call.apply(_ref, [this].concat(args))), _this), _this.isAllowed = function () {
      return (0, _currentUser.isAdmin)(_this.props) || (0, _currentUser.isImpersonating)(_this.props);
    }, _this.render = function () {
      return _this.isAllowed() ? _this.props.children : null;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return RestrictedAreaComponent;
}(_react.Component);

RestrictedAreaComponent.propTypes = {
  children: _propTypes2.default.element.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return state.currentUser;
};

var RestrictedArea = exports.RestrictedArea = (0, _reactRedux.connect)(mapStateToProps)(RestrictedAreaComponent);

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _AdminPanel = __webpack_require__(603);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_NAME = 'adminPanel';
var STATE_KEY = 'adminPanel';

var init = exports.init = function init() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.ADMIN_PANEL, (0, _AdminPanel.AdminPanelContainer)({
    componentName: COMPONENT_NAME,
    stateKey: STATE_KEY
  })));
};

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageBox = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _Modal = __webpack_require__(817);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageBox = exports.MessageBox = function (_Component) {
  (0, _inherits3.default)(MessageBox, _Component);

  function MessageBox(props) {
    (0, _classCallCheck3.default)(this, MessageBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MessageBox.__proto__ || (0, _getPrototypeOf2.default)(MessageBox)).call(this, props));

    _this.handleChange = function (_ref) {
      var value = _ref.target.value;
      return _this.updateMsg(value);
    };

    _this.updateMsg = function (msg) {
      return _this.setState({ message: msg });
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();

      _this.props.handleMessage(_this.state.message);
      _this.props.close();

      _this.updateMsg(null);
    };

    _this.state = { message: null };
    return _this;
  }

  (0, _createClass3.default)(MessageBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          close = _props.close;

      var BLOCK_NAME = 'message-box';

      return _react2.default.createElement(
        _Modal.MmModal,
        { isOpen: isOpen, close: close, contentLabel: 'sendMessage' },
        _react2.default.createElement(
          'form',
          { onSubmit: this.handleSubmit, className: BLOCK_NAME },
          _react2.default.createElement(
            'h1',
            { className: BLOCK_NAME + '__header' },
            (0, _i18nProvider.t)('private_messages.private_message')
          ),
          _react2.default.createElement('textarea', {
            className: BLOCK_NAME + '__message',
            onChange: this.handleChange,
            rows: 3,
            placeholder: (0, _i18nProvider.t)('private_messages.write_message_here')
          }),
          _react2.default.createElement('input', { className: BLOCK_NAME + '__submit', type: 'submit', value: (0, _i18nProvider.t)('settings.submit') })
        )
      );
    }
  }]);
  return MessageBox;
}(_react.Component);

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageUserContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(37);

var _MessageUser = __webpack_require__(427);

var _MessageBox = __webpack_require__(656);

var _pageDataObject = __webpack_require__(5);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageUserContainerComponent = function (_Component) {
  (0, _inherits3.default)(MessageUserContainerComponent, _Component);

  function MessageUserContainerComponent() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MessageUserContainerComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MessageUserContainerComponent.__proto__ || (0, _getPrototypeOf2.default)(MessageUserContainerComponent)).call.apply(_ref, [this].concat(args))), _this), _this.handleMessage = function (msg) {
      return _this.props.sendMessage(msg, _this.getToUserId());
    }, _this.getToUserId = function () {
      return (0, _pageDataObject.get)('page.user_id');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MessageUserContainerComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isMessageBoxOpen,
          close = _props.closeMessageBox;

      var BLOCK_NAME = 'private-message';

      return _react2.default.createElement(
        'div',
        { className: BLOCK_NAME },
        _react2.default.createElement(
          'button',
          { className: BLOCK_NAME + '__open', onClick: this.props.openMessageBox },
          (0, _i18nProvider.t)('common.message')
        ),
        _react2.default.createElement(_MessageBox.MessageBox, { isOpen: isOpen, close: close, handleMessage: this.handleMessage })
      );
    }
  }]);
  return MessageUserContainerComponent;
}(_react.Component);

var MessageUserContainer = exports.MessageUserContainer = function MessageUserContainer(_ref2) {
  var componentName = _ref2.componentName,
      stateKey = _ref2.stateKey;

  var mapStateToProps = function mapStateToProps(state) {
    return state[stateKey];
  };
  var mapDispatchToProps = { closeMessageBox: _MessageUser.closeMessageBox, openMessageBox: _MessageUser.openMessageBox, sendMessage: _MessageUser.sendMessage };

  return {
    name: componentName,
    stateKey: stateKey,
    component: (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MessageUserContainerComponent)
  };
};

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _MessageUser = __webpack_require__(657);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_NAME = 'messageUser';
var STATE_KEY = 'messageUser';

var init = exports.init = function init() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.MESSAGE_USER, (0, _MessageUser.MessageUserContainer)({
    componentName: COMPONENT_NAME,
    stateKey: STATE_KEY
  })));
};

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mountWritersLoginButton;

var _dom = __webpack_require__(13);

var _userToolbarActions = __webpack_require__(76);

var _AppDispatcher = __webpack_require__(55);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _preRenderedSelectorsConfig = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function redirectIfExistingUser(redirectUrl, _ref) {
  var type = _ref.type;

  if (type === _userToolbarActions.TYPES.EXISTING_USER_AUTHENTICATED) {
    window.location = redirectUrl;
  }
}

function loginButtonOnClick(e) {
  if (!_userStore2.default.state.loggedIn) {
    e.preventDefault();
    _AppDispatcher.appDispatcher.register(redirectIfExistingUser.bind(0, e.target.href));
    (0, _userToolbarActions.fbLogin)();
  }
}

function mountWritersLoginButton() {
  var writersLoginButton = (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.WRITERS_ARTICLE_BUTTON);
  if (writersLoginButton) {
    writersLoginButton.addEventListener('click', loginButtonOnClick);
  }
}

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stat = undefined;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _humanFormat = __webpack_require__(280);

var _humanFormat2 = _interopRequireDefault(_humanFormat);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUMBERS_AFTER_FLOATING_POINT = 0;

var formatNumber = function formatNumber(number) {
  return (0, _humanFormat2.default)(Number(number), { decimals: NUMBERS_AFTER_FLOATING_POINT });
};

var BLOCK_NAME = 'stat';
var Stat = exports.Stat = function Stat(_ref) {
  var amount = _ref.amount,
      name = _ref.name;
  return _react2.default.createElement(
    'div',
    { className: BLOCK_NAME },
    _react2.default.createElement(
      'h2',
      { className: BLOCK_NAME + '__amount' },
      formatNumber(amount)
    ),
    (0, _i18nProvider.t)('stat_types.' + name.toLowerCase())
  );
};

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.userStatsContainer = userStatsContainer;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(37);

var _Stats = __webpack_require__(430);

var actions = _interopRequireWildcard(_Stats);

var _Stat = __webpack_require__(698);

var _pageDataObject = __webpack_require__(5);

var _fn = __webpack_require__(15);

var _console = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userStatsContainerComponent = function (_Component) {
  (0, _inherits3.default)(userStatsContainerComponent, _Component);

  function userStatsContainerComponent() {
    (0, _classCallCheck3.default)(this, userStatsContainerComponent);
    return (0, _possibleConstructorReturn3.default)(this, (userStatsContainerComponent.__proto__ || (0, _getPrototypeOf2.default)(userStatsContainerComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(userStatsContainerComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      var userId = this.getUserId();
      if (!userId) {
        (0, _console.warn)('UserId isn\'t in the PDO! (unable to fetch DATA for user-stats-component');
      }

      this.props.fetchUserStats(userId);
    }
  }, {
    key: 'getUserId',
    value: function getUserId() {
      return (0, _pageDataObject.get)('page.user_id');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$userStats = this.props.userStats,
          postCreate = _props$userStats.postCreate,
          readsGot = _props$userStats.readsGot;


      return _react2.default.createElement(
        'section',
        { className: 'user-stats' },
        _react2.default.createElement(_Stat.Stat, { name: 'Articles', amount: postCreate }),
        _react2.default.createElement(_Stat.Stat, { name: 'Reads', amount: readsGot })
      );
    }
  }]);
  return userStatsContainerComponent;
}(_react.Component);

function userStatsContainer(_ref) {
  var componentName = _ref.componentName,
      stateKey = _ref.stateKey;

  return {
    name: componentName,
    stateKey: stateKey,
    component: (0, _reactRedux.connect)(_fn.identity, actions)(userStatsContainerComponent)
  };
}

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _Stats = __webpack_require__(699);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_NAME = 'userStats';
var STATE_KEY = 'userStats';

var init = exports.init = function init() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.USER_STATS, (0, _Stats.userStatsContainer)({
    componentName: COMPONENT_NAME,
    stateKey: STATE_KEY
  })));
};

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserProxy = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _fetch = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserProxy = exports.UserProxy = function UserProxy() {
  (0, _classCallCheck3.default)(this, UserProxy);

  this.impersonate = function (to) {
    return (0, _fetch.getJsonOrError)('/admin/impersonate?id=' + to, { credentials: 'include' });
  };
};

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.impersonate = undefined;

var _user = __webpack_require__(787);

var _currentUser = __webpack_require__(317);

var impersonate = exports.impersonate = function impersonate(to) {
  return function (dispatch) {
    var proxy = new _user.UserProxy();

    return proxy.impersonate(to).then(function (_ref) {
      var user = _ref.data;

      user.authenticated = true;
      user.authenticatedAt = Date.now();
      (0, _currentUser.update)(user);
    });
  };
};

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isAdmin = exports.isAdmin = function isAdmin(state) {
  return state.admin || false;
};

var isImpersonating = exports.isImpersonating = function isImpersonating(state) {
  return state.impersonatingId !== null && state.id !== state.impersonatingId;
};

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MmModal = undefined;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(1253);

var _reactModal2 = _interopRequireDefault(_reactModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = 'nm-modal';
var afterOpen = 'after-open';
var beforeClose = 'before-close';
var contentBase = base + '__content';
var overlayBase = base + '__overlay';

var styleGenerator = function styleGenerator(baseClass) {
  return {
    base: baseClass,
    afterOpen: baseClass + '--' + afterOpen,
    beforeClose: baseClass + '--' + beforeClose
  };
};

var MmModal = exports.MmModal = function MmModal(_ref) {
  var isOpen = _ref.isOpen,
      close = _ref.close,
      contentLabel = _ref.contentLabel,
      children = _ref.children;
  return _react2.default.createElement(
    _reactModal2.default,
    {
      isOpen: isOpen,
      onRequestClose: close,
      contentLabel: contentLabel,
      className: styleGenerator(contentBase),
      overlayClassName: styleGenerator(overlayBase)
    },
    _react2.default.createElement(
      'button',
      { className: base + '__close', onClick: close },
      'X'
    ),
    children
  );
};

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _user_stats = __webpack_require__(700);

var _admin_panel = __webpack_require__(605);

var _message_user = __webpack_require__(658);

var init = exports.init = function init() {
  (0, _user_stats.init)();
  (0, _admin_panel.init)();
  (0, _message_user.init)();
};

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONTI_PREROLL_AD_TYPE_PREFIX = undefined;

var _map = __webpack_require__(225);

var _map2 = _interopRequireDefault(_map);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.getVideoAdTargeting = getVideoAdTargeting;
exports.getVideoAdServerUrl = getVideoAdServerUrl;
exports.getVideoTag = getVideoTag;
exports.default = setPageTargeting;

var _array = __webpack_require__(101);

var _object = __webpack_require__(12);

var _window = __webpack_require__(8);

var _fn = __webpack_require__(15);

var _pageContext = __webpack_require__(61);

var _userStore = __webpack_require__(38);

var _ua = __webpack_require__(10);

var _i18nProvider = __webpack_require__(18);

var _adsConfig = __webpack_require__(27);

var _console = __webpack_require__(11);

var _geolocationProvider = __webpack_require__(44);

var _pageDataObject = __webpack_require__(5);

var _useridentifierTracker = __webpack_require__(136);

var _trafficAnalyzerService = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CUSTOM_CRITERIA_PREFIX = _adsConfig.ADS_QUERYSTRING_OVERRIDE_PREFIXES.CUSTOM_CRITERIA;
var DEBUG_CC = _window.queryString.adsDebugCc;

var getCcWithQsOverride = _window.getPossiblyOverriddenPropByQsWithPrefix.part(CUSTOM_CRITERIA_PREFIX);
var DEBUG_CC_SPORTS_TYPES = _window.queryString.adsDebugSportsTypes;
var SPORTS_TYPE_FOOTBALL = 'Soccer';
var SPORTS_TYPE_AMERICAN = 'American';
var SPORTS_TYPE_NEWS = 'News';
var SPORTS_TYPE_DEFAULT = SPORTS_TYPE_FOOTBALL;
var SPORTS_TYPE_BY_DOMAIN = {
  '12up': SPORTS_TYPE_AMERICAN,
  pluralist: SPORTS_TYPE_NEWS
};
var MONTI_PREROLL_AD_TYPE_PREFIX = exports.MONTI_PREROLL_AD_TYPE_PREFIX = 'preroll';
var MONTI_MIDROLL_AD_TYPE_PREFIX = 'midroll';
var MONTI_FIRST_PREROLLS_AD_TYPES = ['preroll0', 'preroll1'];

var affiliateId = (0, _pageContext.getInfluencerId)() || '0';

function dfpTargetingValueToString(value) {
  if ((0, _array.isArray)(value)) {
    return value;
  }
  return value.toString();
}

function debugGroup(groupName) {
  DEBUG_CC && (0, _console.groupCollapsed)('Custom Criteria: ' + groupName + ' ads');
}

function debugGroupEnd() {
  DEBUG_CC && (0, _console.groupEnd)();
}

function setTargetingViaTargetingFn(setTargetingFn, key, value) {
  DEBUG_CC && (0, _console.info)('%c[CC] %s:', 'font-style: italic; color: green;', key, value);
  (0, _fn.makeSafeFn)(setTargetingFn).invoke(key, value);
}

function setCustomCriteria(setTargetingFn, customCriteriaValue, customCriteriaName) {
  var possiblyOverridenCcValue = getCcWithQsOverride(customCriteriaName, customCriteriaValue);
  if (possiblyOverridenCcValue) {
    setTargetingViaTargetingFn(setTargetingFn, customCriteriaName, possiblyOverridenCcValue);
  }
  return setTargetingFn;
}

function addCustomCriteria(setTargetingFn, additionalCustomCriteriaKey) {
  return setCustomCriteria(setTargetingFn, undefined, additionalCustomCriteriaKey);
}

var removeCcPrefix = _window.unprefixQsProperty.part(CUSTOM_CRITERIA_PREFIX);

function isUnknownCustomCriteria(qsKey, index, allQsKeys) {
  // this function has to be bound to customCriteriaMap to work
  return qsKey.startsWith(CUSTOM_CRITERIA_PREFIX) && !(removeCcPrefix(qsKey) in this);
}

var DEFAULT_ENV = 'production';

function getAdditionalCustomCriteriaKeys(customCriteriaMap) {
  return (0, _keys2.default)(_window.queryString).filter(isUnknownCustomCriteria, customCriteriaMap).map(removeCcPrefix);
}

function getLocaleNameForDfp() {
  return (0, _i18nProvider.getShortLocale)().toUpperCase();
}

var countryCode = _geolocationProvider.NO_LOCATION;

function setCurrentCountryCode(countryCodeResult) {
  countryCode = countryCodeResult;
}

(0, _geolocationProvider.getCountryCode)().then(setCurrentCountryCode).catch(_fn.noop);

function getCustomCriteriaMapFromQueryString(qs) {
  /* eslint-disable camelcase */
  var utmMedium = qs.utm_medium,
      utmSource = qs.utm_source,
      utmCampaign = qs.utm_campaign,
      partnerId = qs.partnerId;
  // eslint-enable

  return {
    affiliateId: affiliateId,
    partnerId: partnerId,
    utmMedium: utmMedium,
    utmSource: utmSource,
    utmCampaign: utmCampaign
  };
}

function getSportsTypesByDomain(domain) {
  var singleSportsType = SPORTS_TYPE_BY_DOMAIN[domain] || SPORTS_TYPE_DEFAULT;
  DEBUG_CC_SPORTS_TYPES && (0, _console.info)('[CC]\ncurrent domain: %s,\nsports-type: %s', domain, singleSportsType);
  return [singleSportsType];
}

function getPromotedMediaCc() {
  return (0, _pageDataObject.get)('post.title', '').includes('VIDEO') ? 'video' : null;
}

function isSkinEligible() {
  return window.innerWidth > 321 ? true : false;
}

function getBaseCustomCriteriaMap() {
  var mainLevels = _pageDataObject.ads.hierarchyLevels.mainLevels;

  var baseCc = {
    // FIXME: not just football any longer!
    sportsTypes: getSportsTypesByDomain((0, _ua.domainFromFqdn)()),
    language: getLocaleNameForDfp(),
    platform: (0, _ua.getPlatform)(),
    articleId: (0, _pageDataObject.get)('post.id'),
    articleTemplate: (0, _pageDataObject.get)('post.template'),
    env: (0, _pageDataObject.get)('config.env', DEFAULT_ENV),
    categories: (0, _pageDataObject.get)('post.categories'),
    viewportOrientation: _ua.viewport.orientation,
    adUnitPath: mainLevels,
    countryCode: countryCode,
    markupFormat: 'web',
    promotedMedia: getPromotedMediaCc(),
    articleTeams: (0, _pageDataObject.get)('post.content_tags'),
    experimentId: undefined !== window.experimentId ? window.experimentId : '',
    format: _ua.path.isSyndication ? 'synd' : '',
    syndicationPartnerId: _ua.path.isSyndication ? (0, _pageContext.getSyndicationPartnerId)() : '',
    userIdentifier: (0, _useridentifierTracker.trackUserIdentifier)(),
    skinEligible: isSkinEligible()
    // TODOS:
    // contentProvider: 'ESPN'
    // sizes: requested slot sizes ['970x250', '300x600', ]
    // screenSize: viewport breakpoint
  };
  return (0, _extends3.default)({}, baseCc, getCustomCriteriaMapFromQueryString(_window.queryString), mainLevels);
}

var pageVideoCustomCriteria = new _map2.default();

function addVideoCcKeyValuePairToThis(ccValue, ccKey) {
  var isCcValueStringable = ccValue !== undefined && ccValue.toString instanceof Function;
  var value = isCcValueStringable ? ccValue.toString() : '';
  if (value.length) {
    this.push(ccKey + '=' + value);
  }
  return this;
}

function getVideoAdTargeting() {
  var instanceCustomCriteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _map2.default();

  if (pageVideoCustomCriteria.size === 0) {
    var setTargetingFn = pageVideoCustomCriteria.set.bind(pageVideoCustomCriteria);
    var setVideoCc = setCustomCriteria.bind(null, setTargetingFn);
    debugGroup('video');
    var baseCustomCriteriaMap = getBaseCustomCriteriaMap();
    var trafficInfo = (0, _trafficAnalyzerService.getTrafficInfo)();
    var customCriteriaMap = (0, _extends3.default)({}, baseCustomCriteriaMap, trafficInfo);
    (0, _object.iterate)(customCriteriaMap, setVideoCc);
    var additionalCustomCriteriaKeys = getAdditionalCustomCriteriaKeys(customCriteriaMap);
    var addVideoCc = addCustomCriteria.bind(null, setTargetingFn);
    additionalCustomCriteriaKeys.forEach(addVideoCc);
    debugGroupEnd();
  }
  var videoCustomCriteria = [];
  pageVideoCustomCriteria.forEach(addVideoCcKeyValuePairToThis, videoCustomCriteria);
  instanceCustomCriteria.forEach(addVideoCcKeyValuePairToThis, videoCustomCriteria);

  var videoCustomCriteriaMap = {};
  videoCustomCriteria.forEach(function (cust_param) {
    var arr = cust_param.split('=');
    videoCustomCriteriaMap[arr[0]] = arr[1];
  });
  return videoCustomCriteriaMap;
}

function adTypeParam(adType) {
  if (adType && adType.startsWith(MONTI_PREROLL_AD_TYPE_PREFIX)) {
    return 'mm_preroll=' + adType.substr(adType.indexOf(MONTI_PREROLL_AD_TYPE_PREFIX) + MONTI_PREROLL_AD_TYPE_PREFIX.length, adType.length);
  } else if (adType && adType.startsWith(MONTI_MIDROLL_AD_TYPE_PREFIX)) {
    return 'mm_midroll=' + adType.substr(adType.indexOf(MONTI_MIDROLL_AD_TYPE_PREFIX) + MONTI_MIDROLL_AD_TYPE_PREFIX.length, adType.length);
  } else {
    return '';
  }
}

function getConsent() {
  var consent = localStorage.getItem('consentData');
  var isGdpr = localStorage.getItem('gdprApplies') ? '1' : '0';
  return '&gdpr=' + isGdpr + '&gdpr_consent=' + consent;
}

function video_cust_param(adType) {
  var cust_param = getVideoAdTargeting();
  var str = '';
  for (var c in cust_param) {
    str += c + '=' + cust_param[c] + '&';
  }
  str += adTypeParam(adType) + '&';
  str += getConsent();
  return encodeURIComponent(str);
}

function getAdUnitPath() {
  var hierarchyLevels = _pageDataObject.ads.hierarchyLevels;

  hierarchyLevels.l4 = _adsConfig.AD_FORMATS.Video;
  return hierarchyLevels.toString();
}

function getVideoAdServerUrl(description_url, adType) {
  var referel = window.location.href;
  var parsedDescriptionUrl = description_url || referel;
  return 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360|480x270|400x300|640x480&iu=/' + getAdUnitPath() + '&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&url=' + referel + '&description_url=' + parsedDescriptionUrl + '&correlator=' + Date.now() + '&cust_params=' + video_cust_param(adType);
}

function getVideoTag(description_url, adType) {
  return getVideoAdServerUrl(description_url, adType);
}

function setPageTargeting(gTag) {
  var additionalCcMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var setTargetingFn = function getDfpSetTargeting(ccKey, ccValue) {
    ccValue = dfpTargetingValueToString(ccValue); // eslint-disable-line no-param-reassign
    if (DEBUG_CC === 'verbose') {
      (0, _console.info)('%c[CC] %s:', 'font-style: italic; color: blue;', 'ccKey: \'' + ccKey + '\', ccValue: \'' + ccValue + '\'');
    }
    return gTag.pubads().setTargeting(ccKey, ccValue);
  };

  var setGtagCc = setCustomCriteria.bind(null, setTargetingFn);
  var customCriteriaMap = (0, _extends3.default)({}, getBaseCustomCriteriaMap(), additionalCcMap);
  debugGroup('display');
  (0, _object.iterate)(customCriteriaMap, setGtagCc);
  var additionalCustomCriteriaKeys = getAdditionalCustomCriteriaKeys(customCriteriaMap);
  var addGtagCc = addCustomCriteria.bind(null, setTargetingFn);
  additionalCustomCriteriaKeys.forEach(addGtagCc);
  debugGroupEnd();
  return gTag;
}

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneChildrenWithProps = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.withParentAttributesAsProps = withParentAttributesAsProps;
exports.reactDataset = reactDataset;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _string = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cloneChildrenWithProps = exports.cloneChildrenWithProps = function cloneChildrenWithProps(children, props) {
  return _react2.default.Children.map(children, function (child) {
    return child ? _react2.default.cloneElement(child, props) : false;
  });
};

function withParentAttributesAsProps(Component) {
  return function (_Component) {
    (0, _inherits3.default)(WithParentAttributesAsProps, _Component);

    function WithParentAttributesAsProps() {
      (0, _classCallCheck3.default)(this, WithParentAttributesAsProps);
      return (0, _possibleConstructorReturn3.default)(this, (WithParentAttributesAsProps.__proto__ || (0, _getPrototypeOf2.default)(WithParentAttributesAsProps)).apply(this, arguments));
    }

    (0, _createClass3.default)(WithParentAttributesAsProps, [{
      key: 'componentWillMount',
      value: function componentWillMount() {}
    }, {
      key: 'render',
      value: function render() {
        var props = this.props,
            dataset = this.dataset;

        return _react2.default.createElement(Component, (0, _extends4.default)({}, props, dataset));
      }
    }]);
    return WithParentAttributesAsProps;
  }(Component);
}

function reactDataset(data) {
  return (0, _keys2.default)(data).reduce(function (acc, dataAttr) {
    return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, 'data-' + (0, _string.camelCaseToDashDelimited)(dataAttr), data[dataAttr]));
  }, {});
}

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.fetchReactions = fetchReactions;
exports.fetchPostMetadata = fetchPostMetadata;
exports.sendData = sendData;

var _actionCounterBaseProvider = __webpack_require__(153);

var _mithril = __webpack_require__(34);

var _fetch = __webpack_require__(57);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var POST_METADATA = 'Post_' + (0, _pageDataObject.getPostId)();
var REACTIONS = 'PostReactions_' + (0, _pageDataObject.getPostId)();

var ACTION_COUNTER_KEYS = [REACTIONS, POST_METADATA];

function canSendData() {
  var hostsUrls = (0, _actionCounterBaseProvider.getActionProviderHosts)();
  var reportingTargets = (0, _keys2.default)(hostsUrls).map(function (k) {
    return hostsUrls[k];
  });
  return !reportingTargets.includes(_actionCounterBaseProvider.NO_HOST);
}

function fetchCounterByKey(key) {
  return (0, _actionCounterBaseProvider.fetchCounters)(ACTION_COUNTER_KEYS).then(function (counters) {
    return counters[key];
  });
}

function fetchReactions() {
  return fetchCounterByKey(REACTIONS);
}

function fetchPostMetadata() {
  return fetchCounterByKey(POST_METADATA);
}

function sendData(type) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!canSendData()) {
    return _promise2.default.reject('cannot report to action counter.');
  }

  params.ts = Date.now();

  var _getActionProviderHos = (0, _actionCounterBaseProvider.getActionProviderHosts)(),
      baseUrl = _getActionProviderHos.WRITER_ACTION_PROVIDER;

  var serializedParams = _mithril.route.buildQueryString(params);
  var url = '//' + baseUrl + '/' + type + '?' + serializedParams;
  return (0, _fetch.getResponseText)(url);
}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_BAR_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var SOCIAL_BAR_ACTION_TYPES = exports.SOCIAL_BAR_ACTION_TYPES = (0, _object.namespacedConsts)({
  REACTIONS: {
    GET_VOTES: true,
    SEND_VOTE: true,
    DISPLAY: true,
    HIDE: true,
    SET_REACTIONS_COMPONENT_STATE: true
  }
});

/***/ })

},[1357]);


// WEBPACK FOOTER //
// webpack-feedAndStaticPages.js